import React, { useEffect, useState } from "react";
import { UserSurveySectionResultDto } from "../../models/userSurveySectionResultDto";
import { UserSurveyQuestionResultDto } from "../../models/userSurveyQuestionResultDto";
import { useStore } from "../../stores/store";

interface Props {
  sections: UserSurveySectionResultDto[] | undefined;
  meterPoints: number;
  questionSet: string;
}

export default function PieChart({ sections, meterPoints, questionSet }: Props) {
  const { commonStore } = useStore();
  const [questions, setQuestions] = useState<UserSurveyQuestionResultDto[]>();
  const [questionAngle, setQuestionAngle] = useState<number>(0);

  useEffect(() => {
    if (sections == null || sections.length == undefined || sections.length === 0) {
      setQuestions([]);
      return;
    }

    let quesetionsList: UserSurveyQuestionResultDto[] = [];
    sections.forEach((s) => {
      if (s.questionResults == null || s.questionResults == undefined || s.questionResults.length === 0)
        return;
      s.questionResults.forEach((q) => {
        //This fix has been added to overcome limitation with pie chart control design to have 6 points
        //while cambodia survey has 3 points weight questions
        if (questionSet.toLowerCase() === "kh")
          quesetionsList.push({ ...q, userScore: q.userScore * 2 });
        else quesetionsList.push({ ...q });
      });
    });

    if (quesetionsList && quesetionsList.length > 0) setQuestionAngle(360 / quesetionsList.length);
    setQuestions(quesetionsList);
  }, [sections]);

  const getRotationAngle = (order: number) => {
    let angle = order * questionAngle;
    return `rotate(${angle}deg) translate(0px, 0px)`;
  };

  const getSliceVector = (score: number): string => {
    if (score === 1) return "";
    else if (score === 2)
      return "M241.1,189.6l9.1-45.9c-3.8-0.7-7.8-1.1-11.8-1.2v46.8C239.3,189.4,240.2,189.5,241.1,189.6z";
    else if (score === 3)
      return "M241.1,189.6L255,120c-5.4-1-10.9-1.6-16.5-1.6v71C239.3,189.4,240.2,189.5,241.1,189.6z";
    else if (score === 4)
      return "M241.1,189.6l18.3-92.2c-6.8-1.3-13.8-2-21-2v94C239.3,189.4,240.2,189.5,241.1,189.6z";
    else if (score === 5)
      return "M241.1,189.6l23.1-116.1c-8.3-1.6-17-2.5-25.8-2.5v118.3C239.3,189.4,240.2,189.5,241.1,189.6z";
    else if (score === 6)
      return "M268.8,50.5c-10-1.9-20.2-2.9-30.4-3v141.8c0.9,0,1.8,0.1,2.7,0.3L268.8,50.5z";
    else return "";
  };

  const getAreaColor = (questionId: number): string => {
    let area = findQuestionArea(questionId);
    switch (area) {
      case 0:
        return "#EF7E2B";
      case 1:
        return "#299947";
      case 2:
        return "#3F85C6";
      case 3:
        return "#1DA2A3";
      case 4:
        return "#623785";
      case 5:
        return "#D3375A";
    }
    return "";
  };

  const getLegendColor = (area: number): string => {
    switch (area) {
      case 0:
        return "#EF7E2B";
      case 1:
        return "#299947";
      case 2:
        return "#3F85C6";
      case 3:
        return "#1DA2A3";
      case 4:
        return "#623785";
      case 5:
        return "#D3375A";
    }
    return "";
  };

  const findQuestionArea = (questionId: number): number => {
    let area: number = 0;
    if (sections == null) return 0;
    sections.forEach((s, sectionIndex) => {
      if (s.questionResults == null || s.questionResults == undefined) return;
      s.questionResults.forEach((q) => {
        if (q.questionId === questionId) area = sectionIndex;
      });
    });
    return area;
  };

  return (
    <>
      <div
        className="pie-chart"
        style={{ display: "grid", justifyContent: "center", alignContent: "center" }}
      >
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 450 405"
          style={{ width: "450px", height: "470px" }}
        >
          <pattern
            x="48.7"
            y="14.5"
            width="25.8"
            height="25.8"
            patternUnits="userSpaceOnUse"
            id="New_Pattern_Swatch_2"
            viewBox="0 -25.8 25.8 25.8"
          >
            <g>
              <rect style={{ fill: "none" }} y="-25.8" className="st0" width="25.8" height="25.8" />
              <rect
                x="0"
                y="-25.8"
                style={{ fill: "#D3375A" }}
                className="st1"
                width="25.8"
                height="25.8"
              />
            </g>
          </pattern>
          <pattern
            x="48.7"
            y="14.5"
            width="25.5"
            height="25.5"
            patternUnits="userSpaceOnUse"
            id="New_Pattern_Swatch_3"
            viewBox="0 -25.5 25.5 25.5"
          >
            <g>
              <rect style={{ fill: "none" }} y="-25.5" className="st0" width="25.5" height="25.5" />
              <rect y="-25.5" style={{ fill: "#EF7E2B" }} className="st2" width="25.5" height="25.5" />
            </g>
          </pattern>
          <pattern
            x="48.7"
            y="14.5"
            width="25.7"
            height="25.7"
            patternUnits="userSpaceOnUse"
            id="New_Pattern_Swatch_4"
            viewBox="0 -25.7 25.7 25.7"
          >
            <g>
              <rect
                style={{ fill: "none" }}
                x="0"
                y="-25.7"
                className="st0"
                width="25.7"
                height="25.7"
              />
              <rect
                x="0"
                y="-25.7"
                style={{ fill: "#299947" }}
                className="st3"
                width="25.7"
                height="25.7"
              />
            </g>
          </pattern>
          <pattern
            x="48.7"
            y="14.5"
            width="25.5"
            height="25.5"
            patternUnits="userSpaceOnUse"
            id="New_Pattern_Swatch_5"
            viewBox="0 -25.5 25.5 25.5"
          >
            <g>
              <rect style={{ fill: "none" }} y="-25.5" className="st0" width="25.5" height="25.5" />
              <rect y="-25.5" style={{ fill: "#3F85C6" }} className="st4" width="25.5" height="25.5" />
            </g>
          </pattern>
          <pattern
            x="48.7"
            y="14.5"
            width="26.2"
            height="26.2"
            patternUnits="userSpaceOnUse"
            id="New_Pattern_Swatch_6"
            viewBox="0 -26.2 26.2 26.2"
          >
            <g>
              <rect style={{ fill: "none" }} y="-26.2" className="st0" width="26.2" height="26.2" />
              <rect
                x="0"
                y="-26.2"
                style={{ fill: "#1DA2A3" }}
                className="st5"
                width="26.2"
                height="26.2"
              />
            </g>
          </pattern>
          <pattern
            x="48.7"
            y="14.5"
            width="24.8"
            height="24.8"
            patternUnits="userSpaceOnUse"
            id="New_Pattern_Swatch_7"
            viewBox="0 -24.8 24.8 24.8"
          >
            <g>
              <rect
                style={{ fill: "none" }}
                x="0"
                y="-24.8"
                className="st0"
                width="24.8"
                height="24.8"
              />
              <rect
                x="0"
                y="-24.8"
                style={{ fill: "#623785" }}
                className="st6"
                width="24.8"
                height="24.8"
              />
            </g>
          </pattern>
          <g id="Border">
            <circle style={{ fill: "#FFFFFF" }} className="st7" cx="238.2" cy="205.7" r="184.7" />
            <g>
              <path
                style={{ fill: "#EF7E2B" }}
                className="st2"
                d="M421.9,187.6c-0.6-6-1.5-12-2.7-17.9s-2.6-11.8-4.4-17.6c-1.8-5.8-3.8-11.5-6.1-17.1
			c-2.3-5.6-4.9-11.1-7.7-16.4c-2.8-5.3-6-10.5-9.3-15.5c-3.4-5-7-9.9-10.8-14.6c-3.8-4.7-7.9-9.2-12.2-13.4
			c-4.3-4.3-8.8-8.3-13.4-12.2s-9.5-7.4-14.6-10.8s-10.2-6.5-15.5-9.3s-10.8-5.4-16.4-7.7c-5.6-2.3-11.3-4.4-17.1-6.1
			c-5.8-1.8-11.7-3.2-17.6-4.4s-11.9-2.1-17.9-2.7c-6-0.6-12.1-0.9-18.1-0.9v20c91.1,0,165,73.7,165.3,164.7c0,0.2,0,0.4,0,0.6
			c0,10.8-1.1,21.4-3,31.7l18.8,3.7c1.2-5.9,2.1-11.9,2.7-17.9c0.6-6,0.9-12.1,0.9-18.1S422.5,193.6,421.9,187.6z"
              />
              <path
                style={{ fill: "#D3375A" }}
                className="st1"
                d="M220.1,21.9c-6,0.6-12,1.5-17.9,2.7s-11.8,2.6-17.6,4.4c-5.8,1.8-11.5,3.8-17.1,6.1
			c-5.6,2.3-11.1,4.9-16.4,7.7c-5.3,2.8-10.5,6-15.5,9.3s-9.9,7-14.6,10.8s-9.2,7.9-13.4,12.2c-4.3,4.3-8.3,8.8-12.2,13.4
			c-3.8,4.7-7.4,9.5-10.8,14.6c-3.4,5-6.5,10.2-9.3,15.5c-2.8,5.3-5.4,10.8-7.7,16.4l18.1,7.5c21-50.1,65.9-87.6,120.4-98.4
			c10.4-2,21.1-3.1,32.1-3.1V21C232.1,21,226.1,21.3,220.1,21.9z"
              />
              <path
                style={{ fill: "#623785" }}
                className="st6"
                d="M76.1,173.5c2.2-10.7,5.4-21.1,9.5-31L67.6,135c-2.3,5.6-4.4,11.3-6.1,17.1c-1.8,5.8-3.2,11.7-4.4,17.6
			s-2.1,11.9-2.7,17.9c-0.6,6-0.9,12.1-0.9,18.1s0.3,12.1,0.9,18.1c0.6,6,1.5,12,2.7,17.9s2.6,11.8,4.4,17.6
			c1.8,5.8,3.8,11.5,6.1,17.1l17.6-7.3c-7.9-19.3-12.3-40.5-12.3-62.7C72.9,195.1,74,184.1,76.1,173.5z"
              />
              <path
                style={{ fill: "#1DA2A3" }}
                className="st5"
                d="M100.4,297.7c-6-9-11.1-18.6-15.2-28.7l-17.6,7.3c2.3,5.6,4.9,11.1,7.7,16.4c2.8,5.3,6,10.5,9.3,15.5
			c3.4,5,7,9.9,10.8,14.6c3.8,4.7,7.9,9.2,12.2,13.4c4.3,4.3,8.8,8.3,13.4,12.2s9.5,7.4,14.6,10.8l10.5-15.7
			C128,331.4,112.5,315.8,100.4,297.7z"
              />
              <path
                style={{ fill: "#3F85C6" }}
                className="st4"
                d="M301.7,359c-19.5,8.1-41,12.6-63.5,12.6s-43.9-4.5-63.5-12.6c-10.1-4.2-19.7-9.4-28.6-15.4l-10.5,15.7
			c5,3.4,10.2,6.5,15.5,9.3c5.3,2.8,10.8,5.4,16.4,7.7c5.6,2.3,11.3,4.4,17.1,6.1c5.8,1.8,11.7,3.2,17.6,4.4
			c5.9,1.2,11.9,2.1,17.9,2.7c6,0.6,12.1,0.9,18.1,0.9c6,0,12.1-0.3,18.1-0.9c6-0.6,12-1.5,17.9-2.7c5.9-1.2,11.8-2.6,17.6-4.4
			c5.8-1.8,11.5-3.8,17.1-6.1L301.7,359z"
              />
              <path
                style={{ fill: "#299947" }}
                className="st3"
                d="M400.4,238c-8.5,43.9-34.4,81.5-70.1,105.6c-9,6-18.5,11.2-28.6,15.4l7.2,17.3c5.6-2.3,11.1-4.9,16.4-7.7
			s10.5-6,15.5-9.3s9.9-7,14.6-10.8s9.2-7.9,13.4-12.2c4.3-4.3,8.3-8.8,12.2-13.4s7.4-9.5,10.8-14.6c3.4-5,6.5-10.2,9.3-15.5
			c2.8-5.3,5.4-10.8,7.7-16.4c2.3-5.6,4.4-11.3,6.1-17.1c1.8-5.8,3.2-11.7,4.4-17.6L400.4,238z"
              />
            </g>
          </g>
          {questions &&
            questions.map((question, index) => (
              <g
                key={question.questionId}
                id={`Score${question.userScore}`}
                style={{ transform: getRotationAngle(index), transformOrigin: "53% 51%" }}
              >
                <g>
                  <path
                    style={{ fill: getAreaColor(question.questionId) }}
                    className="st2"
                    d={getSliceVector(question.userScore)}
                  />
                </g>
              </g>
            ))}

          <g id="Circles">
            <g id="Circle7">
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M105.9,117.6c-0.4,0.6-0.7,1.1-1.1,1.7l0.4,0.3c0.4-0.6,0.7-1.1,1.1-1.7L105.9,117.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M108.2,114.3c-0.4,0.5-0.8,1.1-1.1,1.6l0.4,0.3c0.4-0.5,0.8-1.1,1.1-1.6L108.2,114.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M105.9,295c0.4,0.6,0.7,1.1,1.1,1.7l0.4-0.3c-0.4-0.5-0.8-1.1-1.1-1.6L105.9,295z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M103.7,291.6c0.4,0.6,0.7,1.1,1.1,1.7l0.4-0.3c-0.4-0.6-0.7-1.1-1.1-1.7L103.7,291.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M101.6,288.2c0.3,0.6,0.7,1.1,1,1.7l0.4-0.3c-0.3-0.6-0.7-1.1-1-1.7L101.6,288.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M97.6,281.3c0.3,0.6,0.6,1.2,1,1.8l0.4-0.2c-0.3-0.6-0.6-1.2-0.9-1.7L97.6,281.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M99.6,284.8c0.3,0.6,0.7,1.2,1,1.7l0.4-0.3c-0.3-0.6-0.7-1.1-1-1.7L99.6,284.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M110.5,111.1c-0.4,0.5-0.8,1.1-1.2,1.6l0.4,0.3c0.4-0.5,0.8-1.1,1.2-1.6L110.5,111.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M112.9,304.7c0.4,0.5,0.8,1,1.2,1.6l0.4-0.3c-0.4-0.5-0.8-1-1.2-1.6L112.9,304.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M108.1,298.3c0.4,0.5,0.8,1.1,1.2,1.6l0.4-0.3c-0.4-0.5-0.8-1.1-1.2-1.6L108.1,298.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M115.4,307.8c0.4,0.5,0.9,1,1.3,1.5l0.4-0.3c-0.4-0.5-0.9-1-1.3-1.5L115.4,307.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M115.5,104.8c-0.4,0.5-0.8,1-1.3,1.5l0.4,0.3c0.4-0.5,0.8-1,1.3-1.5L115.5,104.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M95.8,277.8c0.3,0.6,0.6,1.2,0.9,1.8l0.4-0.2c-0.3-0.6-0.6-1.2-0.9-1.8L95.8,277.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M110.5,301.5c0.4,0.5,0.8,1.1,1.2,1.6l0.4-0.3c-0.4-0.5-0.8-1.1-1.2-1.6L110.5,301.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M112.9,107.9c-0.4,0.5-0.8,1.1-1.2,1.6l0.4,0.3c0.4-0.5,0.8-1.1,1.2-1.6L112.9,107.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M85.5,251.8c0.2,0.6,0.4,1.3,0.6,1.9l0.5-0.1c-0.2-0.6-0.4-1.3-0.6-1.9L85.5,251.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M83.4,244.1c0.2,0.6,0.3,1.3,0.5,1.9l0.5-0.1c-0.2-0.6-0.3-1.3-0.5-1.9L83.4,244.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M82.2,236.2l-0.5,0.1c0.1,0.7,0.3,1.3,0.4,2l0.5-0.1C82.5,237.5,82.3,236.8,82.2,236.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M83,240.1l-0.5,0.1c0.1,0.7,0.3,1.3,0.4,2l0.5-0.1C83.3,241.4,83.2,240.7,83,240.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M81.5,232.2l-0.5,0.1c0.1,0.7,0.2,1.3,0.3,2l0.5-0.1C81.7,233.5,81.6,232.9,81.5,232.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M94.1,274.2c0.3,0.6,0.6,1.2,0.9,1.8l0.4-0.2c-0.3-0.6-0.6-1.2-0.9-1.8L94.1,274.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M80,220.4l-0.5,0c0.1,0.7,0.1,1.3,0.2,2l0.5,0C80.2,221.7,80.1,221,80,220.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M80.4,224.3l-0.5,0.1c0.1,0.7,0.2,1.3,0.2,2l0.5-0.1C80.6,225.6,80.5,225,80.4,224.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M80.9,228.3l-0.5,0.1c0.1,0.7,0.2,1.3,0.3,2l0.5-0.1C81.1,229.6,81,228.9,80.9,228.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M90.8,266.9c0.3,0.6,0.5,1.2,0.8,1.8l0.5-0.2c-0.3-0.6-0.5-1.2-0.8-1.8L90.8,266.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M92.4,270.5c0.3,0.6,0.5,1.2,0.8,1.8l0.5-0.2c-0.3-0.6-0.5-1.2-0.8-1.8L92.4,270.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M89.4,263.2c0.2,0.6,0.5,1.2,0.7,1.9l0.5-0.2c-0.2-0.6-0.5-1.2-0.7-1.9L89.4,263.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M84.4,247.9c0.2,0.6,0.4,1.3,0.5,1.9l0.5-0.1c-0.2-0.6-0.4-1.3-0.5-1.9L84.4,247.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M88,259.4c0.2,0.6,0.4,1.3,0.7,1.9l0.5-0.2c-0.2-0.6-0.5-1.2-0.7-1.9L88,259.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M118.1,101.8c-0.4,0.5-0.9,1-1.3,1.5l0.4,0.3c0.4-0.5,0.9-1,1.3-1.5L118.1,101.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M86.7,255.6c0.2,0.6,0.4,1.3,0.6,1.9l0.5-0.2c-0.2-0.6-0.4-1.3-0.6-1.9L86.7,255.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M132.1,325.1c0.5,0.4,1,0.9,1.5,1.3l0.3-0.4c-0.5-0.4-1-0.9-1.5-1.3L132.1,325.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M151.1,339.7c0.6,0.4,1.1,0.7,1.7,1.1l0.3-0.4c-0.6-0.4-1.1-0.7-1.7-1.1L151.1,339.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M147.8,75.2c-0.5,0.4-1.1,0.8-1.6,1.1l0.3,0.4c0.5-0.4,1.1-0.8,1.6-1.1L147.8,75.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M151.1,73c-0.6,0.4-1.1,0.7-1.7,1.1l0.3,0.4c0.6-0.4,1.1-0.7,1.7-1.1L151.1,73z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M147.8,337.4c0.5,0.4,1.1,0.8,1.7,1.1l0.3-0.4c-0.6-0.4-1.1-0.7-1.7-1.1L147.8,337.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M141.3,332.7c0.5,0.4,1.1,0.8,1.6,1.2l0.3-0.4c-0.5-0.4-1.1-0.8-1.6-1.2L141.3,332.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M144.5,77.5c-0.5,0.4-1.1,0.8-1.6,1.2l0.3,0.4c0.5-0.4,1.1-0.8,1.6-1.2L144.5,77.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M144.5,335.1c0.5,0.4,1.1,0.8,1.6,1.2l0.3-0.4c-0.5-0.4-1.1-0.8-1.6-1.2L144.5,335.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M161.4,345.9c0.6,0.3,1.2,0.6,1.8,1l0.2-0.4c-0.6-0.3-1.2-0.6-1.8-1L161.4,345.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M164.9,347.8c0.6,0.3,1.2,0.6,1.8,0.9l0.2-0.4c-0.6-0.3-1.2-0.6-1.8-0.9L164.9,347.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M168.5,349.6c0.6,0.3,1.2,0.6,1.8,0.9l0.2-0.5c-0.6-0.3-1.2-0.6-1.8-0.9L168.5,349.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M154.5,70.8c-0.6,0.4-1.1,0.7-1.7,1.1l0.3,0.4c0.6-0.4,1.1-0.7,1.7-1.1L154.5,70.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M172.2,351.3c0.6,0.3,1.2,0.6,1.8,0.8l0.2-0.5c-0.6-0.3-1.2-0.5-1.8-0.8L172.2,351.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M141.3,79.9c-0.5,0.4-1.1,0.8-1.6,1.2l0.3,0.4c0.5-0.4,1-0.8,1.6-1.2L141.3,79.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M154.5,341.8c0.6,0.4,1.1,0.7,1.7,1l0.3-0.4c-0.6-0.3-1.1-0.7-1.7-1L154.5,341.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M157.9,343.9c0.6,0.3,1.2,0.7,1.7,1l0.2-0.4c-0.6-0.3-1.2-0.7-1.7-1L157.9,343.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M79.7,216.4l-0.5,0c0,0.7,0.1,1.3,0.1,2l0.5,0C79.8,217.7,79.8,217,79.7,216.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M126.3,93c-0.5,0.5-0.9,0.9-1.4,1.4l0.4,0.4c0.5-0.5,0.9-0.9,1.4-1.4L126.3,93z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M129.2,90.2c-0.5,0.5-1,0.9-1.4,1.4l0.3,0.4c0.5-0.5,1-0.9,1.4-1.4L129.2,90.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M123.4,316.7c0.5,0.5,0.9,1,1.4,1.4l0.4-0.4c-0.5-0.5-0.9-0.9-1.4-1.4L123.4,316.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M126.2,319.6c0.5,0.5,1,0.9,1.4,1.4l0.3-0.4c-0.5-0.5-1-0.9-1.4-1.4L126.2,319.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M120.7,98.8c-0.5,0.5-0.9,1-1.3,1.5l0.4,0.3c0.4-0.5,0.9-1,1.3-1.5L120.7,98.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M120.7,313.8c0.5,0.5,0.9,1,1.4,1.5l0.4-0.3c-0.5-0.5-0.9-1-1.4-1.5L120.7,313.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M123.5,95.9c-0.5,0.5-0.9,1-1.4,1.4l0.4,0.3c0.5-0.5,0.9-1,1.4-1.4L123.5,95.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M135.1,327.7c0.5,0.4,1,0.9,1.5,1.3l0.3-0.4c-0.5-0.4-1-0.9-1.5-1.3L135.1,327.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M138.2,330.2c0.5,0.4,1,0.8,1.6,1.2l0.3-0.4c-0.5-0.4-1-0.8-1.6-1.2L138.2,330.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M175.8,352.9c0.6,0.3,1.2,0.5,1.9,0.8l0.2-0.5c-0.6-0.3-1.2-0.5-1.8-0.8L175.8,352.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M138.2,82.4c-0.5,0.4-1,0.8-1.5,1.3L137,84c0.5-0.4,1-0.8,1.5-1.3L138.2,82.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M135.1,84.9c-0.5,0.4-1,0.9-1.5,1.3l0.3,0.4c0.5-0.4,1-0.9,1.5-1.3L135.1,84.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M132.1,87.5c-0.5,0.4-1,0.9-1.5,1.3l0.3,0.4c0.5-0.4,1-0.9,1.5-1.3L132.1,87.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M118,310.8c0.4,0.5,0.9,1,1.3,1.5l0.4-0.3c-0.4-0.5-0.9-1-1.3-1.5L118,310.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M129.1,322.4c0.5,0.5,1,0.9,1.5,1.4l0.3-0.4c-0.5-0.4-1-0.9-1.5-1.4L129.1,322.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M350,93c-0.5-0.5-1-0.9-1.4-1.4l-0.3,0.4c0.5,0.5,1,0.9,1.4,1.4L350,93z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M344.2,87.5c-0.5-0.4-1-0.9-1.5-1.3l-0.3,0.4c0.5,0.4,1,0.9,1.5,1.3L344.2,87.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M352.8,95.8c-0.5-0.5-0.9-1-1.4-1.4l-0.4,0.4c0.5,0.5,0.9,0.9,1.4,1.4L352.8,95.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M363.3,107.9c-0.4-0.5-0.8-1-1.2-1.6l-0.4,0.3c0.4,0.5,0.8,1,1.2,1.6L363.3,107.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M355.6,98.7c-0.5-0.5-0.9-1-1.4-1.5l-0.4,0.3c0.5,0.5,0.9,1,1.4,1.5L355.6,98.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M360.8,104.8c-0.4-0.5-0.9-1-1.3-1.5l-0.4,0.3c0.4,0.5,0.9,1,1.3,1.5L360.8,104.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M358.2,101.7c-0.4-0.5-0.9-1-1.3-1.5l-0.4,0.3c0.4,0.5,0.9,1,1.3,1.5L358.2,101.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M347.1,90.2c-0.5-0.5-1-0.9-1.5-1.4l-0.3,0.4c0.5,0.4,1,0.9,1.5,1.4L347.1,90.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M328.5,75.1c-0.5-0.4-1.1-0.8-1.7-1.1l-0.3,0.4c0.6,0.4,1.1,0.7,1.7,1.1L328.5,75.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M325.1,72.9c-0.6-0.4-1.1-0.7-1.7-1.1l-0.3,0.4c0.6,0.4,1.1,0.7,1.7,1.1L325.1,72.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M183.3,57.3l-0.2-0.5c-0.6,0.2-1.3,0.5-1.9,0.7l0.2,0.5C182.1,57.8,182.7,57.5,183.3,57.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M334.9,79.8c-0.5-0.4-1.1-0.8-1.6-1.2L333,79c0.5,0.4,1.1,0.8,1.6,1.2L334.9,79.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M338.1,82.3c-0.5-0.4-1-0.8-1.6-1.2l-0.3,0.4c0.5,0.4,1,0.8,1.6,1.2L338.1,82.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M341.2,84.9c-0.5-0.4-1-0.9-1.5-1.3l-0.3,0.4c0.5,0.4,1,0.9,1.5,1.3L341.2,84.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M331.7,77.4c-0.5-0.4-1.1-0.8-1.6-1.2l-0.3,0.4c0.5,0.4,1.1,0.8,1.6,1.2L331.7,77.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M179.6,58.7l-0.2-0.5c-0.6,0.2-1.2,0.5-1.9,0.8l0.2,0.5C178.3,59.2,179,59,179.6,58.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M395.9,188.2l0.5-0.1c-0.1-0.7-0.2-1.3-0.2-2l-0.5,0.1C395.7,186.9,395.8,187.5,395.9,188.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M396.3,192.2l0.5,0c-0.1-0.7-0.1-1.3-0.2-2l-0.5,0.1C396.2,190.8,396.2,191.5,396.3,192.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M395.4,184.2l0.5-0.1c-0.1-0.7-0.2-1.3-0.3-2l-0.5,0.1C395.2,182.9,395.3,183.6,395.4,184.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M365.8,111c-0.4-0.5-0.8-1.1-1.2-1.6l-0.4,0.3c0.4,0.5,0.8,1.1,1.2,1.6L365.8,111z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M394.8,180.3l0.5-0.1c-0.1-0.7-0.2-1.3-0.3-2l-0.5,0.1C394.6,179,394.7,179.6,394.8,180.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M396.8,200.1l0.5,0c0-0.7-0.1-1.3-0.1-2l-0.5,0C396.7,198.8,396.8,199.5,396.8,200.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M396.6,196.1l0.5,0c0-0.7-0.1-1.3-0.1-2l-0.5,0C396.5,194.8,396.5,195.5,396.6,196.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M396.9,204.1l0.5,0c0-0.7,0-1.3,0-2l-0.5,0C396.9,202.8,396.9,203.4,396.9,204.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M370.4,117.6c-0.4-0.6-0.7-1.1-1.1-1.6l-0.4,0.3c0.4,0.5,0.8,1.1,1.1,1.6L370.4,117.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M372.6,120.9c-0.4-0.6-0.7-1.1-1.1-1.7l-0.4,0.3c0.4,0.6,0.7,1.1,1.1,1.7L372.6,120.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M368.1,114.3c-0.4-0.5-0.8-1.1-1.2-1.6l-0.4,0.3c0.4,0.5,0.8,1.1,1.2,1.6L368.1,114.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M392.9,168.5c-0.2-0.6-0.3-1.3-0.5-1.9l-0.5,0.1c0.2,0.6,0.3,1.3,0.5,1.9L392.9,168.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M393.3,172.5l0.5-0.1c-0.1-0.7-0.3-1.3-0.4-2l-0.5,0.1C393,171.2,393.1,171.8,393.3,172.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M394.1,176.4l0.5-0.1c-0.1-0.7-0.3-1.3-0.4-2l-0.5,0.1C393.8,175.1,394,175.7,394.1,176.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M391.9,164.6c-0.2-0.6-0.4-1.3-0.5-1.9l-0.5,0.1c0.2,0.6,0.4,1.3,0.5,1.9L391.9,164.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M89.8,149.8l-0.5-0.2c-0.2,0.6-0.5,1.3-0.7,1.9l0.5,0.2C89.3,151,89.5,150.4,89.8,149.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M88.4,153.6l-0.5-0.2c-0.2,0.6-0.4,1.3-0.7,1.9l0.5,0.2C88,154.8,88.2,154.2,88.4,153.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M82.2,176.7l-0.5-0.1c-0.1,0.7-0.2,1.3-0.4,2l0.5,0.1C81.9,178,82.1,177.3,82.2,176.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M83.9,168.9l-0.5-0.1c-0.2,0.6-0.3,1.3-0.5,1.9l0.5,0.1C83.6,170.2,83.7,169.5,83.9,168.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M83,172.8l-0.5-0.1c-0.1,0.7-0.3,1.3-0.4,2l0.5,0.1C82.7,174.1,82.8,173.4,83,172.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M87.1,157.4l-0.5-0.2c-0.2,0.6-0.4,1.3-0.6,1.9l0.5,0.1C86.7,158.6,86.9,158,87.1,157.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M85.9,161.2l-0.5-0.1c-0.2,0.6-0.4,1.3-0.6,1.9l0.5,0.1C85.6,162.4,85.7,161.8,85.9,161.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M84.8,165l-0.5-0.1c-0.2,0.6-0.3,1.3-0.5,1.9l0.5,0.1C84.5,166.3,84.7,165.7,84.8,165z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M81.5,180.6l-0.5-0.1c-0.1,0.7-0.2,1.3-0.3,2l0.5,0.1C81.3,181.9,81.4,181.3,81.5,180.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M79.4,206.3c0-0.6,0-1.3,0-1.9l-0.5,0c0,0.6,0,1.3,0,1.9v0.1h0.5V206.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M80.9,184.5l-0.5-0.1c-0.1,0.7-0.2,1.3-0.3,2l0.5,0.1C80.7,185.9,80.8,185.2,80.9,184.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M79.5,200.4l-0.5,0c0,0.7,0,1.3-0.1,2l0.5,0C79.5,201.8,79.5,201.1,79.5,200.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M79.4,208.4l-0.5,0c0,0.7,0,1.3,0,2l0.5,0C79.5,209.7,79.4,209.1,79.4,208.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M80.4,188.5l-0.5-0.1c-0.1,0.7-0.1,1.3-0.2,2l0.5,0C80.3,189.8,80.3,189.2,80.4,188.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M80,192.5l-0.5,0c-0.1,0.7-0.1,1.3-0.2,2l0.5,0C79.9,193.8,80,193.1,80,192.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M79.7,196.5l-0.5,0c0,0.7-0.1,1.3-0.1,2l0.5,0C79.6,197.8,79.7,197.1,79.7,196.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M172.3,61.9l-0.2-0.5c-0.6,0.3-1.2,0.6-1.8,0.8l0.2,0.5C171.1,62.4,171.7,62.1,172.3,61.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M158.2,69.2l-0.3-0.4c-0.6,0.3-1.1,0.7-1.7,1l0.3,0.4C157,69.9,157.6,69.5,158.2,69.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M102,124.7l-0.4-0.3c-0.3,0.6-0.7,1.1-1,1.7l0.4,0.3C101.3,125.8,101.7,125.2,102,124.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M104.1,121.3l-0.4-0.3c-0.4,0.6-0.7,1.1-1.1,1.7l0.4,0.3C103.4,122.4,103.8,121.8,104.1,121.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M161.6,67.2l-0.2-0.4c-0.6,0.3-1.2,0.6-1.7,1l0.2,0.4C160.5,67.9,161,67.5,161.6,67.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M175.9,60.2l-0.2-0.5c-0.6,0.3-1.2,0.5-1.8,0.8l0.2,0.5C174.7,60.8,175.3,60.5,175.9,60.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M165.1,65.3l-0.2-0.4c-0.6,0.3-1.2,0.6-1.8,0.9l0.2,0.4C163.9,66,164.5,65.6,165.1,65.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M168.7,63.6l-0.2-0.4c-0.6,0.3-1.2,0.6-1.8,0.9l0.2,0.4C167.5,64.1,168.1,63.8,168.7,63.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M92.8,142.4l-0.5-0.2c-0.3,0.6-0.5,1.2-0.8,1.8l0.5,0.2C92.3,143.6,92.5,143,92.8,142.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M79.5,212.4l-0.5,0c0,0.7,0.1,1.3,0.1,2l0.5,0C79.6,213.7,79.6,213.1,79.5,212.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M91.2,146.1l-0.5-0.2c-0.3,0.6-0.5,1.2-0.8,1.9l0.5,0.2C90.7,147.3,91,146.7,91.2,146.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M100,128.1l-0.4-0.2c-0.3,0.6-0.7,1.2-1,1.8l0.4,0.2C99.3,129.3,99.7,128.7,100,128.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M94.5,138.8l-0.5-0.2c-0.3,0.6-0.6,1.2-0.8,1.8l0.5,0.2C93.9,140,94.2,139.4,94.5,138.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M98.1,131.6l-0.4-0.2c-0.3,0.6-0.6,1.2-0.9,1.8l0.4,0.2C97.4,132.8,97.8,132.2,98.1,131.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M96.2,135.2l-0.4-0.2c-0.3,0.6-0.6,1.2-0.9,1.8l0.4,0.2C95.6,136.3,95.9,135.8,96.2,135.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M200.4,51.6l0.1,0.5c0.6-0.2,1.3-0.3,1.9-0.5l-0.1-0.5C201.6,51.3,201,51.4,200.4,51.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M355.2,313.6l0.4,0.3c0.5-0.5,0.9-1,1.3-1.5l-0.4-0.3C356.1,312.6,355.6,313.1,355.2,313.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M352.4,316.5l0.4,0.3c0.5-0.5,0.9-1,1.4-1.4l-0.4-0.3C353.3,315.5,352.9,316,352.4,316.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M357.8,310.6l0.4,0.3c0.4-0.5,0.9-1,1.3-1.5l-0.4-0.3C358.7,309.6,358.3,310.1,357.8,310.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M360.4,307.6l0.4,0.3c0.4-0.5,0.8-1,1.3-1.5l-0.4-0.3C361.2,306.6,360.8,307.1,360.4,307.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M343.8,324.8l0.3,0.4c0.5-0.4,1-0.9,1.5-1.3l-0.3-0.4C344.8,323.9,344.3,324.4,343.8,324.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M375.7,126l-0.4,0.3c0.3,0.6,0.7,1.1,1,1.7l0.4-0.2C376.4,127.2,376,126.6,375.7,126z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M349.6,319.3l0.4,0.4c0.5-0.5,0.9-0.9,1.4-1.4l-0.4-0.4C350.6,318.4,350.1,318.9,349.6,319.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M373.6,122.6l-0.4,0.3c0.3,0.6,0.7,1.1,1,1.7l0.4-0.3C374.3,123.7,374,123.2,373.6,122.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M372.2,291.5l0.4,0.3c0.4-0.6,0.7-1.1,1.1-1.7l-0.4-0.3C372.9,290.3,372.5,290.9,372.2,291.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M340.8,327.4l0.3,0.4c0.5-0.4,1-0.9,1.5-1.3l-0.3-0.4C341.8,326.6,341.3,327,340.8,327.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M374.3,288.1l0.4,0.3c0.3-0.6,0.7-1.1,1-1.7l-0.4-0.3C374.9,286.9,374.6,287.5,374.3,288.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M365.3,301.3l0.4,0.3c0.4-0.5,0.8-1.1,1.2-1.6l-0.4-0.3C366.1,300.2,365.7,300.8,365.3,301.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M362.9,304.5l0.4,0.3c0.4-0.5,0.8-1.1,1.2-1.6l-0.4-0.3C363.7,303.4,363.3,304,362.9,304.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M367.7,298.1l0.4,0.3c0.4-0.5,0.8-1.1,1.1-1.6l-0.4-0.3C368.5,297,368.1,297.5,367.7,298.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M370,294.8l0.4,0.3c0.4-0.6,0.7-1.1,1.1-1.7l-0.4-0.3C370.7,293.7,370.3,294.3,370,294.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M346.7,322.1l0.3,0.4c0.5-0.5,1-0.9,1.5-1.4l-0.3-0.4C347.7,321.2,347.2,321.7,346.7,322.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M304,350.8l0.2,0.5c0.6-0.3,1.2-0.6,1.8-0.8l-0.2-0.5C305.2,350.3,304.6,350.5,304,350.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M311.1,347.3l0.2,0.4c0.6-0.3,1.2-0.6,1.8-0.9l-0.2-0.4C312.3,346.7,311.7,347,311.1,347.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M314.6,345.5l0.2,0.4c0.6-0.3,1.2-0.6,1.7-1l-0.2-0.4C315.8,344.8,315.2,345.1,314.6,345.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M179.5,354.4c0.6,0.2,1.2,0.5,1.9,0.7l0.2-0.5c-0.6-0.2-1.2-0.5-1.9-0.7L179.5,354.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M305.9,62.2l-0.2,0.5c0.6,0.3,1.2,0.6,1.8,0.9l0.2-0.4C307.1,62.7,306.5,62.4,305.9,62.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M307.6,349.1l0.2,0.4c0.6-0.3,1.2-0.6,1.8-0.9l-0.2-0.4C308.7,348.5,308.1,348.8,307.6,349.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M309.5,63.9l-0.2,0.4c0.6,0.3,1.2,0.6,1.8,0.9l0.2-0.4C310.7,64.5,310.1,64.2,309.5,63.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M324.8,339.3l0.3,0.4c0.6-0.4,1.1-0.7,1.7-1.1l-0.3-0.4C326,338.6,325.4,339,324.8,339.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M318.1,343.5l0.3,0.4c0.6-0.3,1.1-0.7,1.7-1l-0.3-0.4C319.2,342.8,318.6,343.2,318.1,343.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M328.2,337.1l0.3,0.4c0.5-0.4,1.1-0.8,1.6-1.1l-0.3-0.4C329.2,336.3,328.7,336.7,328.2,337.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M334.6,332.4l0.3,0.4c0.5-0.4,1.1-0.8,1.6-1.2l-0.3-0.4C335.6,331.6,335.1,332,334.6,332.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M331.4,334.8l0.3,0.4c0.5-0.4,1.1-0.8,1.6-1.2l-0.3-0.4C332.5,334,331.9,334.4,331.4,334.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M337.7,330l0.3,0.4c0.5-0.4,1-0.8,1.5-1.3l-0.3-0.4C338.8,329.1,338.2,329.5,337.7,330z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M320,69.7l-0.3,0.4c0.6,0.3,1.1,0.7,1.7,1l0.3-0.4C321.2,70.4,320.6,70.1,320,69.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M321.5,341.5l0.3,0.4c0.6-0.3,1.1-0.7,1.7-1.1l-0.3-0.4C322.6,340.8,322,341.1,321.5,341.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M316.6,67.7l-0.2,0.4c0.6,0.3,1.2,0.7,1.7,1l0.3-0.4C317.7,68.3,317.2,68,316.6,67.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M394.1,236.1l0.5,0.1c0.1-0.7,0.2-1.3,0.4-2l-0.5-0.1C394.4,234.8,394.2,235.4,394.1,236.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M392.4,243.9l0.5,0.1c0.2-0.6,0.3-1.3,0.5-1.9l-0.5-0.1C392.7,242.6,392.6,243.2,392.4,243.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M393.3,240l0.5,0.1c0.1-0.7,0.3-1.3,0.4-2l-0.5-0.1C393.6,238.7,393.5,239.3,393.3,240z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M391.4,247.7l0.5,0.1c0.2-0.6,0.3-1.3,0.5-1.9l-0.5-0.1C391.8,246.4,391.6,247.1,391.4,247.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M376.3,284.6l0.4,0.2c0.3-0.6,0.7-1.2,1-1.7l-0.4-0.2C376.9,283.5,376.6,284,376.3,284.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M389.2,255.4l0.5,0.2c0.2-0.6,0.4-1.3,0.6-1.9l-0.5-0.1C389.6,254.1,389.4,254.7,389.2,255.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M389,155l-0.5,0.2c0.2,0.6,0.4,1.3,0.6,1.9l0.5-0.2C389.4,156.3,389.2,155.6,389,155z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M390.2,158.8l-0.5,0.1c0.2,0.6,0.4,1.3,0.6,1.9l0.5-0.1C390.6,160.1,390.4,159.5,390.2,158.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M394.8,232.1l0.5,0.1c0.1-0.7,0.2-1.3,0.3-2l-0.5-0.1C395,230.8,394.9,231.5,394.8,232.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M396.9,206.3c0,0.7,0,1.3,0,2l0.5,0c0-0.7,0-1.3,0-2v-0.2h-0.5V206.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M396.6,216.3l0.5,0c0-0.7,0.1-1.3,0.1-2l-0.5,0C396.7,215,396.6,215.6,396.6,216.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M396.8,212.3l0.5,0c0-0.7,0-1.3,0.1-2l-0.5,0C396.8,211,396.8,211.6,396.8,212.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M395.4,228.2l0.5,0.1c0.1-0.7,0.2-1.3,0.3-2l-0.5-0.1C395.6,226.9,395.5,227.5,395.4,228.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M395.9,224.2l0.5,0.1c0.1-0.7,0.1-1.3,0.2-2l-0.5,0C396,222.9,396,223.6,395.9,224.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M396.3,220.3l0.5,0c0.1-0.7,0.1-1.3,0.2-2l-0.5,0C396.4,218.9,396.4,219.6,396.3,220.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M390.4,251.6l0.5,0.1c0.2-0.6,0.4-1.3,0.6-1.9l-0.5-0.1C390.7,250.3,390.5,250.9,390.4,251.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M381.3,136.6l-0.4,0.2c0.3,0.6,0.6,1.2,0.9,1.8l0.5-0.2C381.9,137.8,381.6,137.2,381.3,136.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M380,277.6l0.4,0.2c0.3-0.6,0.6-1.2,0.9-1.8l-0.4-0.2C380.6,276.4,380.3,277,380,277.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M381.8,274l0.5,0.2c0.3-0.6,0.6-1.2,0.8-1.8l-0.5-0.2C382.4,272.8,382.1,273.4,381.8,274z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M383.1,140.2l-0.5,0.2c0.3,0.6,0.5,1.2,0.8,1.8l0.5-0.2C383.6,141.4,383.3,140.8,383.1,140.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M377.7,129.5l-0.4,0.2c0.3,0.6,0.6,1.2,1,1.7l0.4-0.2C378.3,130.6,378,130.1,377.7,129.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M378.2,281.1l0.4,0.2c0.3-0.6,0.6-1.2,0.9-1.8l-0.4-0.2C378.8,279.9,378.5,280.5,378.2,281.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M387.9,259.2l0.5,0.2c0.2-0.6,0.4-1.3,0.7-1.9l-0.5-0.2C388.3,257.9,388.1,258.5,387.9,259.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M379.6,133l-0.4,0.2c0.3,0.6,0.6,1.2,0.9,1.8l0.4-0.2C380.2,134.2,379.9,133.6,379.6,133z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M386.5,262.9l0.5,0.2c0.2-0.6,0.5-1.3,0.7-1.9l-0.5-0.2C387,261.7,386.7,262.3,386.5,262.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M387.6,151.2l-0.5,0.2c0.2,0.6,0.5,1.2,0.7,1.9l0.5-0.2C388.1,152.5,387.8,151.9,387.6,151.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M386.2,147.5l-0.5,0.2c0.2,0.6,0.5,1.2,0.7,1.9l0.5-0.2C386.7,148.7,386.4,148.1,386.2,147.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M383.5,270.3l0.5,0.2c0.3-0.6,0.5-1.2,0.8-1.8l-0.5-0.2C384,269.1,383.7,269.7,383.5,270.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M384.7,143.8l-0.5,0.2c0.3,0.6,0.5,1.2,0.8,1.8l0.5-0.2C385.2,145,384.9,144.4,384.7,143.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M385,266.7l0.5,0.2c0.3-0.6,0.5-1.2,0.8-1.9l-0.5-0.2C385.5,265.4,385.3,266,385,266.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M313.1,65.8l-0.2,0.4c0.6,0.3,1.2,0.6,1.8,1l0.2-0.4C314.2,66.4,313.6,66.1,313.1,65.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M220,48.1l0.1,0.5c0.7-0.1,1.3-0.1,2-0.2l0-0.5C221.4,48,220.7,48,220,48.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M212.1,49.2l0.1,0.5c0.7-0.1,1.3-0.2,2-0.3l-0.1-0.5C213.4,49,212.8,49.1,212.1,49.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M224,47.7l0,0.5c0.7-0.1,1.3-0.1,2-0.2l0-0.5C225.3,47.6,224.7,47.6,224,47.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M214.3,363.8c0.7,0.1,1.3,0.2,2,0.3l0.1-0.5c-0.7-0.1-1.3-0.2-2-0.3L214.3,363.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M218.3,364.3c0.7,0.1,1.3,0.2,2,0.2l0.1-0.5c-0.7-0.1-1.3-0.2-2-0.2L218.3,364.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M226.2,365.1c0.7,0,1.3,0.1,2,0.1l0-0.5c-0.7,0-1.3-0.1-2-0.1L226.2,365.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M216.1,48.6l0.1,0.5c0.7-0.1,1.3-0.2,2-0.3l-0.1-0.5C217.4,48.4,216.7,48.5,216.1,48.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M222.2,364.8c0.7,0.1,1.3,0.1,2,0.2l0-0.5c-0.7-0.1-1.3-0.1-2-0.2L222.2,364.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M238.2,365.1v0.5c0.7,0,1.3,0,2,0l0-0.5C239.5,365,238.9,365.1,238.2,365.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M240,47.6c0.7,0,1.3,0,2,0l0-0.5c-0.7,0-1.3,0-2,0L240,47.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M236,47.6c0.7,0,1.3,0,2,0v-0.5c-0.7,0-1.3,0-2,0L236,47.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M234.2,365.5c0.7,0,1.3,0,2,0l0-0.5c-0.7,0-1.3,0-2,0L234.2,365.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M228,47.4l0,0.5c0.7,0,1.3-0.1,2-0.1l0-0.5C229.3,47.3,228.7,47.4,228,47.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M230.2,365.4c0.7,0,1.3,0.1,2,0.1l0-0.5c-0.7,0-1.3-0.1-2-0.1L230.2,365.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M232,47.2l0,0.5c0.7,0,1.3,0,2-0.1l0-0.5C233.3,47.1,232.7,47.2,232,47.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M188.8,54.9l0.2,0.5c0.6-0.2,1.3-0.4,1.9-0.6l-0.1-0.5C190.1,54.5,189.4,54.7,188.8,54.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M242.2,365l0,0.5c0.7,0,1.3,0,2-0.1l0-0.5C243.5,365,242.9,365,242.2,365z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M302.2,60.5L302,61c0.6,0.3,1.2,0.5,1.8,0.8l0.2-0.5C303.5,61,302.8,60.8,302.2,60.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M192.6,53.7l0.1,0.5c0.6-0.2,1.3-0.4,1.9-0.6l-0.1-0.5C193.9,53.3,193.3,53.5,192.6,53.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M185,56.2l0.2,0.5c0.6-0.2,1.3-0.4,1.9-0.7l-0.2-0.5C186.3,55.7,185.6,55.9,185,56.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M183.3,355.9c0.6,0.2,1.3,0.5,1.9,0.7l0.2-0.5c-0.6-0.2-1.3-0.4-1.9-0.7L183.3,355.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M194.7,359.6c0.6,0.2,1.3,0.4,1.9,0.5l0.1-0.5c-0.6-0.2-1.3-0.4-1.9-0.5L194.7,359.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M187.1,357.2c0.6,0.2,1.3,0.4,1.9,0.6l0.2-0.5c-0.6-0.2-1.3-0.4-1.9-0.6L187.1,357.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M206.4,362.4c0.7,0.1,1.3,0.3,2,0.4l0.1-0.5c-0.7-0.1-1.3-0.3-2-0.4L206.4,362.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M210.3,363.1c0.7,0.1,1.3,0.2,2,0.3l0.1-0.5c-0.7-0.1-1.3-0.2-2-0.3L210.3,363.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M208.2,49.9l0.1,0.5c0.7-0.1,1.3-0.2,2-0.4l-0.1-0.5C209.5,49.6,208.8,49.8,208.2,49.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M196.5,52.6l0.1,0.5c0.6-0.2,1.3-0.3,1.9-0.5l-0.1-0.5C197.8,52.2,197.1,52.4,196.5,52.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M204.3,50.7l0.1,0.5c0.6-0.1,1.3-0.3,2-0.4l-0.1-0.5C205.6,50.4,204.9,50.6,204.3,50.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M202.5,361.5c0.6,0.1,1.3,0.3,2,0.4l0.1-0.5c-0.7-0.1-1.3-0.3-1.9-0.4L202.5,361.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M198.6,360.6c0.6,0.2,1.3,0.3,1.9,0.5l0.1-0.5c-0.6-0.2-1.3-0.3-1.9-0.5L198.6,360.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M190.9,358.4c0.6,0.2,1.3,0.4,1.9,0.6l0.1-0.5c-0.6-0.2-1.3-0.4-1.9-0.6L190.9,358.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M283.3,54.1c0.6,0.2,1.3,0.4,1.9,0.6l0.1-0.5c-0.6-0.2-1.3-0.4-1.9-0.6L283.3,54.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M285.4,357.9l0.1,0.5c0.6-0.2,1.3-0.4,1.9-0.6l-0.2-0.5C286.6,357.5,286,357.7,285.4,357.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M281.5,359.1l0.1,0.5c0.6-0.2,1.3-0.4,1.9-0.6l-0.1-0.5C282.8,358.7,282.2,358.9,281.5,359.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M275.5,52c0.6,0.2,1.3,0.3,1.9,0.5l0.1-0.5c-0.6-0.2-1.3-0.3-1.9-0.5L275.5,52z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M279.4,53c0.6,0.2,1.3,0.3,1.9,0.5l0.1-0.5c-0.6-0.2-1.3-0.4-1.9-0.5L279.4,53z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M287.1,55.3c0.6,0.2,1.3,0.4,1.9,0.6l0.2-0.5c-0.6-0.2-1.3-0.4-1.9-0.6L287.1,55.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M277.7,360.1l0.1,0.5c0.6-0.2,1.3-0.3,1.9-0.5l-0.1-0.5C279,359.8,278.3,359.9,277.7,360.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M298.5,58.9l-0.2,0.5c0.6,0.3,1.2,0.5,1.8,0.8l0.2-0.5C299.8,59.4,299.2,59.2,298.5,58.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M296.6,353.9l0.2,0.5c0.6-0.2,1.2-0.5,1.9-0.7l-0.2-0.5C297.9,353.4,297.3,353.7,296.6,353.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M273.8,361l0.1,0.5c0.7-0.1,1.3-0.3,1.9-0.5l-0.1-0.5C275.1,360.7,274.5,360.9,273.8,361z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M300.3,352.4l0.2,0.5c0.6-0.3,1.2-0.5,1.8-0.8l-0.2-0.5C301.5,351.9,300.9,352.2,300.3,352.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M244,47.7c0.7,0,1.3,0.1,2,0.1l0-0.5c-0.7,0-1.3-0.1-2-0.1L244,47.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M294.8,57.4l-0.2,0.5c0.6,0.2,1.2,0.5,1.9,0.7l0.2-0.5C296.1,57.9,295.4,57.7,294.8,57.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M291,56.1l-0.2,0.5c0.6,0.2,1.3,0.4,1.9,0.7l0.2-0.5C292.3,56.5,291.7,56.3,291,56.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M289.2,356.7l0.2,0.5c0.6-0.2,1.3-0.4,1.9-0.7L291,356C290.4,356.3,289.8,356.5,289.2,356.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M292.9,355.4l0.2,0.5c0.6-0.2,1.3-0.5,1.9-0.7l-0.2-0.5C294.2,354.9,293.5,355.1,292.9,355.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M254.1,364.3l0,0.5c0.7-0.1,1.3-0.1,2-0.2l-0.1-0.5C255.5,364.1,254.8,364.2,254.1,364.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M255.9,48.6c0.7,0.1,1.3,0.2,2,0.2l0.1-0.5c-0.7-0.1-1.3-0.2-2-0.2L255.9,48.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M251.9,48.2c0.7,0.1,1.3,0.1,2,0.2l0-0.5c-0.7-0.1-1.3-0.1-2-0.2L251.9,48.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M258.1,363.8l0.1,0.5c0.7-0.1,1.3-0.2,2-0.3l-0.1-0.5C259.4,363.6,258.8,363.7,258.1,363.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M246.2,364.9l0,0.5c0.7,0,1.3-0.1,2-0.1l0-0.5C247.5,364.8,246.8,364.8,246.2,364.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M248,47.9c0.7,0,1.3,0.1,2,0.1l0-0.5c-0.7,0-1.3-0.1-2-0.1L248,47.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M250.2,364.6l0,0.5c0.7-0.1,1.3-0.1,2-0.2l0-0.5C251.5,364.5,250.8,364.6,250.2,364.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M263.8,49.6c0.7,0.1,1.3,0.2,2,0.3l0.1-0.5c-0.7-0.1-1.3-0.2-2-0.3L263.8,49.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M267.7,50.3c0.7,0.1,1.3,0.3,2,0.4l0.1-0.5c-0.7-0.1-1.3-0.3-2-0.4L267.7,50.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M269.9,361.9l0.1,0.5c0.7-0.1,1.3-0.3,2-0.4l-0.1-0.5C271.2,361.6,270.6,361.7,269.9,361.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M259.9,49c0.7,0.1,1.3,0.2,2,0.3l0.1-0.5c-0.7-0.1-1.3-0.2-2-0.3L259.9,49z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M266,362.6l0.1,0.5c0.7-0.1,1.3-0.2,2-0.4l-0.1-0.5C267.3,362.4,266.6,362.5,266,362.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M262.1,363.3l0.1,0.5c0.7-0.1,1.3-0.2,2-0.3L264,363C263.4,363.1,262.7,363.2,262.1,363.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M271.7,51.1c0.7,0.1,1.3,0.3,1.9,0.4l0.1-0.5c-0.6-0.1-1.3-0.3-2-0.4L271.7,51.1z"
              />
            </g>
            {meterPoints === 6 && (
              <g id="Circle6">
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M154.9,313.2c0.5,0.4,1.1,0.8,1.6,1.2l0.3-0.4c-0.5-0.4-1.1-0.8-1.6-1.2L154.9,313.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M154.9,99.4l0.3,0.4c0.5-0.4,1.1-0.8,1.6-1.2l-0.3-0.4C156,98.6,155.4,99,154.9,99.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M151.7,310.7c0.5,0.4,1,0.8,1.6,1.3l0.3-0.4c-0.5-0.4-1-0.8-1.5-1.3L151.7,310.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M151.8,101.9l0.3,0.4c0.5-0.4,1-0.8,1.5-1.3l-0.3-0.4C152.8,101,152.3,101.5,151.8,101.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M148.7,104.5l0.3,0.4c0.5-0.4,1-0.9,1.5-1.3l-0.3-0.4C149.7,103.6,149.2,104,148.7,104.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M148.7,308.1c0.5,0.4,1,0.9,1.5,1.3l0.3-0.4c-0.5-0.4-1-0.9-1.5-1.3L148.7,308.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M158.1,315.6c0.5,0.4,1.1,0.8,1.6,1.2l0.3-0.4c-0.5-0.4-1.1-0.8-1.6-1.2L158.1,315.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M164.7,320.2c0.6,0.4,1.1,0.7,1.7,1.1l0.3-0.4c-0.6-0.4-1.1-0.7-1.7-1.1L164.7,320.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M161.3,94.6l0.3,0.4c0.5-0.4,1.1-0.8,1.6-1.1l-0.3-0.4C162.4,93.9,161.9,94.3,161.3,94.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M164.7,92.4l0.3,0.4c0.6-0.4,1.1-0.7,1.7-1.1l-0.3-0.4C165.8,91.7,165.2,92.1,164.7,92.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M168.1,322.3c0.6,0.3,1.1,0.7,1.7,1l0.3-0.4c-0.6-0.3-1.1-0.7-1.7-1L168.1,322.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M158.1,97l0.3,0.4c0.5-0.4,1.1-0.8,1.6-1.2l-0.3-0.4C159.2,96.2,158.6,96.6,158.1,97z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M161.3,318c0.6,0.4,1.1,0.8,1.7,1.1l0.3-0.4c-0.6-0.4-1.1-0.7-1.7-1.1L161.3,318z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M140,299.8c0.5,0.5,0.9,1,1.4,1.4l0.4-0.4c-0.5-0.5-0.9-1-1.4-1.4L140,299.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M132.2,121.9l0.4,0.3c0.4-0.5,0.8-1,1.3-1.6l-0.4-0.3C133,120.8,132.6,121.3,132.2,121.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M134.7,293.8c0.4,0.5,0.9,1,1.3,1.5l0.4-0.3c-0.4-0.5-0.9-1-1.3-1.5L134.7,293.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M145.8,107.2l0.3,0.4c0.5-0.5,1-0.9,1.5-1.3l-0.3-0.4C146.7,106.3,146.3,106.7,145.8,107.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M129.7,287.6c0.4,0.5,0.8,1.1,1.2,1.6l0.4-0.3c-0.4-0.5-0.8-1.1-1.2-1.6L129.7,287.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M129.7,125l0.4,0.3c0.4-0.5,0.8-1.1,1.2-1.6l-0.4-0.3C130.5,124,130.1,124.5,129.7,125z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M132.1,290.7c0.4,0.5,0.8,1,1.3,1.6l0.4-0.3c-0.4-0.5-0.8-1-1.3-1.5L132.1,290.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M134.7,118.8l0.4,0.3c0.4-0.5,0.9-1,1.3-1.5l-0.4-0.3C135.6,117.7,135.1,118.3,134.7,118.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M142.9,109.9l0.4,0.4c0.5-0.5,0.9-0.9,1.4-1.4l-0.3-0.4C143.8,109,143.3,109.5,142.9,109.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M137.3,115.7l0.4,0.3c0.4-0.5,0.9-1,1.3-1.5l-0.4-0.3C138.2,114.8,137.8,115.2,137.3,115.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M145.7,305.4c0.5,0.5,1,0.9,1.5,1.4l0.3-0.4c-0.5-0.4-1-0.9-1.5-1.4L145.7,305.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M140.1,112.8l0.4,0.3c0.5-0.5,0.9-1,1.4-1.4l-0.4-0.4C141,111.8,140.5,112.3,140.1,112.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M142.8,302.6c0.5,0.5,1,0.9,1.4,1.4l0.3-0.4c-0.5-0.5-1-0.9-1.4-1.4L142.8,302.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M137.3,296.8c0.4,0.5,0.9,1,1.3,1.5l0.4-0.3c-0.5-0.5-0.9-1-1.3-1.5L137.3,296.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M202.9,75.4c-0.6,0.2-1.3,0.4-1.9,0.5l0.1,0.5c0.6-0.2,1.3-0.4,1.9-0.5L202.9,75.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M206.8,74.4c-0.7,0.2-1.3,0.3-1.9,0.5l0.1,0.5c0.6-0.2,1.3-0.3,1.9-0.5L206.8,74.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M216.7,340.2c0.7,0.1,1.3,0.2,2,0.3l0.1-0.5c-0.7-0.1-1.3-0.2-2-0.3L216.7,340.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M197.3,335.6c0.6,0.2,1.3,0.4,1.9,0.6l0.1-0.5c-0.6-0.2-1.3-0.4-1.9-0.6L197.3,335.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M193.4,334.3c0.6,0.2,1.3,0.4,1.9,0.6l0.2-0.5c-0.6-0.2-1.3-0.4-1.9-0.6L193.4,334.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M199.2,77l-0.1-0.5c-0.6,0.2-1.3,0.4-1.9,0.6l0.2,0.5C197.9,77.4,198.5,77.2,199.2,77z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M214.6,72.8c-0.7,0.1-1.3,0.2-2,0.4l0.1,0.5c0.7-0.1,1.3-0.2,2-0.4L214.6,72.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M212.8,339.5c0.7,0.1,1.3,0.2,2,0.4l0.1-0.5c-0.7-0.1-1.3-0.2-2-0.4L212.8,339.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M218.6,72.2c-0.7,0.1-1.3,0.2-2,0.3l0.1,0.5c0.7-0.1,1.3-0.2,2-0.3L218.6,72.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M195.4,78.2l-0.2-0.5c-0.6,0.2-1.3,0.4-1.9,0.6l0.2,0.5C194.1,78.6,194.7,78.4,195.4,78.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M208.9,338.7c0.7,0.1,1.3,0.3,2,0.4l0.1-0.5c-0.7-0.1-1.3-0.3-2-0.4L208.9,338.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M205,337.7c0.6,0.2,1.3,0.3,1.9,0.5l0.1-0.5c-0.6-0.2-1.3-0.3-1.9-0.5L205,337.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M210.7,73.6c-0.7,0.1-1.3,0.3-2,0.4l0.1,0.5c0.6-0.1,1.3-0.3,2-0.4L210.7,73.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M201.1,336.7c0.6,0.2,1.3,0.4,1.9,0.5l0.1-0.5c-0.6-0.2-1.3-0.3-1.9-0.5L201.1,336.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M177,85.9l-0.2-0.4c-0.6,0.3-1.2,0.6-1.8,0.9l0.2,0.4C175.8,86.5,176.4,86.2,177,85.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M178.6,328.1c0.6,0.3,1.2,0.6,1.8,0.9l0.2-0.5c-0.6-0.3-1.2-0.6-1.8-0.9L178.6,328.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M180.6,84.1l-0.2-0.5c-0.6,0.3-1.2,0.6-1.8,0.9l0.2,0.4C179.4,84.7,180,84.4,180.6,84.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M189.7,332.9c0.6,0.2,1.3,0.5,1.9,0.7l0.2-0.5c-0.6-0.2-1.3-0.5-1.9-0.7L189.7,332.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M171.5,324.3c0.6,0.3,1.2,0.7,1.8,1l0.2-0.4c-0.6-0.3-1.2-0.6-1.7-1L171.5,324.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M173.5,87.8l-0.2-0.4c-0.6,0.3-1.2,0.6-1.7,1l0.2,0.4C172.3,88.4,172.9,88.1,173.5,87.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M175,326.3c0.6,0.3,1.2,0.6,1.8,0.9l0.2-0.4c-0.6-0.3-1.2-0.6-1.8-0.9L175,326.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M185.9,331.4c0.6,0.3,1.2,0.5,1.9,0.8l0.2-0.5c-0.6-0.2-1.2-0.5-1.9-0.8L185.9,331.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M184.2,82.5L184,82c-0.6,0.3-1.2,0.5-1.8,0.8l0.2,0.5C183,83,183.6,82.8,184.2,82.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M191.6,79.5l-0.2-0.5c-0.6,0.2-1.3,0.5-1.9,0.7l0.2,0.5C190.4,80,191,79.8,191.6,79.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M187.9,81l-0.2-0.5c-0.6,0.2-1.2,0.5-1.8,0.8l0.2,0.5C186.7,81.5,187.3,81.2,187.9,81z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M182.3,329.8c0.6,0.3,1.2,0.5,1.8,0.8l0.2-0.5c-0.6-0.3-1.2-0.5-1.8-0.8L182.3,329.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M168.1,90.3l0.3,0.4c0.6-0.3,1.1-0.7,1.7-1l-0.3-0.4C169.2,89.6,168.6,90,168.1,90.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M103.7,193.4l-0.5,0c-0.1,0.7-0.1,1.3-0.2,2l0.5,0C103.6,194.8,103.7,194.1,103.7,193.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M104.2,189.5l-0.5-0.1c-0.1,0.7-0.2,1.3-0.2,2l0.5,0.1C104,190.8,104.1,190.1,104.2,189.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M103.4,197.4l-0.5,0c0,0.7-0.1,1.3-0.1,2l0.5,0C103.3,198.7,103.4,198.1,103.4,197.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M105.4,181.6l-0.5-0.1c-0.1,0.7-0.2,1.3-0.4,2l0.5,0.1C105.2,182.9,105.3,182.2,105.4,181.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M104.7,185.5l-0.5-0.1c-0.1,0.7-0.2,1.3-0.3,2l0.5,0.1C104.5,186.8,104.6,186.2,104.7,185.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M103.2,201.4l-0.5,0c0,0.7,0,1.3-0.1,2l0.5,0C103.2,202.7,103.2,202.1,103.2,201.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M106.2,177.7l-0.5-0.1c-0.1,0.7-0.3,1.3-0.4,2l0.5,0.1C105.9,179,106,178.3,106.2,177.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M104,221.3l-0.5,0.1c0.1,0.7,0.2,1.3,0.2,2l0.5-0.1C104.1,222.6,104,222,104,221.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M103.6,217.4l-0.5,0c0.1,0.7,0.1,1.3,0.2,2l0.5,0C103.7,218.7,103.6,218,103.6,217.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M104.5,225.3l-0.5,0.1c0.1,0.7,0.2,1.3,0.3,2l0.5-0.1C104.6,226.6,104.6,225.9,104.5,225.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M103.3,213.4l-0.5,0c0,0.7,0.1,1.3,0.1,2l0.5,0C103.4,214.7,103.4,214,103.3,213.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M103.2,209.4l-0.5,0c0,0.7,0,1.3,0.1,2l0.5,0C103.2,210.7,103.2,210,103.2,209.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M103.1,206.3l0-0.9l-0.5,0l0,0.9c0,0.4,0,0.7,0,1.1l0.5,0C103.1,207,103.1,206.7,103.1,206.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M372.9,198.2l0.5,0c0-0.7-0.1-1.3-0.1-2l-0.5,0C372.9,196.8,372.9,197.5,372.9,198.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M371.7,186.3l0.5-0.1c-0.1-0.7-0.2-1.3-0.3-2l-0.5,0.1C371.5,185,371.6,185.6,371.7,186.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M372.6,194.2l0.5,0c-0.1-0.7-0.1-1.3-0.2-2l-0.5,0.1C372.5,192.9,372.6,193.5,372.6,194.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M107.1,173.8l-0.5-0.1c-0.2,0.6-0.3,1.3-0.5,1.9l0.5,0.1C106.8,175.1,106.9,174.4,107.1,173.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M105.1,229.2l-0.5,0.1c0.1,0.7,0.2,1.3,0.4,2l0.5-0.1C105.3,230.5,105.2,229.9,105.1,229.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M373.1,202.2l0.5,0c0-0.7,0-1.3-0.1-2l-0.5,0C373.1,200.8,373.1,201.5,373.1,202.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M373.2,206.2h0.5c0-0.7,0-1.3,0-2l-0.5,0C373.2,204.8,373.2,205.5,373.2,206.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M372.2,190.2l0.5-0.1c-0.1-0.7-0.2-1.3-0.3-2l-0.5,0.1C372.1,188.9,372.2,189.6,372.2,190.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M371.1,182.3l0.5-0.1c-0.1-0.7-0.2-1.3-0.4-2l-0.5,0.1C370.8,181,370.9,181.7,371.1,182.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M354.9,137.5c-0.3-0.6-0.7-1.1-1-1.7l-0.4,0.3c0.3,0.6,0.7,1.1,1,1.7L354.9,137.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M108.1,169.9l-0.5-0.1c-0.2,0.6-0.4,1.3-0.5,1.9l0.5,0.1C107.7,171.2,107.9,170.6,108.1,169.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M369.9,174.4c-0.2-0.6-0.3-1.3-0.5-1.9l-0.5,0.1c0.2,0.6,0.3,1.3,0.5,1.9L369.9,174.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M370.3,178.4l0.5-0.1c-0.1-0.7-0.3-1.3-0.4-2l-0.5,0.1C370,177.1,370.2,177.8,370.3,178.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M111.8,158.5l-0.5-0.2c-0.2,0.6-0.5,1.3-0.7,1.9l0.5,0.2C111.4,159.8,111.6,159.1,111.8,158.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M120.9,138.4l0.4,0.3c0.3-0.6,0.7-1.2,1-1.7l-0.4-0.3C121.5,137.2,121.2,137.8,120.9,138.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M118.9,270.7c0.3,0.6,0.6,1.2,1,1.7l0.4-0.2c-0.3-0.6-0.6-1.2-1-1.7L118.9,270.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M120.9,274.2c0.3,0.6,0.7,1.2,1,1.7l0.4-0.3c-0.3-0.6-0.7-1.1-1-1.7L120.9,274.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M120.3,140.4l-0.4-0.2c-0.3,0.6-0.6,1.2-1,1.8l0.4,0.2C119.6,141.6,120,141,120.3,140.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M117.1,267.2c0.3,0.6,0.6,1.2,0.9,1.8l0.4-0.2c-0.3-0.6-0.6-1.2-0.9-1.8L117.1,267.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M118.4,143.9l-0.4-0.2c-0.3,0.6-0.6,1.2-0.9,1.8l0.4,0.2C117.8,145.1,118.1,144.5,118.4,143.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M127.3,284.3c0.4,0.5,0.8,1.1,1.2,1.6l0.4-0.3c-0.4-0.5-0.8-1.1-1.2-1.6L127.3,284.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M125.1,131.6l0.4,0.3c0.4-0.6,0.7-1.1,1.1-1.7l-0.4-0.3C125.8,130.5,125.5,131,125.1,131.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M115.3,263.6c0.3,0.6,0.6,1.2,0.9,1.8l0.5-0.2c-0.3-0.6-0.6-1.2-0.9-1.8L115.3,263.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M122.9,135l0.4,0.3c0.4-0.6,0.7-1.1,1.1-1.7l-0.4-0.3C123.6,133.8,123.3,134.4,122.9,135z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M122.9,277.7c0.4,0.6,0.7,1.1,1.1,1.7l0.4-0.3c-0.4-0.6-0.7-1.1-1.1-1.7L122.9,277.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M125.1,281c0.4,0.6,0.7,1.1,1.1,1.7l0.4-0.3c-0.4-0.5-0.7-1.1-1.1-1.7L125.1,281z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M113.7,260c0.3,0.6,0.5,1.2,0.8,1.8l0.5-0.2c-0.3-0.6-0.5-1.2-0.8-1.8L113.7,260z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M109.2,166.1l-0.5-0.1c-0.2,0.6-0.4,1.3-0.6,1.9l0.5,0.1C108.8,167.4,109,166.7,109.2,166.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M110.5,162.3l-0.5-0.2c-0.2,0.6-0.4,1.3-0.6,1.9l0.5,0.2C110.1,163.5,110.3,162.9,110.5,162.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M109.4,248.7c0.2,0.6,0.4,1.3,0.6,1.9l0.5-0.2c-0.2-0.6-0.4-1.3-0.6-1.9L109.4,248.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M106.2,237.2c0.2,0.7,0.3,1.3,0.5,1.9l0.5-0.1c-0.2-0.6-0.3-1.3-0.5-1.9L106.2,237.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M127.4,128.3l0.4,0.3c0.4-0.5,0.8-1.1,1.2-1.6l-0.4-0.3C128.1,127.2,127.7,127.7,127.4,128.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M107.1,241.1c0.2,0.6,0.3,1.3,0.5,1.9l0.5-0.1c-0.2-0.6-0.4-1.3-0.5-1.9L107.1,241.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M110.7,252.5c0.2,0.6,0.5,1.3,0.7,1.9l0.5-0.2c-0.2-0.6-0.5-1.2-0.7-1.9L110.7,252.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M114.9,151.1l-0.5-0.2c-0.3,0.6-0.5,1.2-0.8,1.8l0.5,0.2C114.4,152.3,114.6,151.7,114.9,151.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M105.8,233.2l-0.5,0.1c0.1,0.7,0.3,1.3,0.4,2l0.5-0.1C106.1,234.5,105.9,233.8,105.8,233.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M112.1,256.3c0.2,0.6,0.5,1.2,0.8,1.9l0.5-0.2c-0.3-0.6-0.5-1.2-0.8-1.8L112.1,256.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M113.3,154.8l-0.5-0.2c-0.3,0.6-0.5,1.2-0.8,1.9l0.5,0.2C112.8,156,113.1,155.4,113.3,154.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M116.6,147.5l-0.5-0.2c-0.3,0.6-0.6,1.2-0.9,1.8l0.5,0.2C116,148.7,116.3,148.1,116.6,147.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M108.2,244.9c0.2,0.6,0.4,1.3,0.6,1.9l0.5-0.1c-0.2-0.6-0.4-1.3-0.6-1.9L108.2,244.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M346.8,286.6l0.4,0.3c0.4-0.5,0.8-1.1,1.2-1.6l-0.4-0.3C347.5,285.5,347.2,286,346.8,286.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M341.9,119.8c0.4,0.5,0.8,1,1.3,1.5l0.4-0.3c-0.4-0.5-0.8-1-1.3-1.5L341.9,119.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M344.4,122.9c0.4,0.5,0.8,1,1.2,1.6l0.4-0.3c-0.4-0.5-0.8-1.1-1.2-1.6L344.4,122.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M344.3,289.7l0.4,0.3c0.4-0.5,0.8-1.1,1.2-1.6l-0.4-0.3C345.2,288.7,344.7,289.2,344.3,289.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M339.3,116.8c0.4,0.5,0.9,1,1.3,1.5l0.4-0.3c-0.4-0.5-0.9-1-1.3-1.5L339.3,116.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M341.8,292.8l0.4,0.3c0.4-0.5,0.9-1,1.3-1.5l-0.4-0.3C342.7,291.8,342.2,292.3,341.8,292.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M351.3,132.6c0.4,0.6,0.7,1.1,1.1,1.7l0.4-0.3c-0.4-0.6-0.7-1.1-1.1-1.7L351.3,132.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M356.9,140.9c-0.3-0.6-0.6-1.2-1-1.7l-0.4,0.2c0.3,0.6,0.7,1.2,1,1.7L356.9,140.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M351.3,280l0.4,0.3c0.4-0.6,0.7-1.1,1.1-1.7l-0.4-0.3C352,278.9,351.7,279.4,351.3,280z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M222.5,71.7c-0.7,0.1-1.3,0.2-2,0.2l0.1,0.5c0.7-0.1,1.3-0.2,2-0.2L222.5,71.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M339.2,295.9l0.4,0.3c0.4-0.5,0.9-1,1.3-1.5l-0.4-0.3C340.1,294.9,339.7,295.4,339.2,295.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M349.1,283.3l0.4,0.3c0.4-0.5,0.8-1.1,1.1-1.7l-0.4-0.3C349.8,282.2,349.5,282.8,349.1,283.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M318.7,97.9c0.5,0.4,1.1,0.8,1.6,1.2l0.3-0.4c-0.5-0.4-1.1-0.8-1.6-1.2L318.7,97.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M346.8,126.1c0.4,0.5,0.8,1.1,1.2,1.6l0.4-0.3c-0.4-0.5-0.8-1.1-1.2-1.6L346.8,126.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M325,102.9c0.5,0.4,1,0.9,1.5,1.3l0.3-0.4c-0.5-0.4-1-0.9-1.5-1.3L325,102.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M328,105.5c0.5,0.4,1,0.9,1.5,1.3l0.3-0.4c-0.5-0.5-1-0.9-1.5-1.3L328,105.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M327.9,307.2l0.3,0.4c0.5-0.4,1-0.9,1.5-1.3l-0.3-0.4C328.9,306.3,328.4,306.7,327.9,307.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M324.9,309.8l0.3,0.4c0.5-0.4,1-0.9,1.5-1.3l-0.3-0.4C325.9,308.9,325.4,309.3,324.9,309.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M336.6,113.9c0.5,0.5,0.9,1,1.4,1.5l0.4-0.3c-0.4-0.5-0.9-1-1.4-1.5L336.6,113.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M321.8,312.3l0.3,0.4c0.5-0.4,1-0.8,1.6-1.3l-0.3-0.4C322.9,311.5,322.4,311.9,321.8,312.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M321.9,100.4c0.5,0.4,1,0.8,1.6,1.3l0.3-0.4c-0.5-0.4-1-0.8-1.6-1.3L321.9,100.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M333.8,111c0.5,0.5,0.9,0.9,1.4,1.4l0.4-0.3c-0.5-0.5-0.9-1-1.4-1.4L333.8,111z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M336.5,298.8l0.4,0.3c0.5-0.5,0.9-1,1.4-1.5l-0.4-0.3C337.4,297.8,337,298.3,336.5,298.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M333.7,301.7l0.4,0.4c0.5-0.5,0.9-0.9,1.4-1.4l-0.4-0.3C334.7,300.7,334.2,301.2,333.7,301.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M330.9,304.5l0.3,0.4c0.5-0.5,1-0.9,1.4-1.4l-0.3-0.4C331.8,303.5,331.4,304,330.9,304.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M330.9,108.2c0.5,0.5,1,0.9,1.4,1.4l0.3-0.4c-0.5-0.5-1-0.9-1.4-1.4L330.9,108.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M349.1,129.3c0.4,0.5,0.8,1.1,1.1,1.6l0.4-0.3c-0.4-0.6-0.7-1.1-1.1-1.7L349.1,129.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M370.7,232.1l0.5,0.1c0.1-0.7,0.2-1.3,0.4-2l-0.5-0.1C371,230.8,370.8,231.5,370.7,232.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M369,239.9l0.5,0.1c0.2-0.6,0.3-1.3,0.5-1.9l-0.5-0.1C369.3,238.6,369.1,239.3,369,239.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M369.9,236l0.5,0.1c0.1-0.7,0.3-1.3,0.4-2l-0.5-0.1C370.2,234.7,370.1,235.4,369.9,236z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M367.9,243.7l0.5,0.1c0.2-0.6,0.4-1.3,0.5-1.9l-0.5-0.1C368.3,242.5,368.1,243.1,367.9,243.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M366.8,247.6l0.5,0.2c0.2-0.6,0.4-1.3,0.6-1.9l-0.5-0.1C367.2,246.3,367,246.9,366.8,247.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M368.9,170.5c-0.2-0.6-0.4-1.3-0.5-1.9l-0.5,0.1c0.2,0.6,0.4,1.3,0.5,1.9L368.9,170.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M355.5,273.2l0.4,0.2c0.3-0.6,0.7-1.2,1-1.8l-0.4-0.2C356.1,272,355.8,272.6,355.5,273.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M373.1,212.3l0.5,0c0-0.7,0.1-1.3,0.1-2l-0.5,0C373.1,211,373.1,211.6,373.1,212.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M371.4,228.2l0.5,0.1c0.1-0.7,0.2-1.3,0.3-2l-0.5-0.1C371.6,226.9,371.5,227.5,371.4,228.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M367.8,166.7c-0.2-0.6-0.4-1.3-0.6-1.9l-0.5,0.2c0.2,0.6,0.4,1.3,0.6,1.9L367.8,166.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M373.2,208.3l0.5,0c0-0.7,0-1.3,0-2h-0.5C373.2,207,373.2,207.6,373.2,208.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M372,224.2l0.5,0.1c0.1-0.7,0.2-1.3,0.2-2l-0.5-0.1C372.2,222.9,372.1,223.6,372,224.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M372.5,220.3l0.5,0.1c0.1-0.7,0.1-1.3,0.2-2l-0.5,0C372.6,218.9,372.5,219.6,372.5,220.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M372.8,216.3l0.5,0c0-0.7,0.1-1.3,0.1-2l-0.5,0C372.9,215,372.9,215.6,372.8,216.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M365.5,251.4l0.5,0.2c0.2-0.6,0.4-1.3,0.7-1.9l-0.5-0.2C365.9,250.1,365.7,250.7,365.5,251.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M359.2,266.1l0.4,0.2c0.3-0.6,0.6-1.2,0.9-1.8l-0.5-0.2C359.8,264.9,359.5,265.5,359.2,266.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M362.2,151.7c-0.3-0.6-0.5-1.2-0.8-1.8l-0.5,0.2c0.3,0.6,0.5,1.2,0.8,1.8L362.2,151.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M361,262.5l0.5,0.2c0.3-0.6,0.6-1.2,0.8-1.8l-0.5-0.2C361.5,261.3,361.2,261.9,361,262.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M358.8,144.5c-0.3-0.6-0.6-1.2-0.9-1.8l-0.4,0.2c0.3,0.6,0.6,1.2,0.9,1.8L358.8,144.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M357.4,269.7l0.4,0.2c0.3-0.6,0.6-1.2,0.9-1.8l-0.4-0.2C358,268.5,357.7,269.1,357.4,269.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M360.5,148c-0.3-0.6-0.6-1.2-0.9-1.8l-0.4,0.2c0.3,0.6,0.6,1.2,0.9,1.8L360.5,148z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M364.1,255.1l0.5,0.2c0.2-0.6,0.5-1.3,0.7-1.9l-0.5-0.2C364.6,253.9,364.3,254.5,364.1,255.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M366.6,162.9c-0.2-0.6-0.4-1.3-0.7-1.9l-0.5,0.2c0.2,0.6,0.4,1.3,0.7,1.9L366.6,162.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M365.2,159.1c-0.2-0.6-0.5-1.3-0.7-1.9l-0.5,0.2c0.2,0.6,0.5,1.2,0.7,1.9L365.2,159.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M362.6,258.8l0.5,0.2c0.3-0.6,0.5-1.2,0.8-1.9l-0.5-0.2C363.1,257.6,362.8,258.2,362.6,258.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M363.8,155.3c-0.3-0.6-0.5-1.2-0.8-1.8l-0.5,0.2c0.3,0.6,0.5,1.2,0.8,1.8L363.8,155.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M353.5,276.6l0.4,0.3c0.3-0.6,0.7-1.1,1-1.7l-0.4-0.3C354.1,275.5,353.8,276.1,353.5,276.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M254.5,71.8c-0.7-0.1-1.3-0.2-2-0.2l-0.1,0.5c0.7,0.1,1.3,0.1,2,0.2L254.5,71.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M252.6,340.6l0.1,0.5c0.7-0.1,1.3-0.1,2-0.2l-0.1-0.5C254,340.4,253.3,340.5,252.6,340.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M256.6,340.1l0.1,0.5c0.7-0.1,1.3-0.2,2-0.3l-0.1-0.5C257.9,339.9,257.3,340,256.6,340.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M258.5,72.3c-0.7-0.1-1.3-0.2-2-0.3l-0.1,0.5c0.7,0.1,1.3,0.2,2,0.3L258.5,72.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M248.7,340.9l0,0.5c0.7-0.1,1.3-0.1,2-0.2l0-0.5C250,340.8,249.3,340.9,248.7,340.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M250.5,71.4c-0.7-0.1-1.3-0.1-2-0.2l0,0.5c0.7,0,1.3,0.1,2,0.2L250.5,71.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M264.5,338.8l0.1,0.5c0.7-0.1,1.3-0.3,2-0.4l-0.1-0.5C265.8,338.5,265.1,338.6,264.5,338.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M244.7,341.2l0,0.5c0.7,0,1.3-0.1,2-0.1l0-0.5C246,341.1,245.3,341.2,244.7,341.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M262.4,73c-0.7-0.1-1.3-0.2-2-0.3l-0.1,0.5c0.7,0.1,1.3,0.2,2,0.3L262.4,73z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M268.4,337.9l0.1,0.5c0.7-0.1,1.3-0.3,1.9-0.5l-0.1-0.5C269.7,337.6,269,337.8,268.4,337.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M270.3,74.6c-0.6-0.2-1.3-0.3-2-0.5l-0.1,0.5c0.6,0.1,1.3,0.3,1.9,0.5L270.3,74.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M260.5,339.5l0.1,0.5c0.7-0.1,1.3-0.2,2-0.3l-0.1-0.5C261.9,339.3,261.2,339.4,260.5,339.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M266.4,73.7c-0.7-0.1-1.3-0.3-2-0.4l-0.1,0.5c0.7,0.1,1.3,0.3,2,0.4L266.4,73.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M226.5,71.3c-0.7,0.1-1.3,0.1-2,0.2l0,0.5c0.7-0.1,1.3-0.1,2-0.2L226.5,71.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M234.5,70.8c-0.7,0-1.3,0-2,0.1l0,0.5c0.7,0,1.3,0,2-0.1L234.5,70.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M228.7,341.5c0.7,0,1.3,0.1,2,0.1l0-0.5c-0.7,0-1.3-0.1-2-0.1L228.7,341.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M224.7,341.2c0.7,0.1,1.3,0.1,2,0.2l0-0.5c-0.7-0.1-1.3-0.1-2-0.2L224.7,341.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M246.5,71c-0.7,0-1.3-0.1-2-0.1l0,0.5c0.7,0,1.3,0.1,2,0.1L246.5,71z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M220.7,340.7c0.7,0.1,1.3,0.2,2,0.2l0.1-0.5c-0.7-0.1-1.3-0.2-2-0.2L220.7,340.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M274.2,75.6c-0.6-0.2-1.3-0.3-1.9-0.5l-0.1,0.5c0.6,0.2,1.3,0.3,1.9,0.5L274.2,75.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M230.5,71c-0.7,0-1.3,0.1-2,0.1l0,0.5c0.7,0,1.3-0.1,2-0.1L230.5,71z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M242.5,70.9c-0.7,0-1.3,0-2,0l0,0.5c0.7,0,1.3,0,2,0L242.5,70.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M318.7,314.7l0.3,0.4c0.5-0.4,1.1-0.8,1.6-1.2l-0.3-0.4C319.7,313.9,319.2,314.3,318.7,314.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M240.7,341.3l0,0.5c0.7,0,1.3,0,2-0.1l0-0.5C242,341.3,241.4,341.3,240.7,341.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M238.2,341.3c-0.5,0-1,0-1.5,0l0,0.5c0.5,0,1,0,1.5,0l0.5,0l0-0.5L238.2,341.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M238.5,71.3l0-0.5l-0.4,0c-0.5,0-1.1,0-1.6,0l0,0.5c0.5,0,1.1,0,1.6,0L238.5,71.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M232.7,341.7c0.7,0,1.3,0,2,0.1l0-0.5c-0.7,0-1.3,0-2-0.1L232.7,341.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M300.3,85.9c-0.6-0.3-1.2-0.6-1.8-0.9l-0.2,0.4c0.6,0.3,1.2,0.6,1.8,0.9L300.3,85.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M308.8,321.4l0.3,0.4c0.6-0.3,1.1-0.7,1.7-1.1l-0.3-0.4C309.9,320.7,309.3,321.1,308.8,321.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M301.9,325.4l0.2,0.4c0.6-0.3,1.2-0.6,1.8-1l-0.2-0.4C303,324.8,302.5,325.1,301.9,325.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M305.3,89.2c0.6,0.3,1.2,0.7,1.7,1l0.3-0.4c-0.6-0.3-1.2-0.7-1.7-1L305.3,89.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M272.3,337l0.1,0.5c0.6-0.2,1.3-0.3,1.9-0.5l-0.1-0.5C273.5,336.7,272.9,336.8,272.3,337z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M298.3,327.2l0.2,0.4c0.6-0.3,1.2-0.6,1.8-0.9l-0.2-0.4C299.5,326.6,298.9,326.9,298.3,327.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M305.4,323.5l0.2,0.4c0.6-0.3,1.2-0.7,1.7-1l-0.3-0.4C306.5,322.8,305.9,323.1,305.4,323.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M315.4,317l0.3,0.4c0.5-0.4,1.1-0.8,1.6-1.2l-0.3-0.4C316.5,316.3,316,316.7,315.4,317z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M315.5,95.6c0.5,0.4,1.1,0.8,1.6,1.2l0.3-0.4c-0.5-0.4-1.1-0.8-1.6-1.2L315.5,95.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M312.2,93.4c0.6,0.4,1.1,0.7,1.7,1.1l0.3-0.4c-0.6-0.4-1.1-0.7-1.7-1.1L312.2,93.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M308.8,91.2c0.6,0.3,1.1,0.7,1.7,1.1l0.3-0.4c-0.6-0.4-1.1-0.7-1.7-1.1L308.8,91.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M312.1,319.3l0.3,0.4c0.6-0.4,1.1-0.7,1.7-1.1l-0.3-0.4C313.2,318.6,312.7,318.9,312.1,319.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M303.9,87.7c-0.6-0.3-1.2-0.6-1.8-1l-0.2,0.4c0.6,0.3,1.2,0.6,1.8,1L303.9,87.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M283.7,333.5l0.2,0.5c0.6-0.2,1.3-0.5,1.9-0.7l-0.2-0.5C284.9,333,284.3,333.2,283.7,333.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M279.9,334.8l0.2,0.5c0.6-0.2,1.3-0.4,1.9-0.6l-0.2-0.5C281.2,334.3,280.6,334.6,279.9,334.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M285.6,79.3c-0.6-0.2-1.3-0.5-1.9-0.7l-0.2,0.5c0.6,0.2,1.3,0.5,1.9,0.7L285.6,79.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M281.8,78c-0.6-0.2-1.3-0.4-1.9-0.6l-0.2,0.5c0.6,0.2,1.3,0.4,1.9,0.6L281.8,78z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M276.1,335.9l0.1,0.5c0.6-0.2,1.3-0.4,1.9-0.6l-0.1-0.5C277.4,335.6,276.7,335.7,276.1,335.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M278,76.7c-0.6-0.2-1.3-0.4-1.9-0.6l-0.1,0.5c0.6,0.2,1.3,0.4,1.9,0.6L278,76.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M296.7,84.1c-0.6-0.3-1.2-0.6-1.8-0.9l-0.2,0.5c0.6,0.3,1.2,0.6,1.8,0.9L296.7,84.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M291.1,330.6l0.2,0.5c0.6-0.3,1.2-0.5,1.8-0.8l-0.2-0.5C292.3,330,291.7,330.3,291.1,330.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M294.8,328.9l0.2,0.5c0.6-0.3,1.2-0.6,1.8-0.9l-0.2-0.5C296,328.4,295.4,328.7,294.8,328.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M289.4,80.8c-0.6-0.3-1.2-0.5-1.9-0.7l-0.2,0.5c0.6,0.2,1.2,0.5,1.9,0.7L289.4,80.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M293.1,82.4c-0.6-0.3-1.2-0.5-1.8-0.8L291,82c0.6,0.3,1.2,0.5,1.8,0.8L293.1,82.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M287.4,332.1l0.2,0.5c0.6-0.2,1.2-0.5,1.9-0.7l-0.2-0.5C288.7,331.6,288.1,331.8,287.4,332.1z"
                />
              </g>
            )}
            <g id="Circle5">
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M181.1,301.8c0.6,0.3,1.2,0.7,1.7,1l0.2-0.4c-0.6-0.3-1.2-0.7-1.7-1L181.1,301.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M177.7,299.7c0.6,0.4,1.1,0.7,1.7,1.1l0.3-0.4c-0.6-0.4-1.1-0.7-1.7-1.1L177.7,299.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M184.6,303.8c0.6,0.3,1.2,0.6,1.8,1l0.2-0.4c-0.6-0.3-1.2-0.6-1.8-0.9L184.6,303.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M178.5,112.5l0.3,0.4c0.6-0.4,1.1-0.7,1.7-1.1l-0.3-0.4C179.6,111.8,179,112.1,178.5,112.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M181.9,110.4l0.3,0.4c0.6-0.3,1.1-0.7,1.7-1l-0.2-0.4C183,109.7,182.5,110.1,181.9,110.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M192.5,104.9l0.2,0.5c0.6-0.3,1.2-0.5,1.8-0.8l-0.2-0.5C193.7,104.4,193.1,104.6,192.5,104.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M185.4,108.4l0.2,0.4c0.6-0.3,1.2-0.6,1.8-0.9l-0.2-0.4C186.5,107.8,186,108.1,185.4,108.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M191.8,307.4c0.6,0.3,1.2,0.6,1.8,0.8l0.2-0.5c-0.6-0.3-1.2-0.5-1.8-0.8L191.8,307.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M188.2,305.7c0.6,0.3,1.2,0.6,1.8,0.9l0.2-0.5c-0.6-0.3-1.2-0.6-1.8-0.9L188.2,305.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M188.9,106.6l0.2,0.4c0.6-0.3,1.2-0.6,1.8-0.9l-0.2-0.5C190.1,106,189.5,106.3,188.9,106.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M171.9,117l0.3,0.4c0.5-0.4,1.1-0.8,1.6-1.2l-0.3-0.4C173,116.2,172.4,116.6,171.9,117z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M164.9,290c0.5,0.4,1,0.9,1.5,1.3l0.3-0.4c-0.5-0.4-1-0.9-1.5-1.3L164.9,290z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M162.6,124.7l0.3,0.4c0.5-0.5,1-0.9,1.5-1.3l-0.3-0.4C163.6,123.8,163.1,124.2,162.6,124.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M165.6,122l0.3,0.4c0.5-0.4,1-0.9,1.5-1.3l-0.3-0.4C166.6,121.2,166.1,121.6,165.6,122z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M162,287.3c0.5,0.5,1,0.9,1.5,1.4l0.3-0.4c-0.5-0.4-1-0.9-1.5-1.4L162,287.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M175.1,114.7l0.3,0.4c0.5-0.4,1.1-0.7,1.7-1.1l-0.3-0.4C176.2,113.9,175.7,114.3,175.1,114.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M159.8,127.5l0.4,0.4c0.5-0.5,0.9-0.9,1.4-1.4l-0.3-0.4C160.7,126.5,160.2,127,159.8,127.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M174.4,297.4c0.5,0.4,1.1,0.8,1.7,1.1l0.3-0.4c-0.6-0.4-1.1-0.8-1.6-1.1L174.4,297.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M171.2,295.1c0.5,0.4,1.1,0.8,1.6,1.2l0.3-0.4c-0.5-0.4-1.1-0.8-1.6-1.2L171.2,295.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M168.7,119.5l0.3,0.4c0.5-0.4,1-0.8,1.6-1.2l-0.3-0.4C169.8,118.6,169.2,119.1,168.7,119.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M168,292.6c0.5,0.4,1,0.8,1.6,1.3l0.3-0.4c-0.5-0.4-1-0.8-1.6-1.2L168,292.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M219.3,96.7l0.1,0.5c0.7-0.1,1.3-0.2,2-0.3l-0.1-0.5C220.6,96.5,219.9,96.6,219.3,96.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M223.2,96.1l0.1,0.5c0.7-0.1,1.3-0.2,2-0.2l-0.1-0.5C224.6,95.9,223.9,96,223.2,96.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M222.5,316.4c0.7,0.1,1.3,0.2,2,0.3l0.1-0.5c-0.7-0.1-1.3-0.2-2-0.3L222.5,316.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M159.1,284.5c0.5,0.5,0.9,0.9,1.4,1.4l0.3-0.4c-0.5-0.5-0.9-0.9-1.4-1.4L159.1,284.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M226.5,316.9c0.7,0.1,1.3,0.1,2,0.2l0-0.5c-0.7-0.1-1.3-0.1-2-0.2L226.5,316.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M218.5,315.8c0.7,0.1,1.3,0.2,2,0.3l0.1-0.5c-0.7-0.1-1.3-0.2-2-0.3L218.5,315.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M348.8,203.1l0.5,0c0-0.7,0-1.3-0.1-2l-0.5,0C348.8,201.7,348.8,202.4,348.8,203.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M348.3,195.1l0.5,0c-0.1-0.7-0.1-1.3-0.2-2l-0.5,0.1C348.2,193.8,348.2,194.5,348.3,195.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M348.6,199.1l0.5,0c0-0.7-0.1-1.3-0.1-2l-0.5,0C348.5,197.8,348.6,198.4,348.6,199.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M215.3,97.5l0.1,0.5c0.7-0.1,1.3-0.3,2-0.4l-0.1-0.5C216.6,97.2,216,97.3,215.3,97.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M195.5,309c0.6,0.3,1.2,0.5,1.9,0.8l0.2-0.5c-0.6-0.2-1.2-0.5-1.9-0.8L195.5,309z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M227.2,95.7l0,0.5c0.7-0.1,1.3-0.1,2-0.2l0-0.5C228.5,95.5,227.9,95.6,227.2,95.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M199.9,101.9l0.2,0.5c0.6-0.2,1.3-0.5,1.9-0.7l-0.2-0.5C201.2,101.4,200.6,101.6,199.9,101.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M203,311.8c0.6,0.2,1.3,0.4,1.9,0.6l0.1-0.5c-0.6-0.2-1.3-0.4-1.9-0.6L203,311.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M347.8,191.2l0.5-0.1c-0.1-0.7-0.2-1.3-0.3-2l-0.5,0.1C347.6,189.8,347.7,190.5,347.8,191.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M203.7,100.6l0.2,0.5c0.6-0.2,1.3-0.4,1.9-0.6l-0.1-0.5C205,100.2,204.4,100.4,203.7,100.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M199.2,310.5c0.6,0.2,1.3,0.5,1.9,0.7l0.2-0.5c-0.6-0.2-1.3-0.5-1.9-0.7L199.2,310.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M214.6,315c0.7,0.1,1.3,0.3,2,0.4l0.1-0.5c-0.7-0.1-1.3-0.3-2-0.4L214.6,315z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M211.4,98.4l0.1,0.5c0.6-0.2,1.3-0.3,1.9-0.5l-0.1-0.5C212.7,98,212.1,98.2,211.4,98.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M206.8,313c0.6,0.2,1.3,0.4,1.9,0.5l0.1-0.5c-0.6-0.2-1.3-0.4-1.9-0.5L206.8,313z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M210.7,314.1c0.6,0.2,1.3,0.3,1.9,0.5l0.1-0.5c-0.6-0.2-1.3-0.3-1.9-0.5L210.7,314.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M207.6,99.4l0.1,0.5c0.6-0.2,1.3-0.4,1.9-0.5l-0.1-0.5C208.8,99,208.2,99.2,207.6,99.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M196.2,103.3l0.2,0.5c0.6-0.3,1.2-0.5,1.9-0.7l-0.2-0.5C197.4,102.8,196.8,103.1,196.2,103.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M129,224.8l-0.5,0.1c0.1,0.7,0.2,1.3,0.4,2l0.5-0.1C129.2,226.1,129.1,225.5,129,224.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M128,216.9l-0.5,0c0.1,0.7,0.1,1.3,0.2,2l0.5-0.1C128.1,218.2,128,217.6,128,216.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M128.4,220.9l-0.5,0.1c0.1,0.7,0.2,1.3,0.3,2l0.5-0.1C128.6,222.2,128.5,221.5,128.4,220.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M127.5,208.9l-0.5,0c0,0.7,0,1.3,0.1,2l0.5,0C127.5,210.3,127.5,209.6,127.5,208.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M127.7,212.9l-0.5,0c0,0.7,0.1,1.3,0.1,2l0.5,0C127.7,214.2,127.7,213.6,127.7,212.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M132.3,240.5c0.2,0.6,0.4,1.3,0.6,1.9l0.5-0.2c-0.2-0.6-0.4-1.3-0.6-1.9L132.3,240.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M131.1,236.6c0.2,0.6,0.4,1.3,0.6,1.9l0.5-0.1c-0.2-0.6-0.4-1.3-0.6-1.9L131.1,236.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M133.6,244.2c0.2,0.6,0.5,1.3,0.7,1.9l0.5-0.2c-0.2-0.6-0.5-1.2-0.7-1.9L133.6,244.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M130.1,232.7c0.2,0.6,0.3,1.3,0.5,1.9l0.5-0.1c-0.2-0.6-0.3-1.3-0.5-1.9L130.1,232.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M129.7,228.7l-0.5,0.1c0.1,0.7,0.3,1.3,0.4,2l0.5-0.1C130,230,129.9,229.4,129.7,228.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M127.5,206.3c0-0.5,0-0.9,0-1.4l-0.5,0c0,0.5,0,0.9,0,1.4l0,0.6l0.5,0L127.5,206.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M131.3,177.4l-0.5-0.1c-0.2,0.6-0.3,1.3-0.5,1.9l0.5,0.1C131,178.6,131.1,178,131.3,177.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M130.3,181.2l-0.5-0.1c-0.2,0.6-0.3,1.3-0.4,2l0.5,0.1C130,182.5,130.2,181.9,130.3,181.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M132.4,173.5l-0.5-0.1c-0.2,0.6-0.4,1.3-0.6,1.9l0.5,0.1C132,174.8,132.2,174.2,132.4,173.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M135.1,166l-0.5-0.2c-0.2,0.6-0.5,1.3-0.7,1.9l0.5,0.2C134.6,167.2,134.8,166.6,135.1,166z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M133.7,169.7l-0.5-0.2c-0.2,0.6-0.4,1.3-0.6,1.9l0.5,0.2C133.2,171,133.4,170.3,133.7,169.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M128.3,193l-0.5-0.1c-0.1,0.7-0.2,1.3-0.2,2l0.5,0.1C128.1,194.3,128.2,193.7,128.3,193z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M127.6,201l-0.5,0c0,0.7-0.1,1.3-0.1,2l0.5,0C127.5,202.3,127.6,201.6,127.6,201z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M129.5,185.1L129,185c-0.1,0.7-0.2,1.3-0.4,2l0.5,0.1C129.2,186.4,129.4,185.8,129.5,185.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M127.9,197l-0.5,0c-0.1,0.7-0.1,1.3-0.1,2l0.5,0C127.8,198.3,127.8,197.6,127.9,197z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M128.8,189.1l-0.5-0.1c-0.1,0.7-0.2,1.3-0.3,2l0.5,0.1C128.6,190.4,128.7,189.7,128.8,189.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M142.5,149.6l0.4,0.3c0.3-0.6,0.7-1.1,1-1.7l-0.4-0.3C143.2,148.4,142.9,149,142.5,149.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M149.2,139.6l0.4,0.3c0.4-0.5,0.8-1.1,1.2-1.6l-0.4-0.3C150,138.5,149.6,139,149.2,139.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M148.7,272.3c0.4,0.5,0.8,1.1,1.2,1.6l0.4-0.3c-0.4-0.5-0.8-1.1-1.2-1.6L148.7,272.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M146.4,269.1c0.4,0.6,0.8,1.1,1.1,1.6l0.4-0.3c-0.4-0.5-0.8-1.1-1.1-1.6L146.4,269.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M151.1,275.5c0.4,0.5,0.8,1,1.3,1.6l0.4-0.3c-0.4-0.5-0.8-1-1.3-1.5L151.1,275.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M144.6,146.1l0.4,0.3c0.4-0.6,0.7-1.1,1.1-1.7l-0.4-0.3C145.4,145,145,145.6,144.6,146.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M135,248c0.3,0.6,0.5,1.2,0.8,1.8l0.5-0.2c-0.3-0.6-0.5-1.2-0.8-1.8L135,248z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M151.7,136.4l0.4,0.3c0.4-0.5,0.8-1,1.3-1.5l-0.4-0.3C152.5,135.4,152.1,135.9,151.7,136.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M154.3,133.3l0.4,0.3c0.4-0.5,0.9-1,1.3-1.5l-0.4-0.3C155.2,132.3,154.7,132.8,154.3,133.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M156.3,281.6c0.5,0.5,0.9,1,1.4,1.5l0.4-0.3c-0.5-0.5-0.9-1-1.4-1.5L156.3,281.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M153.7,278.6c0.4,0.5,0.9,1,1.3,1.5l0.4-0.3c-0.4-0.5-0.9-1-1.3-1.5L153.7,278.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M146.9,142.8l0.4,0.3c0.4-0.5,0.8-1.1,1.2-1.6l-0.4-0.3C147.6,141.7,147.3,142.3,146.9,142.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M138.3,255.3c0.3,0.6,0.6,1.2,0.9,1.8l0.4-0.2c-0.3-0.6-0.6-1.2-0.9-1.8L138.3,255.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M138.7,156.6l0.4,0.2c0.3-0.6,0.6-1.2,0.9-1.8l-0.4-0.2C139.3,155.4,139,156,138.7,156.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M136.9,160.2l0.5,0.2c0.3-0.6,0.6-1.2,0.8-1.8l-0.5-0.2C137.5,159,137.2,159.6,136.9,160.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M136.6,251.7c0.3,0.6,0.5,1.2,0.8,1.8l0.5-0.2c-0.3-0.6-0.6-1.2-0.8-1.8L136.6,251.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M144.2,265.7c0.4,0.6,0.7,1.1,1.1,1.7l0.4-0.3c-0.4-0.6-0.7-1.1-1.1-1.7L144.2,265.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M135.3,163.9l0.5,0.2c0.3-0.6,0.5-1.2,0.8-1.8l-0.5-0.2C135.9,162.7,135.6,163.3,135.3,163.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M142.1,262.3c0.3,0.6,0.7,1.1,1,1.7l0.4-0.3c-0.3-0.6-0.7-1.1-1-1.7L142.1,262.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M140.1,258.8c0.3,0.6,0.6,1.2,1,1.8l0.4-0.2c-0.3-0.6-0.6-1.2-1-1.7L140.1,258.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M157,130.4l0.4,0.3c0.5-0.5,0.9-1,1.4-1.4l-0.4-0.3C157.9,129.4,157.4,129.9,157,130.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M140.5,153l0.4,0.2c0.3-0.6,0.6-1.2,1-1.7l-0.4-0.2C141.2,151.9,140.9,152.5,140.5,153z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M258.3,315.2l0.1,0.5c0.7-0.1,1.3-0.2,2-0.4l-0.1-0.5C259.6,314.9,259,315.1,258.3,315.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M322.6,277.9l0.4,0.3c0.4-0.5,0.9-1,1.3-1.5l-0.4-0.3C323.4,276.9,323,277.4,322.6,277.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M320.5,132.4c0.4,0.5,0.9,1,1.3,1.5l0.4-0.3c-0.4-0.5-0.9-1-1.3-1.5L320.5,132.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M317.2,283.8l0.4,0.4c0.5-0.5,0.9-1,1.4-1.4l-0.4-0.3C318.1,282.9,317.6,283.4,317.2,283.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M319.9,280.9l0.4,0.3c0.5-0.5,0.9-1,1.3-1.5l-0.4-0.3C320.8,279.9,320.4,280.4,319.9,280.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M323.2,135.4c0.4,0.5,0.8,1,1.3,1.5l0.4-0.3c-0.4-0.5-0.8-1-1.3-1.5L323.2,135.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M317.8,129.5c0.5,0.5,0.9,1,1.4,1.4l0.4-0.3c-0.5-0.5-0.9-1-1.4-1.5L317.8,129.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M327.5,271.7l0.4,0.3c0.4-0.5,0.8-1.1,1.2-1.6l-0.4-0.3C328.3,270.6,327.9,271.1,327.5,271.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M328,141.7c0.4,0.5,0.8,1.1,1.1,1.6l0.4-0.3c-0.4-0.5-0.8-1.1-1.2-1.6L328,141.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M325.7,138.5c0.4,0.5,0.8,1.1,1.2,1.6l0.4-0.3c-0.4-0.5-0.8-1.1-1.2-1.6L325.7,138.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M325.1,274.8l0.4,0.3c0.4-0.5,0.8-1.1,1.2-1.6l-0.4-0.3C325.9,273.8,325.5,274.3,325.1,274.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M309.1,121.3c0.5,0.4,1,0.9,1.5,1.3l0.3-0.4c-0.5-0.4-1-0.9-1.5-1.3L309.1,121.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M299.5,114.1c0.6,0.4,1.1,0.7,1.7,1.1l0.3-0.4c-0.5-0.4-1.1-0.8-1.7-1.1L299.5,114.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M306,118.8c0.5,0.4,1,0.8,1.6,1.2l0.3-0.4c-0.5-0.4-1-0.8-1.6-1.2L306,118.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M302.8,116.4c0.5,0.4,1.1,0.8,1.6,1.2l0.3-0.4c-0.5-0.4-1.1-0.8-1.6-1.2L302.8,116.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M308.4,291.9l0.3,0.4c0.5-0.4,1-0.9,1.5-1.3l-0.3-0.4C309.4,291.1,308.9,291.5,308.4,291.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M302,296.7l0.3,0.4c0.5-0.4,1.1-0.8,1.6-1.2l-0.3-0.4C303.1,296,302.6,296.4,302,296.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M305.2,294.4l0.3,0.4c0.5-0.4,1.1-0.8,1.6-1.2l-0.3-0.4C306.3,293.6,305.8,294,305.2,294.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M312.1,123.9c0.5,0.4,1,0.9,1.5,1.3l0.3-0.4c-0.5-0.5-1-0.9-1.5-1.4L312.1,123.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M314.3,286.6l0.3,0.4c0.5-0.5,1-0.9,1.4-1.4l-0.4-0.4C315.3,285.7,314.8,286.2,314.3,286.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M329.8,268.4l0.4,0.3c0.4-0.6,0.7-1.1,1.1-1.7l-0.4-0.3C330.6,267.3,330.2,267.9,329.8,268.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M311.4,289.3l0.3,0.4c0.5-0.4,1-0.9,1.5-1.3l-0.3-0.4C312.4,288.4,311.9,288.9,311.4,289.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M315,126.6c0.5,0.5,1,0.9,1.4,1.4l0.4-0.4c-0.5-0.5-0.9-0.9-1.4-1.4L315,126.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M345.8,232l0.5,0.1c0.2-0.6,0.3-1.3,0.4-2l-0.5-0.1C346.2,230.7,346,231.4,345.8,232z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M347.4,224.2l0.5,0.1c0.1-0.7,0.2-1.3,0.3-2l-0.5-0.1C347.6,222.9,347.5,223.5,347.4,224.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M346.7,228.1l0.5,0.1c0.1-0.7,0.3-1.3,0.4-2l-0.5-0.1C347,226.8,346.8,227.5,346.7,228.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M344.9,235.9l0.5,0.1c0.2-0.6,0.4-1.3,0.5-1.9l-0.5-0.1C345.2,234.6,345,235.2,344.9,235.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M343.7,239.7l0.5,0.2c0.2-0.6,0.4-1.3,0.6-1.9l-0.5-0.1C344.1,238.4,343.9,239.1,343.7,239.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M330.3,145c0.4,0.6,0.7,1.1,1.1,1.7l0.4-0.3c-0.4-0.6-0.7-1.1-1.1-1.7L330.3,145z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M348.8,205.1c0,0.4,0,0.8,0,1.2c0,0.7,0,1.3,0,2l0.5,0c0-0.7,0-1.3,0-2c0-0.4,0-0.8,0-1.2L348.8,205.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M347.2,187.2l0.5-0.1c-0.1-0.7-0.2-1.3-0.4-2l-0.5,0.1C347,185.9,347.1,186.6,347.2,187.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M348.7,212.3l0.5,0c0-0.7,0.1-1.3,0.1-2l-0.5,0C348.8,211,348.7,211.6,348.7,212.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M348.4,216.3l0.5,0c0.1-0.7,0.1-1.3,0.2-2l-0.5,0C348.5,215,348.5,215.6,348.4,216.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M342.4,243.5l0.5,0.2c0.2-0.6,0.4-1.3,0.7-1.9l-0.5-0.2C342.9,242.2,342.7,242.9,342.4,243.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M334.1,261.6l0.4,0.2c0.3-0.6,0.7-1.2,1-1.7l-0.4-0.2C334.7,260.5,334.4,261.1,334.1,261.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M336,258.1l0.4,0.2c0.3-0.6,0.6-1.2,0.9-1.8l-0.4-0.2C336.6,257,336.3,257.6,336,258.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M334.5,151.7c0.3,0.6,0.6,1.2,1,1.7l0.4-0.2c-0.3-0.6-0.6-1.2-1-1.7L334.5,151.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M332.5,148.3c0.3,0.6,0.7,1.1,1,1.7l0.4-0.3c-0.3-0.6-0.7-1.1-1-1.7L332.5,148.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M332,265.1l0.4,0.3c0.4-0.6,0.7-1.1,1.1-1.7l-0.4-0.3C332.7,263.9,332.3,264.5,332,265.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M336.4,155.2c0.3,0.6,0.6,1.2,0.9,1.8l0.4-0.2c-0.3-0.6-0.6-1.2-0.9-1.8L336.4,155.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M339.5,250.9l0.5,0.2c0.3-0.6,0.5-1.2,0.8-1.8l-0.5-0.2C340,249.7,339.8,250.3,339.5,250.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M341,247.3l0.5,0.2c0.2-0.6,0.5-1.2,0.7-1.9l-0.5-0.2C341.5,246,341.3,246.6,341,247.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M338.2,158.8c0.3,0.6,0.6,1.2,0.8,1.8l0.5-0.2c-0.3-0.6-0.6-1.2-0.8-1.8L338.2,158.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M337.8,254.6l0.4,0.2c0.3-0.6,0.6-1.2,0.9-1.8l-0.5-0.2C338.4,253.4,338.1,254,337.8,254.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M348,220.2l0.5,0.1c0.1-0.7,0.2-1.3,0.2-2l-0.5-0.1C348.1,218.9,348.1,219.6,348,220.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M243.2,95.7c0.7,0,1.3,0.1,2,0.1l0-0.5c-0.7,0-1.3-0.1-2-0.1L243.2,95.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M247.2,96c0.7,0.1,1.3,0.1,2,0.2l0-0.5c-0.7-0.1-1.3-0.1-2-0.2L247.2,96z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M246.4,316.7l0,0.5c0.7,0,1.3-0.1,2-0.2l0-0.5C247.8,316.6,247.1,316.7,246.4,316.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M242.5,316.9l0,0.5c0.7,0,1.3-0.1,2-0.1l0-0.5C243.8,316.9,243.1,316.9,242.5,316.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M239.2,95.6c0.7,0,1.3,0,2,0l0-0.5c-0.7,0-1.3,0-2,0L239.2,95.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M255.1,96.9c0.7,0.1,1.3,0.2,2,0.3l0.1-0.5c-0.7-0.1-1.3-0.2-2-0.3L255.1,96.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M250.4,316.3l0.1,0.5c0.7-0.1,1.3-0.2,2-0.2l-0.1-0.5C251.7,316.2,251.1,316.3,250.4,316.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M238.5,317l0,0.5c0.7,0,1.3,0,2,0l0-0.5C239.8,317,239.1,317,238.5,317z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M254.4,315.8l0.1,0.5c0.7-0.1,1.3-0.2,2-0.3l-0.1-0.5C255.7,315.6,255,315.7,254.4,315.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M251.2,96.4c0.7,0.1,1.3,0.2,2,0.2l0.1-0.5c-0.7-0.1-1.3-0.2-2-0.3L251.2,96.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M341,164.1c-0.3-0.6-0.5-1.2-0.8-1.8l-0.5,0.2c0.3,0.6,0.5,1.2,0.8,1.8L341,164.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M343.8,171.6c-0.2-0.6-0.4-1.3-0.6-1.9l-0.5,0.2c0.2,0.6,0.4,1.3,0.6,1.9L343.8,171.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M345,175.4c-0.2-0.6-0.4-1.3-0.6-1.9l-0.5,0.1c0.2,0.6,0.4,1.3,0.6,1.9L345,175.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M342.5,167.8c-0.2-0.6-0.5-1.3-0.7-1.9l-0.5,0.2c0.2,0.6,0.5,1.2,0.7,1.9L342.5,167.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M346.5,183.3l0.5-0.1c-0.1-0.7-0.3-1.3-0.4-2l-0.5,0.1C346.2,182,346.3,182.6,346.5,183.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M235.2,95.2l0,0.5c0.7,0,1.3,0,2,0l0-0.5C236.5,95.1,235.9,95.1,235.2,95.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M298.7,299l0.3,0.4c0.6-0.4,1.1-0.7,1.7-1.1l-0.3-0.4C299.8,298.2,299.3,298.6,298.7,299z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M259,97.6c0.7,0.1,1.3,0.3,2,0.4l0.1-0.5c-0.7-0.1-1.3-0.3-2-0.4L259,97.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M234.5,317.4c0.7,0,1.3,0,2,0l0-0.5c-0.7,0-1.3,0-2,0L234.5,317.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M231.2,95.3l0,0.5c0.7,0,1.3-0.1,2-0.1l0-0.5C232.5,95.3,231.9,95.3,231.2,95.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M230.5,317.2c0.7,0,1.3,0.1,2,0.1l0-0.5c-0.7,0-1.3-0.1-2-0.1L230.5,317.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M346,179.3c-0.2-0.6-0.3-1.3-0.5-1.9l-0.5,0.1c0.2,0.6,0.3,1.3,0.5,1.9L346,179.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M285.6,106.3c0.6,0.3,1.2,0.6,1.8,0.9l0.2-0.4c-0.6-0.3-1.2-0.6-1.8-0.9L285.6,106.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M289.2,108c0.6,0.3,1.2,0.6,1.8,0.9l0.2-0.4c-0.6-0.3-1.2-0.6-1.8-0.9L289.2,108z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M288.4,305l0.2,0.4c0.6-0.3,1.2-0.6,1.8-0.9l-0.2-0.4C289.6,304.4,289,304.7,288.4,305z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M281.2,308.3l0.2,0.5c0.6-0.3,1.2-0.5,1.8-0.8l-0.2-0.5C282.4,307.8,281.8,308.1,281.2,308.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M281.9,104.6c0.6,0.3,1.2,0.5,1.8,0.8l0.2-0.5c-0.6-0.3-1.2-0.5-1.8-0.8L281.9,104.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M284.8,306.7l0.2,0.5c0.6-0.3,1.2-0.6,1.8-0.9l-0.2-0.4C286,306.1,285.4,306.4,284.8,306.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M296.1,112c0.6,0.3,1.1,0.7,1.7,1.1l0.3-0.4c-0.6-0.4-1.1-0.7-1.7-1.1L296.1,112z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M295.4,301.1l0.3,0.4c0.6-0.3,1.1-0.7,1.7-1.1l-0.3-0.4C296.5,300.4,295.9,300.8,295.4,301.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M292.7,110c0.6,0.3,1.2,0.7,1.7,1l0.3-0.4c-0.6-0.3-1.2-0.7-1.7-1L292.7,110z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M291.9,303.1l0.2,0.4c0.6-0.3,1.2-0.7,1.7-1l-0.3-0.4C293.1,302.4,292.5,302.8,291.9,303.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M262.2,314.4l0.1,0.5c0.7-0.1,1.3-0.3,2-0.5l-0.1-0.5C263.5,314.1,262.9,314.2,262.2,314.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M266.1,313.4l0.1,0.5c0.6-0.2,1.3-0.3,1.9-0.5l-0.1-0.5C267.4,313.1,266.7,313.3,266.1,313.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M269.9,312.4l0.1,0.5c0.6-0.2,1.3-0.4,1.9-0.6l-0.2-0.5C271.2,312,270.6,312.2,269.9,312.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M266.8,99.4c0.6,0.2,1.3,0.3,1.9,0.5l0.1-0.5c-0.6-0.2-1.3-0.4-1.9-0.5L266.8,99.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M278.2,103.1c0.6,0.2,1.2,0.5,1.9,0.7l0.2-0.5c-0.6-0.3-1.2-0.5-1.9-0.7L278.2,103.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M262.9,98.4c0.6,0.1,1.3,0.3,1.9,0.5l0.1-0.5c-0.6-0.2-1.3-0.3-1.9-0.5L262.9,98.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M274.5,101.7c0.6,0.2,1.3,0.4,1.9,0.7l0.2-0.5c-0.6-0.2-1.3-0.5-1.9-0.7L274.5,101.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M277.5,309.8l0.2,0.5c0.6-0.2,1.2-0.5,1.9-0.7l-0.2-0.5C278.7,309.3,278.1,309.6,277.5,309.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M270.7,100.5c0.6,0.2,1.3,0.4,1.9,0.6l0.2-0.5c-0.6-0.2-1.3-0.4-1.9-0.6L270.7,100.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M273.7,311.2l0.2,0.5c0.6-0.2,1.3-0.4,1.9-0.7l-0.2-0.5C275,310.7,274.4,310.9,273.7,311.2z"
              />
            </g>
            {meterPoints === 6 && (
              <g id="Circle4">
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M180.6,139.5l0.3,0.4c0.5-0.4,1-0.9,1.5-1.3l-0.3-0.4C181.6,138.6,181.1,139,180.6,139.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M164,254.1c0.4,0.6,0.7,1.1,1.1,1.7l0.4-0.3c-0.4-0.5-0.7-1.1-1.1-1.7L164,254.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M177.6,142.2l0.3,0.4c0.5-0.5,1-0.9,1.5-1.4l-0.3-0.4C178.6,141.2,178.1,141.7,177.6,142.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M182.7,274.9c0.5,0.4,1,0.8,1.6,1.2l0.3-0.4c-0.5-0.4-1-0.8-1.6-1.2L182.7,274.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M186.9,134.5l0.3,0.4c0.5-0.4,1.1-0.8,1.6-1.1l-0.3-0.4C188,133.7,187.4,134.1,186.9,134.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M185.8,277.3c0.5,0.4,1.1,0.8,1.6,1.2l0.3-0.4c-0.5-0.4-1.1-0.8-1.6-1.2L185.8,277.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M183.7,136.9l0.3,0.4c0.5-0.4,1-0.8,1.6-1.2l-0.3-0.4C184.7,136.1,184.2,136.5,183.7,136.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M179.6,272.3c0.5,0.4,1,0.9,1.5,1.3l0.3-0.4c-0.5-0.4-1-0.9-1.5-1.3L179.6,272.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M169.5,151l0.4,0.3c0.4-0.5,0.8-1,1.3-1.5l-0.4-0.3C170.3,149.9,169.9,150.5,169.5,151z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M167,154.2l0.4,0.3c0.4-0.5,0.8-1.1,1.2-1.6l-0.4-0.3C167.8,153.1,167.4,153.6,167,154.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M168.6,260.6c0.4,0.5,0.8,1,1.3,1.6l0.4-0.3c-0.4-0.5-0.8-1-1.2-1.6L168.6,260.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M166.2,257.4c0.4,0.5,0.8,1.1,1.2,1.6l0.4-0.3c-0.4-0.5-0.8-1.1-1.2-1.6L166.2,257.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M173.9,266.7c0.5,0.5,0.9,1,1.4,1.4l0.4-0.4c-0.5-0.5-0.9-1-1.4-1.4L173.9,266.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M174.8,145l0.4,0.3c0.5-0.5,0.9-0.9,1.4-1.4l-0.4-0.4C175.7,144,175.2,144.5,174.8,145z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M172,147.9l0.4,0.3c0.4-0.5,0.9-1,1.3-1.5l-0.4-0.3C172.9,146.9,172.5,147.4,172,147.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M171.2,263.7c0.4,0.5,0.9,1,1.3,1.5l0.4-0.3c-0.4-0.5-0.9-1-1.3-1.5L171.2,263.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M176.7,269.6c0.5,0.5,1,0.9,1.5,1.4l0.3-0.4c-0.5-0.5-1-0.9-1.4-1.4L176.7,269.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M211.9,122.1l0.1,0.5c0.6-0.2,1.3-0.4,1.9-0.6l-0.1-0.5C213.2,121.7,212.5,121.9,211.9,122.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M204.3,124.8l0.2,0.5c0.6-0.3,1.2-0.5,1.8-0.7l-0.2-0.5C205.6,124.3,205,124.6,204.3,124.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M208.1,123.4l0.2,0.5c0.6-0.2,1.3-0.4,1.9-0.7l-0.2-0.5C209.3,122.9,208.7,123.1,208.1,123.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M206.9,288.8c0.6,0.2,1.3,0.5,1.9,0.7l0.2-0.5c-0.6-0.2-1.3-0.5-1.9-0.7L206.9,288.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M210.7,290.2c0.6,0.2,1.3,0.4,1.9,0.6l0.1-0.5c-0.6-0.2-1.3-0.4-1.9-0.6L210.7,290.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M218.5,292.3c0.7,0.1,1.3,0.3,2,0.4l0.1-0.5c-0.7-0.1-1.3-0.3-1.9-0.4L218.5,292.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M214.6,291.3c0.6,0.2,1.3,0.3,1.9,0.5l0.1-0.5c-0.6-0.2-1.3-0.3-1.9-0.5L214.6,291.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M215.7,121l0.1,0.5c0.6-0.2,1.3-0.3,1.9-0.5l-0.1-0.5C217,120.6,216.4,120.8,215.7,121z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M203.2,287.3c0.6,0.3,1.2,0.5,1.9,0.8l0.2-0.5c-0.6-0.2-1.2-0.5-1.8-0.8L203.2,287.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M196,283.8c0.6,0.3,1.2,0.6,1.8,0.9l0.2-0.4c-0.6-0.3-1.2-0.6-1.8-0.9L196,283.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M193.6,130.2l0.3,0.4c0.6-0.3,1.1-0.7,1.7-1l-0.2-0.4C194.8,129.5,194.2,129.8,193.6,130.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M192.5,281.8c0.6,0.3,1.1,0.7,1.7,1l0.2-0.4c-0.6-0.3-1.2-0.7-1.7-1L192.5,281.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M190.2,132.3l0.3,0.4c0.6-0.4,1.1-0.7,1.7-1.1l-0.3-0.4C191.3,131.5,190.8,131.9,190.2,132.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M200.7,126.4l0.2,0.5c0.6-0.3,1.2-0.6,1.8-0.8l-0.2-0.5C201.9,125.9,201.3,126.2,200.7,126.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M219.6,120.1l0.1,0.5c0.6-0.1,1.3-0.3,2-0.4l-0.1-0.5C220.9,119.8,220.3,119.9,219.6,120.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M197.1,128.2l0.2,0.4c0.6-0.3,1.2-0.6,1.8-0.9l-0.2-0.4C198.3,127.6,197.7,127.9,197.1,128.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M199.6,285.7c0.6,0.3,1.2,0.6,1.8,0.9l0.2-0.5c-0.6-0.3-1.2-0.6-1.8-0.9L199.6,285.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M189.1,279.6c0.6,0.4,1.1,0.7,1.7,1.1l0.3-0.4c-0.6-0.4-1.1-0.7-1.7-1.1L189.1,279.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M160.1,166.3l-0.4-0.2c-0.3,0.6-0.6,1.2-0.9,1.8l0.5,0.2C159.5,167.5,159.8,166.9,160.1,166.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M162,162.8l-0.4-0.2c-0.3,0.6-0.7,1.2-1,1.8l0.4,0.2C161.3,164,161.6,163.4,162,162.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M164,159.4l-0.4-0.3c-0.4,0.6-0.7,1.1-1.1,1.7l0.4,0.3C163.3,160.5,163.7,160,164,159.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M166.3,156.1l-0.4-0.3c-0.4,0.5-0.8,1.1-1.1,1.7l0.4,0.3C165.5,157.2,165.9,156.6,166.3,156.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M321,176c-0.2-0.6-0.5-1.3-0.7-1.9l-0.5,0.2c0.2,0.6,0.5,1.2,0.7,1.9L321,176z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M155.3,177.3l-0.5-0.2c-0.2,0.6-0.4,1.3-0.6,1.9l0.5,0.2C154.9,178.6,155.1,178,155.3,177.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M158.3,169.9l-0.5-0.2c-0.3,0.6-0.5,1.2-0.8,1.8l0.5,0.2C157.8,171.1,158.1,170.5,158.3,169.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M156.8,173.6l-0.5-0.2c-0.2,0.6-0.5,1.2-0.7,1.9l0.5,0.2C156.3,174.8,156.5,174.2,156.8,173.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M325.2,195.5l0.5-0.1c-0.1-0.7-0.2-1.3-0.3-2l-0.5,0.1C325,194.2,325.1,194.9,325.2,195.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M325.6,199.5l0.5,0c-0.1-0.7-0.1-1.3-0.2-2l-0.5,0C325.5,198.2,325.6,198.8,325.6,199.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M322.3,179.8c-0.2-0.6-0.4-1.3-0.6-1.9l-0.5,0.2c0.2,0.6,0.4,1.3,0.6,1.9L322.3,179.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M325.8,203.5l0.5,0c0-0.7-0.1-1.3-0.1-2l-0.5,0C325.8,202.2,325.8,202.8,325.8,203.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M154.1,181.1l-0.5-0.1c-0.2,0.6-0.4,1.3-0.6,1.9l0.5,0.1C153.7,182.4,153.9,181.8,154.1,181.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M323.4,183.7c-0.2-0.6-0.4-1.3-0.5-1.9l-0.5,0.1c0.2,0.6,0.4,1.3,0.5,1.9L323.4,183.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M324.4,187.6c-0.1-0.7-0.3-1.3-0.4-2l-0.5,0.1c0.2,0.6,0.3,1.3,0.4,1.9L324.4,187.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M324.6,191.6l0.5-0.1c-0.1-0.7-0.2-1.3-0.4-2l-0.5,0.1C324.4,190.3,324.5,190.9,324.6,191.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M152.3,224.5l-0.5,0.1c0.1,0.7,0.3,1.3,0.4,2l0.5-0.1C152.6,225.8,152.5,225.2,152.3,224.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M153.9,232.4c0.2,0.6,0.4,1.3,0.6,1.9l0.5-0.2c-0.2-0.6-0.4-1.3-0.6-1.9L153.9,232.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M151.6,220.6l-0.5,0.1c0.1,0.7,0.2,1.3,0.3,2l0.5-0.1C151.8,221.9,151.7,221.3,151.6,220.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M161.9,250.7c0.3,0.6,0.7,1.1,1,1.7l0.4-0.3c-0.3-0.6-0.7-1.1-1-1.7L161.9,250.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M155.1,236.2c0.2,0.6,0.5,1.3,0.7,1.9l0.5-0.2c-0.2-0.6-0.5-1.2-0.7-1.9L155.1,236.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M152.8,228.5c0.2,0.6,0.3,1.3,0.5,1.9l0.5-0.1c-0.2-0.6-0.4-1.3-0.5-1.9L152.8,228.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M160,247.2c0.3,0.6,0.6,1.2,0.9,1.8l0.4-0.2c-0.3-0.6-0.6-1.2-0.9-1.8L160,247.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M158.2,243.6c0.3,0.6,0.6,1.2,0.9,1.8l0.4-0.2c-0.3-0.6-0.6-1.2-0.9-1.8L158.2,243.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M156.6,239.9c0.3,0.6,0.5,1.2,0.8,1.8l0.5-0.2c-0.3-0.6-0.5-1.2-0.8-1.8L156.6,239.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M150.7,212.7l-0.5,0c0,0.7,0.1,1.3,0.2,2l0.5,0C150.8,214,150.7,213.4,150.7,212.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M150.6,200.7l-0.5,0c0,0.7-0.1,1.3-0.1,2l0.5,0C150.5,202.1,150.6,201.4,150.6,200.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M151,196.8l-0.5-0.1c-0.1,0.7-0.1,1.3-0.2,2l0.5,0C150.8,198.1,150.9,197.4,151,196.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M151.5,192.8l-0.5-0.1c-0.1,0.7-0.2,1.3-0.3,2l0.5,0.1C151.3,194.1,151.4,193.5,151.5,192.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M150.4,206.3c0-0.5,0-1.1,0-1.6l-0.5,0c0,0.5,0,1.1,0,1.6l0,0.4l0.5,0L150.4,206.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M153.1,185l-0.5-0.1c-0.2,0.6-0.3,1.3-0.5,2l0.5,0.1C152.7,186.3,152.9,185.6,153.1,185z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M150.5,208.7l-0.5,0c0,0.7,0,1.3,0.1,2l0.5,0C150.5,210,150.5,209.4,150.5,208.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M151.1,216.7l-0.5,0.1c0.1,0.7,0.2,1.3,0.3,2l0.5-0.1C151.2,218,151.1,217.3,151.1,216.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M152.2,188.9l-0.5-0.1c-0.1,0.7-0.3,1.3-0.4,2l0.5,0.1C151.9,190.2,152.1,189.5,152.2,188.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M304.9,263.2l0.4,0.3c0.4-0.5,0.9-1,1.3-1.5l-0.4-0.3C305.8,262.2,305.4,262.7,304.9,263.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M302.3,266.2l0.4,0.3c0.5-0.5,0.9-1,1.4-1.5l-0.4-0.3C303.2,265.2,302.7,265.7,302.3,266.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M303.2,147.4c0.4,0.5,0.9,1,1.3,1.5l0.4-0.3c-0.4-0.5-0.9-1-1.3-1.5L303.2,147.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M307.5,260.1l0.4,0.3c0.4-0.5,0.8-1.1,1.2-1.6l-0.4-0.3C308.3,259,307.9,259.6,307.5,260.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M305.8,150.4c0.4,0.5,0.8,1,1.3,1.5l0.4-0.3c-0.4-0.5-0.8-1-1.3-1.6L305.8,150.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M308.2,153.6c0.4,0.5,0.8,1.1,1.2,1.6l0.4-0.3c-0.4-0.5-0.8-1.1-1.2-1.6L308.2,153.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M311,156.5l-0.4,0.3c0.4,0.5,0.7,1.1,1.1,1.7l0.4-0.3C311.7,157.6,311.4,157.1,311,156.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M309.8,256.9l0.4,0.3c0.4-0.5,0.8-1.1,1.1-1.7l-0.4-0.3C310.6,255.8,310.2,256.3,309.8,256.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M293.6,274.3l0.3,0.4c0.5-0.4,1-0.9,1.5-1.3l-0.3-0.4C294.6,273.5,294.1,273.9,293.6,274.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M300.4,144.5c0.5,0.5,0.9,0.9,1.4,1.4l0.4-0.3c-0.5-0.5-0.9-1-1.4-1.4L300.4,144.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M312.1,253.6l0.4,0.3c0.4-0.6,0.7-1.1,1.1-1.7l-0.4-0.3C312.8,252.4,312.4,253,312.1,253.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M290.4,276.8l0.3,0.4c0.5-0.4,1.1-0.8,1.6-1.2l-0.3-0.4C291.5,276,290.9,276.4,290.4,276.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M294.6,139.1c0.5,0.4,1,0.9,1.5,1.3l0.3-0.4c-0.5-0.4-1-0.9-1.5-1.3L294.6,139.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M291.4,136.6c0.5,0.4,1.1,0.8,1.6,1.2l0.3-0.4c-0.5-0.4-1-0.8-1.6-1.2L291.4,136.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M299.5,269l0.3,0.4c0.5-0.5,1-0.9,1.4-1.4l-0.4-0.3C300.4,268.1,300,268.5,299.5,269z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M297.5,141.8c0.5,0.5,1,0.9,1.5,1.4l0.3-0.4c-0.5-0.5-1-0.9-1.5-1.4L297.5,141.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M296.6,271.7l0.3,0.4c0.5-0.4,1-0.9,1.5-1.4l-0.3-0.4C297.6,270.8,297.1,271.3,296.6,271.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M319.4,239.4l0.5,0.2c0.3-0.6,0.5-1.2,0.7-1.9l-0.5-0.2C319.9,238.2,319.7,238.8,319.4,239.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M323.2,228l0.5,0.1c0.2-0.6,0.3-1.3,0.5-1.9l-0.5-0.1C323.5,226.7,323.3,227.4,323.2,228z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M222.4,293.1c0.7,0.1,1.3,0.2,2,0.3l0.1-0.5c-0.7-0.1-1.3-0.2-2-0.3L222.4,293.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M320.8,235.7l0.5,0.2c0.2-0.6,0.4-1.3,0.7-1.9l-0.5-0.2C321.3,234.4,321.1,235,320.8,235.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M322.1,231.9l0.5,0.1c0.2-0.6,0.4-1.3,0.6-1.9l-0.5-0.1C322.5,230.6,322.3,231.2,322.1,231.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M324.8,220.2l0.5,0.1c0.1-0.7,0.2-1.3,0.3-2l-0.5-0.1C325,218.9,324.9,219.6,324.8,220.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M325.9,205.5c0,0.3,0,0.6,0,0.8c0,0.7,0,1.3,0,2l0.5,0c0-0.7,0-1.3,0-2c0-0.3,0-0.6,0-0.8L325.9,205.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M325.3,216.3l0.5,0.1c0.1-0.7,0.1-1.3,0.2-2l-0.5,0C325.5,214.9,325.4,215.6,325.3,216.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M325.7,212.3l0.5,0c0-0.7,0.1-1.3,0.1-2l-0.5,0C325.8,211,325.7,211.6,325.7,212.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M315.2,163.3l-0.4,0.2c0.3,0.6,0.6,1.2,1,1.7l0.4-0.2C315.8,164.5,315.5,163.9,315.2,163.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M316.1,246.7l0.4,0.2c0.3-0.6,0.6-1.2,0.9-1.8l-0.4-0.2C316.7,245.5,316.4,246.1,316.1,246.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M288.2,134.3c0.5,0.4,1.1,0.8,1.6,1.2l0.3-0.4c-0.5-0.4-1.1-0.8-1.6-1.2L288.2,134.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M314.1,250.2l0.4,0.3c0.3-0.6,0.7-1.2,1-1.8l-0.4-0.2C314.8,249,314.5,249.6,314.1,250.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M313.2,159.9l-0.4,0.3c0.3,0.6,0.7,1.1,1,1.7l0.4-0.3C313.9,161,313.5,160.4,313.2,159.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M318.8,170.5l-0.5,0.2c0.3,0.6,0.5,1.2,0.8,1.8l0.5-0.2C319.3,171.7,319.1,171.1,318.8,170.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M317.8,243.1l0.5,0.2c0.3-0.6,0.6-1.2,0.8-1.8l-0.5-0.2C318.4,241.9,318.1,242.5,317.8,243.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M317.1,166.9l-0.4,0.2c0.3,0.6,0.6,1.2,0.9,1.8l0.5-0.2C317.7,168,317.4,167.4,317.1,166.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M324.1,224.1l0.5,0.1c0.1-0.7,0.3-1.3,0.4-2l-0.5-0.1C324.3,222.8,324.2,223.5,324.1,224.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M247.5,119.1c0.7,0.1,1.3,0.1,2,0.2l0.1-0.5c-0.7-0.1-1.3-0.2-2-0.2L247.5,119.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M243.5,118.8c0.7,0,1.3,0.1,2,0.1l0-0.5c-0.7-0.1-1.3-0.1-2-0.1L243.5,118.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M246.3,293.7l0,0.5c0.7-0.1,1.3-0.1,2-0.2l-0.1-0.5C247.7,293.5,247,293.6,246.3,293.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M287.2,279.1l0.3,0.4c0.6-0.4,1.1-0.8,1.6-1.1l-0.3-0.4C288.3,278.3,287.7,278.7,287.2,279.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M250.3,293.2l0.1,0.5c0.7-0.1,1.3-0.2,2-0.3l-0.1-0.5C251.6,293,250.9,293.1,250.3,293.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M254.2,292.6l0.1,0.5c0.7-0.1,1.3-0.3,2-0.4l-0.1-0.5C255.5,292.3,254.9,292.4,254.2,292.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M251.5,119.6c0.7,0.1,1.3,0.2,2,0.3l0.1-0.5c-0.7-0.1-1.3-0.2-2-0.3L251.5,119.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M255.4,120.3c0.7,0.1,1.3,0.3,2,0.4l0.1-0.5c-0.7-0.1-1.3-0.3-2-0.4L255.4,120.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M239.5,118.6c0.7,0,1.3,0,2,0.1l0-0.5c-0.7,0-1.3,0-2-0.1L239.5,118.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M227.5,118.7l0.1,0.5c0.7-0.1,1.3-0.2,2-0.2l0-0.5C228.9,118.6,228.2,118.7,227.5,118.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M230.4,294.2c0.7,0.1,1.3,0.1,2,0.2l0-0.5c-0.7,0-1.3-0.1-2-0.2L230.4,294.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M226.4,293.7c0.7,0.1,1.3,0.2,2,0.2l0.1-0.5c-0.7-0.1-1.3-0.2-2-0.2L226.4,293.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M238.4,294l0,0.5c0.7,0,1.3,0,2,0l0-0.5C239.7,294,239,294,238.4,294z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M223.6,119.3l0.1,0.5c0.7-0.1,1.3-0.2,2-0.3l-0.1-0.5C224.9,119.1,224.2,119.2,223.6,119.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M231.5,118.3l0,0.5c0.7,0,1.3-0.1,2-0.1l0-0.5C232.9,118.3,232.2,118.3,231.5,118.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M235.5,118.1l0,0.5c0.7,0,1.3,0,2,0l0-0.5C236.9,118.1,236.2,118.1,235.5,118.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M234.4,294.4c0.7,0,1.3,0,2,0.1l0-0.5c-0.7,0-1.3,0-2-0.1L234.4,294.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M242.3,293.9l0,0.5c0.7,0,1.3-0.1,2-0.1l0-0.5C243.7,293.9,243,293.9,242.3,293.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M273.2,286.7l0.2,0.5c0.6-0.3,1.2-0.5,1.8-0.8l-0.2-0.5C274.4,286.2,273.8,286.5,273.2,286.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M278,128.1c0.6,0.3,1.2,0.6,1.8,0.9l0.2-0.4c-0.6-0.3-1.2-0.6-1.8-0.9L278,128.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M280.4,283.2l0.2,0.4c0.6-0.3,1.2-0.6,1.7-1l-0.3-0.4C281.5,282.6,281,282.9,280.4,283.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M258.1,291.7l0.1,0.5c0.7-0.2,1.3-0.3,1.9-0.5l-0.1-0.5C259.4,291.4,258.8,291.6,258.1,291.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M276.8,285.1l0.2,0.4c0.6-0.3,1.2-0.6,1.8-0.9l-0.2-0.4C278,284.5,277.4,284.8,276.8,285.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M284.9,132.1c0.6,0.4,1.1,0.7,1.7,1.1l0.3-0.4c-0.6-0.4-1.1-0.7-1.7-1.1L284.9,132.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M283.8,281.2l0.3,0.4c0.6-0.3,1.1-0.7,1.7-1.1l-0.3-0.4C284.9,280.5,284.4,280.9,283.8,281.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M281.5,130c0.6,0.3,1.2,0.7,1.7,1l0.3-0.4c-0.6-0.3-1.2-0.7-1.7-1L281.5,130z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M274.3,126.4c0.6,0.3,1.2,0.6,1.8,0.8l0.2-0.5c-0.6-0.3-1.2-0.6-1.8-0.9L274.3,126.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M262,290.7l0.1,0.5c0.6-0.2,1.3-0.4,1.9-0.6l-0.1-0.5C263.3,290.4,262.6,290.6,262,290.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M259.3,121.2c0.6,0.2,1.3,0.3,1.9,0.5l0.1-0.5c-0.6-0.2-1.3-0.3-1.9-0.5L259.3,121.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M263.1,122.2c0.6,0.2,1.3,0.4,1.9,0.6l0.2-0.5c-0.6-0.2-1.3-0.4-1.9-0.6L263.1,122.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M269.6,288.2l0.2,0.5c0.6-0.2,1.2-0.5,1.9-0.7l-0.2-0.5C270.8,287.8,270.2,288,269.6,288.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M270.7,124.8c0.6,0.2,1.2,0.5,1.8,0.8l0.2-0.5c-0.6-0.3-1.2-0.5-1.9-0.8L270.7,124.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M265.8,289.6l0.2,0.5c0.6-0.2,1.3-0.4,1.9-0.7l-0.2-0.5C267.1,289.2,266.4,289.4,265.8,289.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M266.9,123.4c0.6,0.2,1.3,0.4,1.9,0.7l0.2-0.5c-0.6-0.2-1.3-0.5-1.9-0.7L266.9,123.4z"
                />
              </g>
            )}
            <g id="Circle3">
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M193.1,251.8c0.5,0.5,1,0.9,1.4,1.4l0.3-0.4c-0.5-0.5-1-0.9-1.4-1.4L193.1,251.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M191.1,162.9l0.4,0.3c0.5-0.5,0.9-1,1.4-1.4l-0.4-0.4C192,161.9,191.5,162.4,191.1,162.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M190.3,248.9c0.4,0.5,0.9,1,1.4,1.5l0.4-0.3c-0.5-0.5-0.9-1-1.3-1.5L190.3,248.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M196.9,157.3l0.3,0.4c0.5-0.4,1-0.8,1.5-1.3l-0.3-0.4C197.9,156.5,197.4,156.9,196.9,157.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M193.9,160l0.3,0.4c0.5-0.5,1-0.9,1.5-1.4l-0.3-0.4C194.9,159.1,194.4,159.6,193.9,160z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M196,254.6c0.5,0.4,1,0.9,1.5,1.3l0.3-0.4c-0.5-0.4-1-0.9-1.5-1.3L196,254.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M199.1,257.1c0.5,0.4,1.1,0.8,1.6,1.2l0.3-0.4c-0.5-0.4-1.1-0.8-1.6-1.2L199.1,257.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M185.4,242.6c0.4,0.6,0.8,1.1,1.2,1.6l0.4-0.3c-0.4-0.5-0.8-1.1-1.2-1.6L185.4,242.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M183.2,239.3c0.3,0.6,0.7,1.1,1.1,1.7l0.4-0.3c-0.4-0.6-0.7-1.1-1.1-1.7L183.2,239.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M183.8,172.5l0.4,0.3c0.4-0.6,0.7-1.1,1.1-1.7l-0.4-0.3C184.5,171.3,184.1,171.9,183.8,172.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M187.8,245.8c0.4,0.5,0.8,1,1.3,1.6l0.4-0.3c-0.4-0.5-0.8-1-1.3-1.5L187.8,245.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M186,169.1l0.4,0.3c0.4-0.5,0.8-1.1,1.2-1.6l-0.4-0.3C186.8,168,186.4,168.6,186,169.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M188.5,165.9l0.4,0.3c0.4-0.5,0.8-1,1.3-1.5l-0.4-0.3C189.3,164.9,188.9,165.4,188.5,165.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M213.9,147l0.2,0.5c0.6-0.3,1.2-0.5,1.9-0.7l-0.2-0.5C215.2,146.5,214.6,146.7,213.9,147z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M213,265.2c0.6,0.3,1.2,0.5,1.9,0.8l0.2-0.5c-0.6-0.2-1.2-0.5-1.8-0.8L213,265.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M210.3,148.6l0.2,0.5c0.6-0.3,1.2-0.6,1.8-0.8l-0.2-0.5C211.5,148.1,210.9,148.3,210.3,148.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M200,154.9l0.3,0.4c0.5-0.4,1.1-0.8,1.6-1.2l-0.3-0.4C201.1,154.1,200.6,154.5,200,154.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M221.6,144.4l0.1,0.5c0.6-0.2,1.3-0.3,1.9-0.5l-0.1-0.5C222.8,144.1,222.2,144.3,221.6,144.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M217.7,145.6l0.2,0.5c0.6-0.2,1.3-0.4,1.9-0.6l-0.1-0.5C219,145.2,218.3,145.4,217.7,145.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M216.7,266.7c0.6,0.2,1.3,0.4,1.9,0.6l0.2-0.5c-0.6-0.2-1.3-0.4-1.9-0.6L216.7,266.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M202.4,259.5c0.6,0.4,1.1,0.7,1.7,1.1l0.3-0.4c-0.6-0.4-1.1-0.7-1.7-1.1L202.4,259.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M203.3,152.6l0.3,0.4c0.6-0.4,1.1-0.7,1.7-1.1l-0.3-0.4C204.4,151.8,203.9,152.2,203.3,152.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M206.7,150.5l0.2,0.4c0.6-0.3,1.2-0.6,1.7-0.9l-0.2-0.4C207.9,149.8,207.3,150.2,206.7,150.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M205.8,261.6c0.6,0.3,1.2,0.7,1.8,1l0.2-0.4c-0.6-0.3-1.2-0.6-1.7-1L205.8,261.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M209.3,263.5c0.6,0.3,1.2,0.6,1.8,0.9l0.2-0.5c-0.6-0.3-1.2-0.6-1.8-0.9L209.3,263.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M220.6,267.9c0.6,0.2,1.3,0.4,1.9,0.5l0.1-0.5c-0.6-0.2-1.3-0.3-1.9-0.5L220.6,267.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M179.6,181.6l-0.5-0.2c-0.3,0.6-0.5,1.2-0.8,1.9l0.5,0.2C179.1,182.8,179.4,182.2,179.6,181.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M181.3,177.9l-0.4-0.2c-0.3,0.6-0.6,1.2-0.9,1.8l0.5,0.2C180.7,179.1,181,178.5,181.3,177.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M296.6,180c-0.3-0.6-0.6-1.2-0.9-1.8l-0.4,0.2c0.3,0.6,0.6,1.2,0.8,1.8L296.6,180z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M177,189.1l-0.5-0.1c-0.2,0.6-0.4,1.3-0.5,1.9l0.5,0.1C176.6,190.4,176.8,189.7,177,189.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M178.2,185.3l-0.5-0.2c-0.2,0.6-0.4,1.3-0.6,1.9l0.5,0.2C177.7,186.6,178,185.9,178.2,185.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M176,193l-0.5-0.1c-0.1,0.7-0.3,1.3-0.4,2l0.5,0.1C175.7,194.3,175.9,193.6,176,193z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M298.1,183.7c-0.2-0.6-0.5-1.2-0.7-1.9l-0.5,0.2c0.3,0.6,0.5,1.2,0.7,1.9L298.1,183.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M301.6,203.3l0.5,0c0-0.7-0.1-1.3-0.1-2l-0.5,0C301.6,202,301.6,202.7,301.6,203.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M301.3,199.4l0.5-0.1c-0.1-0.7-0.2-1.3-0.2-2l-0.5,0.1C301.2,198.1,301.3,198.7,301.3,199.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M300.5,191.4c-0.2-0.7-0.3-1.3-0.5-1.9l-0.5,0.1c0.2,0.6,0.3,1.3,0.5,1.9L300.5,191.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M299.4,187.5c-0.2-0.6-0.4-1.3-0.6-1.9l-0.5,0.2c0.2,0.6,0.4,1.3,0.6,1.9L299.4,187.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M300.8,195.4l0.5-0.1c-0.1-0.7-0.2-1.3-0.4-2l-0.5,0.1C300.5,194.1,300.7,194.8,300.8,195.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M175.7,220.7c0.2,0.7,0.3,1.3,0.5,1.9l0.5-0.1c-0.2-0.6-0.3-1.3-0.5-1.9L175.7,220.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M176.8,224.6c0.2,0.6,0.4,1.3,0.6,1.9l0.5-0.2c-0.2-0.6-0.4-1.3-0.6-1.9L176.8,224.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M178,228.4c0.2,0.6,0.5,1.3,0.7,1.9l0.5-0.2c-0.2-0.6-0.5-1.2-0.7-1.9L178,228.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M181.8,175.9l0.4,0.2c0.3-0.6,0.6-1.2,1-1.7l-0.4-0.3C182.4,174.8,182.1,175.3,181.8,175.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M179.5,232.1c0.3,0.6,0.5,1.2,0.8,1.8l0.5-0.2c-0.3-0.6-0.6-1.2-0.8-1.8L179.5,232.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M181.3,235.8c0.3,0.6,0.6,1.2,1,1.8l0.4-0.2c-0.3-0.6-0.6-1.2-0.9-1.8L181.3,235.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M174.8,200.8l-0.5,0c-0.1,0.7-0.1,1.3-0.1,2l0.5,0C174.7,202.2,174.8,201.5,174.8,200.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M175.3,196.9l-0.5-0.1c-0.1,0.7-0.2,1.3-0.3,2l0.5,0.1C175.1,198.2,175.2,197.5,175.3,196.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M174.6,206.3c0-0.5,0-1,0-1.5l-0.5,0c0,0.5,0,1,0,1.5l0,0.5l0.5,0L174.6,206.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M174.7,208.8l-0.5,0c0,0.7,0.1,1.3,0.1,2l0.5,0C174.7,210.1,174.7,209.5,174.7,208.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M175.5,216.7l-0.5,0.1c0.1,0.7,0.2,1.3,0.4,2l0.5-0.1C175.7,218,175.6,217.4,175.5,216.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M174.9,212.8l-0.5,0.1c0.1,0.7,0.1,1.3,0.2,2l0.5-0.1C175.1,214.1,175,213.4,174.9,212.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M280.3,253.9l0.3,0.4c0.5-0.4,1-0.9,1.5-1.4l-0.3-0.4C281.2,253,280.8,253.5,280.3,253.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M285.9,248.3l0.4,0.3c0.4-0.5,0.9-1,1.3-1.5l-0.4-0.3C286.7,247.3,286.3,247.8,285.9,248.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M283.9,162.2c0.5,0.5,0.9,1,1.4,1.5l0.4-0.3c-0.4-0.5-0.9-1-1.4-1.5L283.9,162.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M286.6,165.2c0.4,0.5,0.9,1,1.3,1.5l0.4-0.3c-0.4-0.5-0.8-1-1.3-1.5L286.6,165.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M283.2,251.2l0.4,0.4c0.5-0.5,0.9-1,1.4-1.4l-0.4-0.3C284.1,250.2,283.6,250.7,283.2,251.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M288.4,245.2l0.4,0.3c0.4-0.5,0.8-1.1,1.2-1.6l-0.4-0.3C289.2,244.2,288.8,244.7,288.4,245.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M289.1,168.3c0.4,0.5,0.8,1.1,1.2,1.6l0.4-0.3c-0.4-0.5-0.8-1.1-1.2-1.6L289.1,168.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M281.1,159.4c0.5,0.4,1,0.9,1.4,1.4l0.3-0.4c-0.5-0.5-1-0.9-1.5-1.4L281.1,159.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M274,258.8l0.3,0.4c0.6-0.4,1.1-0.8,1.6-1.2l-0.3-0.4C275.1,258.1,274.5,258.4,274,258.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M274.9,154.4c0.5,0.4,1.1,0.8,1.6,1.2l0.3-0.4c-0.5-0.4-1.1-0.8-1.6-1.2L274.9,154.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M290.8,242l0.4,0.3c0.4-0.6,0.7-1.1,1.1-1.7l-0.4-0.3C291.5,240.9,291.1,241.4,290.8,242z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M278,156.8c0.5,0.4,1,0.8,1.5,1.3l0.3-0.4c-0.5-0.4-1-0.9-1.5-1.3L278,156.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M277.2,256.5l0.3,0.4c0.5-0.4,1-0.8,1.6-1.3l-0.3-0.4C278.2,255.6,277.7,256.1,277.2,256.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M292.9,238.6l0.4,0.3c0.3-0.6,0.7-1.2,1-1.7l-0.4-0.2C293.6,237.5,293.2,238.1,292.9,238.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M299.2,224l0.5,0.1c0.2-0.6,0.4-1.3,0.5-1.9l-0.5-0.1C299.6,222.7,299.4,223.4,299.2,224z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M300.2,220.1l0.5,0.1c0.1-0.7,0.3-1.3,0.4-2l-0.5-0.1C300.5,218.8,300.3,219.5,300.2,220.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M300.9,216.2l0.5,0.1c0.1-0.7,0.2-1.3,0.3-2l-0.5-0.1C301.1,214.9,301,215.6,300.9,216.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M301.7,205.3c0,0.3,0,0.7,0,1c0,0.7,0,1.3,0,2l0.5,0c0-0.7,0-1.3,0-2c0-0.3,0-0.7,0-1L301.7,205.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M301.4,212.3l0.5,0c0.1-0.7,0.1-1.3,0.2-2l-0.5,0C301.5,211,301.5,211.6,301.4,212.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M294.8,235.1l0.4,0.2c0.3-0.6,0.6-1.2,0.9-1.8l-0.5-0.2C295.4,233.9,295.1,234.5,294.8,235.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M271.5,152.2c0.6,0.4,1.1,0.7,1.7,1.1l0.3-0.4c-0.6-0.4-1.1-0.7-1.7-1.1L271.5,152.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M293.9,174.7l-0.4,0.2c0.3,0.6,0.6,1.2,1,1.7l0.4-0.2C294.5,175.8,294.2,175.3,293.9,174.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M296.5,231.5l0.5,0.2c0.3-0.6,0.5-1.2,0.8-1.9l-0.5-0.2C297,230.3,296.8,230.9,296.5,231.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M298,227.8l0.5,0.2c0.2-0.6,0.4-1.3,0.7-1.9l-0.5-0.2C298.4,226.5,298.2,227.2,298,227.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M291.4,171.5c0.4,0.6,0.7,1.1,1.1,1.7l0.4-0.3c-0.3-0.6-0.7-1.1-1.1-1.7L291.4,171.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M229.4,142.9l0.1,0.5c0.7-0.1,1.3-0.2,2-0.2l-0.1-0.5C230.7,142.7,230.1,142.8,229.4,142.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M241.4,142.8c0.7,0,1.3,0.1,2,0.1l0-0.5c-0.7-0.1-1.3-0.1-2-0.1L241.4,142.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M240.4,269.8l0,0.5c0.7,0,1.3-0.1,2-0.1l0-0.5C241.7,269.8,241.1,269.8,240.4,269.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M237.4,142.3l0,0.5c0.2,0,0.4,0,0.6,0c0.4,0,0.9,0,1.3,0l0-0.5c-0.4,0-0.8,0-1.3,0
			C237.9,142.3,237.7,142.3,237.4,142.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M238.2,269.9c-0.6,0-1.2,0-1.7,0l0,0.5c0.6,0,1.2,0,1.8,0l0.2,0l0-0.5L238.2,269.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M244.4,269.6l0,0.5c0.7-0.1,1.3-0.1,2-0.2l-0.1-0.5C245.7,269.4,245,269.5,244.4,269.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M245.4,143.2c0.7,0.1,1.3,0.2,2,0.3l0.1-0.5c-0.7-0.1-1.3-0.2-2-0.3L245.4,143.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M232.4,270.1c0.7,0.1,1.3,0.1,2,0.1l0-0.5c-0.7,0-1.3-0.1-2-0.1L232.4,270.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M225.5,143.5l0.1,0.5c0.6-0.1,1.3-0.3,2-0.4l-0.1-0.5C226.8,143.3,226.1,143.4,225.5,143.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M228.4,269.6c0.7,0.1,1.3,0.2,2,0.3l0.1-0.5c-0.7-0.1-1.3-0.2-2-0.3L228.4,269.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M224.5,268.9c0.7,0.1,1.3,0.3,2,0.4l0.1-0.5c-0.7-0.1-1.3-0.3-2-0.4L224.5,268.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M248.3,269.1l0.1,0.5c0.7-0.1,1.3-0.2,2-0.3l-0.1-0.5C249.6,268.8,249,268.9,248.3,269.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M233.4,142.4l0,0.5c0.7,0,1.3-0.1,2-0.1l0-0.5C234.7,142.4,234.1,142.4,233.4,142.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M263.6,264.6l0.2,0.5c0.6-0.3,1.2-0.5,1.8-0.8l-0.2-0.5C264.8,264,264.2,264.3,263.6,264.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M270.6,261l0.3,0.4c0.6-0.3,1.1-0.7,1.7-1.1l-0.3-0.4C271.8,260.3,271.2,260.6,270.6,261z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M264.5,148.5c0.6,0.3,1.2,0.6,1.8,0.9l0.2-0.4c-0.6-0.3-1.2-0.6-1.8-0.9L264.5,148.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M249.3,143.7c0.7,0.1,1.3,0.2,2,0.4l0.1-0.5c-0.7-0.1-1.3-0.3-2-0.4L249.3,143.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M267.2,262.9l0.2,0.4c0.6-0.3,1.2-0.6,1.8-0.9l-0.2-0.4C268.3,262.3,267.7,262.6,267.2,262.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M260.8,146.9c0.6,0.2,1.2,0.5,1.9,0.7l0.2-0.5c-0.6-0.3-1.2-0.5-1.9-0.7L260.8,146.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M268.1,150.2c0.6,0.3,1.2,0.6,1.7,1l0.2-0.4c-0.6-0.3-1.2-0.7-1.8-1L268.1,150.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M252.2,268.3l0.1,0.5c0.7-0.1,1.3-0.3,2-0.5l-0.1-0.5C253.5,268,252.9,268.2,252.2,268.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M253.2,144.6c0.6,0.2,1.3,0.3,1.9,0.5l0.1-0.5c-0.6-0.2-1.3-0.3-1.9-0.5L253.2,144.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M259.9,266.1l0.2,0.5c0.6-0.2,1.3-0.5,1.9-0.7l-0.2-0.5C261.1,265.6,260.5,265.8,259.9,266.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M256.1,267.3l0.1,0.5c0.6-0.2,1.3-0.4,1.9-0.6l-0.2-0.5C257.4,266.9,256.7,267.1,256.1,267.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M257.1,145.6c0.6,0.2,1.3,0.4,1.9,0.6l0.2-0.5c-0.6-0.2-1.3-0.4-1.9-0.6L257.1,145.6z"
              />
            </g>
            {meterPoints === 6 && (
              <g id="Circle2">
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M204.2,227.5c-0.4-0.6-0.7-1.1-1-1.7l-0.4,0.2c0.3,0.6,0.7,1.2,1,1.7L204.2,227.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M202.7,187.7l-0.4-0.2c-0.3,0.6-0.6,1.2-0.9,1.8l0.5,0.2C202.1,188.9,202.4,188.3,202.7,187.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M204.7,184.3l-0.4-0.3c-0.4,0.6-0.7,1.1-1.1,1.7l0.4,0.3C204,185.4,204.4,184.9,204.7,184.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M207.4,232.7c0.4,0.5,0.9,1,1.3,1.5l0.4-0.3c-0.5-0.5-0.9-1-1.3-1.5L207.4,232.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M209.4,177.8c-0.5,0.5-0.9,1-1.4,1.5l0.4,0.3c0.4-0.5,0.9-1,1.4-1.4L209.4,177.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M206.5,230.8c-0.4-0.5-0.8-1.1-1.2-1.6l-0.4,0.3c0.4,0.5,0.8,1.1,1.2,1.6L206.5,230.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M201,222.5c0.3,0.6,0.5,1.2,0.8,1.8l0.4-0.2c-0.3-0.6-0.6-1.2-0.8-1.8L201,222.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M205.9,182.7c0.4-0.5,0.8-1.1,1.2-1.6l-0.4-0.3c-0.4,0.5-0.8,1.1-1.2,1.6L205.9,182.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M257.6,170.8c-0.6-0.3-1.2-0.6-1.8-0.9l-0.2,0.5c0.6,0.3,1.2,0.6,1.8,0.9L257.6,170.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M254,169c-0.6-0.3-1.2-0.5-1.9-0.7l-0.2,0.5c0.6,0.2,1.2,0.5,1.9,0.7L254,169z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M258.6,241.3c0.6-0.3,1.1-0.7,1.7-1.1l-0.3-0.4c-0.6,0.4-1.1,0.7-1.7,1L258.6,241.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M201,191.3l-0.5-0.2c-0.3,0.6-0.5,1.3-0.7,1.9l0.5,0.2C200.6,192.6,200.8,191.9,201,191.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M261.9,239.1c0.5-0.4,1.1-0.8,1.6-1.2l-0.3-0.4c-0.5,0.4-1,0.8-1.6,1.2L261.9,239.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M255,243.2c0.6-0.3,1.2-0.6,1.8-0.9l-0.2-0.4c-0.6,0.3-1.2,0.6-1.8,0.9L255,243.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M261.1,172.9c-0.6-0.4-1.1-0.7-1.7-1.1l-0.3,0.4c0.6,0.3,1.1,0.7,1.7,1.1L261.1,172.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M278.6,203.2c-0.1-0.7-0.1-1.3-0.2-2l-0.5,0.1c0.1,0.7,0.1,1.3,0.2,2L278.6,203.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M277.2,197.4c0.1,0.6,0.3,1.3,0.4,1.9l0.5-0.1c-0.1-0.7-0.2-1.3-0.4-2L277.2,197.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M264.3,175.3c-0.5-0.4-1-0.9-1.6-1.3l-0.3,0.4c0.5,0.4,1,0.8,1.6,1.2L264.3,175.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M210.1,235.6c0.5,0.5,1,0.9,1.5,1.4l0.3-0.4c-0.5-0.4-1-0.9-1.5-1.3L210.1,235.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M276.7,195.4l0.5-0.1c-0.2-0.6-0.4-1.3-0.6-1.9l-0.5,0.2C276.3,194.2,276.5,194.8,276.7,195.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M215.6,172.7c-0.6,0.4-1.1,0.8-1.6,1.2l0.3,0.4c0.5-0.4,1.1-0.8,1.6-1.1L215.6,172.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M218.5,241.1c-0.6-0.3-1.1-0.7-1.7-1l-0.3,0.4c0.6,0.4,1.1,0.7,1.7,1L218.5,241.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M213.2,238.2c0.5,0.4,1.1,0.8,1.6,1.2l0.3-0.4c-0.5-0.4-1.1-0.8-1.6-1.2L213.2,238.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M212.4,175.1c-0.5,0.4-1,0.9-1.5,1.3l0.3,0.4c0.5-0.4,1-0.9,1.5-1.3L212.4,175.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M246.3,166.6c-0.7-0.1-1.3-0.3-2-0.4l-0.1,0.5c0.6,0.1,1.3,0.2,2,0.4L246.3,166.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M250.2,167.6c-0.6-0.2-1.3-0.4-1.9-0.6l-0.1,0.5c0.6,0.2,1.3,0.3,1.9,0.5L250.2,167.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M249.4,245.3l-0.1-0.5c-0.6,0.2-1.3,0.4-1.9,0.5l0.1,0.5C248,245.6,248.7,245.5,249.4,245.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M245.4,246.2l-0.1-0.5c-0.6,0.1-1.3,0.2-2,0.3l0.1,0.5C244.1,246.4,244.8,246.3,245.4,246.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M253.2,244l-0.2-0.5c-0.6,0.2-1.2,0.5-1.9,0.7l0.2,0.5C251.9,244.4,252.5,244.2,253.2,244z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M275.4,191.7l0.5-0.2c-0.2-0.6-0.5-1.2-0.8-1.8l-0.5,0.2C274.9,190.4,275.2,191.1,275.4,191.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M270.7,183c0.4,0.5,0.8,1.1,1.1,1.6l0.4-0.3c-0.4-0.6-0.7-1.1-1.1-1.7L270.7,183z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M265.4,177c0.5,0.5,1,0.9,1.4,1.4l0.4-0.3c-0.5-0.5-0.9-1-1.4-1.4L265.4,177z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M268.2,179.9c0.4,0.5,0.9,1,1.3,1.5l0.4-0.3c-0.4-0.5-0.9-1-1.3-1.5L268.2,179.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M270.1,230.4l0.4,0.3c0.4-0.5,0.8-1.1,1.2-1.6l-0.4-0.3C270.9,229.3,270.5,229.9,270.1,230.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M267.6,233.5l0.4,0.3c0.5-0.5,0.9-1,1.3-1.5l-0.4-0.3C268.5,232.5,268,233,267.6,233.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M239.4,246.3l0,0.5c0.7,0,1.3-0.1,2-0.1l0-0.5C240.7,246.3,240.1,246.3,239.4,246.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M266.2,234.9c-0.5,0.5-1,0.9-1.5,1.4l0.3,0.4c0.5-0.4,1-0.9,1.5-1.4L266.2,234.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M240.3,166.4c0.7,0,1.3,0.1,2,0.2l0.1-0.5c-0.7-0.1-1.3-0.1-2-0.2L240.3,166.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M278.2,205.2c0,0.4,0,0.7,0,1.1c0,0.7,0,1.3,0,2l0.5,0c0-0.7,0-1.3,0-2c0-0.4,0-0.7,0-1.1L278.2,205.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M277,216.1l0.5,0.1c0.2-0.6,0.3-1.3,0.4-2l-0.5-0.1C277.3,214.9,277.1,215.5,277,216.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M277.7,212.3l0.5,0.1c0.1-0.7,0.2-1.3,0.2-2l-0.5,0C277.9,210.9,277.8,211.6,277.7,212.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M236.3,165.8l0,0.5c0.6,0,1.2-0.1,1.8,0l0.2,0l0-0.5l-0.2,0C237.5,165.8,236.9,165.8,236.3,165.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M275.8,220l0.5,0.2c0.2-0.6,0.4-1.3,0.6-1.9l-0.5-0.1C276.2,218.7,276,219.3,275.8,220z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M272.8,186.3c0.3,0.6,0.6,1.2,0.9,1.7l0.4-0.2c-0.3-0.6-0.6-1.2-1-1.8L272.8,186.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M274.3,223.6l0.5,0.2c0.3-0.6,0.6-1.2,0.8-1.8l-0.5-0.2C274.8,222.4,274.5,223,274.3,223.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M272.4,227.1l0.4,0.3c0.3-0.6,0.7-1.2,1-1.7l-0.4-0.2C273,226,272.7,226.6,272.4,227.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M220,242.5c0.6,0.3,1.2,0.6,1.8,0.9l0.2-0.5c-0.6-0.3-1.2-0.6-1.8-0.8L220,242.5z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M198.3,202.9l-0.5,0c-0.1,0.7-0.1,1.3-0.1,2l0.5,0C198.2,204.2,198.2,203.5,198.3,202.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M198.2,208.8c0-0.7-0.1-1.3-0.1-2l-0.5,0c0,0.7,0,1.3,0.1,2L198.2,208.8z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M198.8,198.9l-0.5-0.1c-0.1,0.7-0.2,1.3-0.3,2l0.5,0.1C198.6,200.3,198.7,199.6,198.8,198.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M235.4,246.7c0.7,0,1.3,0.1,2,0.1l0-0.5c-0.7,0-1.3,0-2-0.1L235.4,246.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M199.5,216.7c-0.2-0.6-0.3-1.3-0.5-1.9l-0.5,0.1c0.1,0.6,0.3,1.3,0.5,2L199.5,216.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M197.9,210.9c0.1,0.7,0.2,1.3,0.3,2l0.5-0.1c-0.1-0.7-0.2-1.3-0.3-2L197.9,210.9z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M199.7,195.1l-0.5-0.1c-0.2,0.6-0.4,1.3-0.5,1.9l0.5,0.1C199.4,196.4,199.6,195.7,199.7,195.1z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M199.6,218.7c0.2,0.6,0.4,1.3,0.7,1.9l0.5-0.2c-0.2-0.6-0.5-1.3-0.7-1.9L199.6,218.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M217.3,171.6l0.3,0.4c0.6-0.3,1.1-0.7,1.7-1l-0.2-0.4C218.4,170.9,217.9,171.2,217.3,171.6z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M231.4,246.3c0.7,0.1,1.3,0.2,2,0.3l0.1-0.5c-0.7-0.1-1.3-0.2-2-0.3L231.4,246.3z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M220.8,169.7l0.2,0.5c0.6-0.3,1.2-0.6,1.8-0.8l-0.2-0.5C222,169.1,221.4,169.4,220.8,169.7z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M232.3,166.2l0.1,0.5c0.6-0.1,1.3-0.2,2-0.2l0-0.5C233.7,166,233,166.1,232.3,166.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M228.4,167l0.1,0.5c0.6-0.2,1.3-0.3,1.9-0.4l-0.1-0.5C229.7,166.7,229,166.8,228.4,167z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M227.5,245.4c0.6,0.2,1.3,0.3,2,0.5l0.1-0.5c-0.6-0.1-1.3-0.3-1.9-0.5L227.5,245.4z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M223.7,244.2c0.6,0.2,1.3,0.5,1.9,0.7l0.2-0.5c-0.6-0.2-1.3-0.4-1.9-0.7L223.7,244.2z"
                />
                <path
                  style={{ fill: "#58595B" }}
                  className="st8"
                  d="M224.5,168.1l0.2,0.5c0.6-0.2,1.3-0.4,1.9-0.6l-0.1-0.5C225.8,167.7,225.2,167.9,224.5,168.1z"
                />
              </g>
            )}
            <g id="Circle1_00000016033043783129153950000000203744856375843202_">
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M225,195.6l0.4,0.3c0.4-0.5,0.9-1,1.3-1.4l-0.3-0.4C225.9,194.5,225.5,195,225,195.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M229.1,220.1c-0.5-0.4-1.1-0.8-1.6-1.2l-0.3,0.4c0.5,0.4,1.1,0.8,1.6,1.2L229.1,220.1z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M248.7,193c-0.5-0.4-1.1-0.8-1.7-1.2l-0.3,0.4c0.6,0.3,1.1,0.7,1.6,1.1L248.7,193z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M254.6,210.3l-0.5-0.1c-0.2,0.6-0.4,1.3-0.6,1.9l0.5,0.2C254.3,211.6,254.5,211,254.6,210.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M228,192.8l0.3,0.4c0.5-0.4,1.1-0.8,1.6-1.1l-0.3-0.4C229.1,192,228.5,192.4,228,192.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M222.9,212.6l-0.5,0.2c0.3,0.6,0.6,1.2,0.9,1.8l0.4-0.2C223.5,213.8,223.2,213.2,222.9,212.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M231.5,190.7l0.2,0.5c0.6-0.3,1.2-0.5,1.9-0.7l-0.1-0.5C232.7,190.2,232.1,190.5,231.5,190.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M240.4,222.6c-0.6,0.1-1.3,0.1-2,0.1l0,0.5c0.7,0,1.4-0.1,2-0.2L240.4,222.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M232.6,221.8c-0.6-0.2-1.2-0.5-1.8-0.8l-0.2,0.4c0.6,0.3,1.2,0.6,1.9,0.8L232.6,221.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M237.4,189.4c-0.7,0-1.4,0.1-2,0.2l0.1,0.5c0.6-0.1,1.3-0.2,2-0.2L237.4,189.4z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M244.2,221.6c-0.6,0.2-1.2,0.4-1.9,0.6l0.1,0.5c0.7-0.2,1.3-0.4,1.9-0.6L244.2,221.6z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M236.5,222.7c-0.7-0.1-1.3-0.2-1.9-0.3l-0.1,0.5c0.7,0.1,1.3,0.3,2,0.3L236.5,222.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M252.3,197.8c0.3,0.6,0.6,1.1,0.9,1.7l0.5-0.2c-0.3-0.6-0.6-1.2-0.9-1.8L252.3,197.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M224.4,216.3c0.4,0.5,0.8,1.1,1.3,1.6l0.4-0.3c-0.4-0.5-0.9-1-1.3-1.5L224.4,216.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M254.8,203.2c-0.1-0.7-0.3-1.3-0.5-2l-0.5,0.1c0.2,0.6,0.4,1.3,0.5,1.9L254.8,203.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M223.3,199.2c0.3-0.6,0.6-1.2,1-1.7l-0.4-0.3c-0.4,0.6-0.7,1.2-1,1.8L223.3,199.2z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M249.9,194.7c0.5,0.5,0.9,1,1.3,1.5l0.4-0.3c-0.4-0.5-0.9-1-1.3-1.5L249.9,194.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M241.4,189.7c-0.7-0.1-1.3-0.2-2-0.3l0,0.5c0.7,0,1.3,0.1,2,0.3L241.4,189.7z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M250.9,217.5l-0.4-0.3c-0.4,0.5-0.9,1-1.4,1.4l0.3,0.4C250,218.5,250.5,218,250.9,217.5z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M245.3,190.9c-0.6-0.3-1.2-0.5-1.9-0.7l-0.2,0.5c0.6,0.2,1.2,0.4,1.8,0.7L245.3,190.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M246,220.8l0.2,0.4c0.6-0.3,1.2-0.7,1.7-1.1l-0.3-0.4C247.1,220.2,246.5,220.5,246,220.8z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M221.4,208.9c0.1,0.7,0.2,1.3,0.4,2l0.5-0.1c-0.2-0.6-0.3-1.3-0.4-1.9L221.4,208.9z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M255.1,206.3c0-0.4,0-0.7,0-1.1l-0.5,0c0,0.3,0,0.7,0,1c0,0.7,0,1.3-0.1,2l0.5,0.1
			C255.1,207.7,255.1,207,255.1,206.3z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M221.3,204.8c0,0.5-0.1,1-0.1,1.5c0,0.2,0,0.4,0,0.5l0.5,0c0-0.2,0-0.3,0-0.5c0-0.5,0-1,0.1-1.5L221.3,204.8z
			"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M222.6,201l-0.5-0.2c-0.2,0.6-0.4,1.3-0.5,2l0.5,0.1C222.2,202.3,222.4,201.6,222.6,201z"
              />
              <path
                style={{ fill: "#58595B" }}
                className="st8"
                d="M253.2,214.1l-0.4-0.2c-0.3,0.6-0.6,1.1-1,1.7l0.4,0.3C252.6,215.3,252.9,214.7,253.2,214.1z"
              />
            </g>
          </g>
          <g id="Numbers">
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M323.3,37.1h1.5v-4h-1.3v-1c0.7-0.1,1.2-0.3,1.7-0.6h1.2v5.7h1.3v1.3h-4.5V37.1z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M329,37.5c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S329,38.1,329,37.5z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M331.9,37.6l0.7-1c0.4,0.4,0.9,0.7,1.5,0.7c0.7,0,1.1-0.3,1.1-0.8c0-0.6-0.4-1-1.9-1v-1.1
		c1.3,0,1.6-0.4,1.6-0.9c0-0.5-0.3-0.8-0.9-0.8c-0.5,0-0.9,0.2-1.3,0.6l-0.8-1c0.6-0.6,1.3-0.9,2.2-0.9c1.5,0,2.4,0.7,2.4,1.9
		c0,0.7-0.4,1.2-1.2,1.6v0c0.8,0.2,1.4,0.8,1.4,1.7c0,1.3-1.2,2-2.6,2C333.2,38.6,332.4,38.2,331.9,37.6z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M355.6,58h1.5v-4h-1.3v-1c0.7-0.1,1.2-0.3,1.7-0.6h1.2V58h1.3v1.3h-4.5V58z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M361.3,58.4c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S361.3,59,361.3,58.4z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M367.1,55.3c0-0.4,0-1.1,0.1-1.6h0c-0.2,0.4-0.4,0.8-0.6,1.2l-0.9,1.5h3.8v1.2h-5.3v-1.1l2.6-4.2h2v7h-1.5
		V55.3z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M382.1,84.8h1.5v-4h-1.3v-1c0.7-0.1,1.2-0.3,1.7-0.6h1.2v5.7h1.3v1.3h-4.5V84.8z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M387.8,85.2c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S387.8,85.7,387.8,85.2z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M390.7,85.2l0.7-1c0.4,0.4,0.9,0.7,1.5,0.7c0.7,0,1.2-0.4,1.2-1.1c0-0.7-0.5-1.1-1.1-1.1c-0.4,0-0.6,0.1-1,0.4
		l-0.7-0.5l0.2-3.5h4v1.4h-2.6l-0.1,1.3c0.3-0.1,0.5-0.2,0.8-0.2c1.2,0,2.2,0.7,2.2,2.2c0,1.6-1.2,2.4-2.6,2.4
		C392,86.2,391.3,85.8,390.7,85.2z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M403.4,117h1.5v-4h-1.3v-1c0.7-0.1,1.2-0.3,1.7-0.6h1.2v5.7h1.3v1.3h-4.5V117z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M409.1,117.5c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S409.1,118,409.1,117.5z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M412.2,115c0-2.6,1.4-3.8,2.8-3.8c0.9,0,1.6,0.4,2,0.8l-0.9,1c-0.2-0.3-0.7-0.5-1.1-0.5
		c-0.8,0-1.5,0.6-1.5,2.5c0,1.7,0.5,2.2,1.1,2.2c0.5,0,0.9-0.3,0.9-1.1c0-0.7-0.4-1-0.9-1c-0.4,0-0.8,0.2-1.1,0.8l-0.1-1.1
		c0.4-0.5,1-0.8,1.5-0.8c1.2,0,2.1,0.7,2.1,2.2c0,1.5-1.1,2.3-2.3,2.3C413.5,118.5,412.2,117.5,412.2,115z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M417.9,151.8h1.5v-4h-1.3v-1c0.7-0.1,1.2-0.3,1.7-0.6h1.2v5.7h1.3v1.3h-4.5V151.8z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M423.6,152.2c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S423.6,152.8,423.6,152.2z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M429.9,147.5h-3.1v-1.4h4.9v1c-1.6,1.9-1.8,3.3-2,6H428C428.1,150.8,428.6,149.3,429.9,147.5z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M425.7,189.5h1.5v-4h-1.3v-1c0.7-0.1,1.2-0.3,1.7-0.6h1.2v5.7h1.3v1.3h-4.5V189.5z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M431.4,189.9c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S431.4,190.5,431.4,189.9z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M434.5,189c0-0.8,0.5-1.4,1.2-1.7v0c-0.5-0.4-0.9-0.9-0.9-1.6c0-1.2,0.9-1.9,2.2-1.9c1.3,0,2.1,0.8,2.1,1.9
		c0,0.7-0.4,1.2-0.9,1.5v0c0.7,0.4,1.2,0.9,1.2,1.8c0,1.1-1,1.9-2.5,1.9C435.5,190.9,434.5,190.1,434.5,189z M437.9,188.9
		c0-0.6-0.6-0.9-1.5-1.2c-0.3,0.3-0.5,0.7-0.5,1.1c0,0.6,0.5,1,1.1,1C437.5,189.8,437.9,189.5,437.9,188.9z M437.8,185.7
		c0-0.5-0.3-0.9-0.8-0.9c-0.4,0-0.8,0.3-0.8,0.8c0,0.6,0.5,0.8,1.2,1.1C437.6,186.4,437.8,186.1,437.8,185.7z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M287.9,22.2h1.5v-4h-1.3v-1c0.7-0.1,1.2-0.3,1.7-0.6h1.2v5.7h1.3v1.3h-4.5V22.2z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M293.7,22.6c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S293.7,23.2,293.7,22.6z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M296.7,22.5c1.8-1.7,3-2.9,3-3.9c0-0.7-0.4-1-1-1c-0.5,0-0.9,0.3-1.2,0.7l-0.9-0.9c0.7-0.7,1.3-1.1,2.3-1.1
		c1.4,0,2.3,0.9,2.3,2.2c0,1.2-1.1,2.4-2.2,3.6c0.4,0,0.8-0.1,1.2-0.1h1.4v1.4h-4.9V22.5z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M425.7,227.8h1.5v-4h-1.3v-1c0.7-0.1,1.2-0.3,1.7-0.6h1.2v5.7h1.3v1.3h-4.5V227.8z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M431.4,228.3c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S431.4,228.8,431.4,228.3z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M434.5,228.4l0.9-1c0.2,0.3,0.7,0.5,1.1,0.5c0.8,0,1.5-0.6,1.5-2.5c0-1.7-0.5-2.2-1.1-2.2
		c-0.5,0-0.9,0.3-0.9,1.1c0,0.7,0.4,1,0.9,1c0.4,0,0.8-0.2,1.1-0.8l0.1,1.1c-0.4,0.5-1,0.8-1.5,0.8c-1.2,0-2.1-0.7-2.1-2.2
		c0-1.5,1.1-2.3,2.3-2.3c1.4,0,2.6,1,2.6,3.5c0,2.6-1.4,3.8-2.8,3.8C435.6,229.3,434.9,228.9,434.5,228.4z"
            />
            <path
              style={{ fill: "#299947" }}
              className="st10"
              d="M417.6,265.7c1.8-1.7,3-2.9,3-3.9c0-0.7-0.4-1-1-1c-0.5,0-0.9,0.3-1.2,0.7l-0.9-0.9c0.7-0.7,1.3-1.1,2.3-1.1
		c1.4,0,2.3,0.9,2.3,2.2c0,1.2-1.1,2.4-2.2,3.6c0.4,0,0.8-0.1,1.2-0.1h1.4v1.4h-4.9V265.7z"
            />
            <path
              style={{ fill: "#299947" }}
              className="st10"
              d="M423.6,265.8c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S423.6,266.3,423.6,265.8z"
            />
            <path
              style={{ fill: "#299947" }}
              className="st10"
              d="M427,265.3h1.5v-4h-1.3v-1c0.7-0.1,1.2-0.3,1.7-0.6h1.2v5.7h1.3v1.3H427V265.3z"
            />
            <path
              style={{ fill: "#299947" }}
              className="st10"
              d="M403.2,300.9c1.8-1.7,3-2.9,3-3.9c0-0.7-0.4-1-1-1c-0.5,0-0.9,0.3-1.2,0.7l-0.9-0.9c0.7-0.7,1.3-1.1,2.3-1.1
		c1.4,0,2.3,0.9,2.3,2.2c0,1.2-1.1,2.4-2.2,3.6c0.4,0,0.8-0.1,1.2-0.1h1.4v1.4h-4.9V300.9z"
            />
            <path
              style={{ fill: "#299947" }}
              className="st10"
              d="M409.3,300.9c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S409.3,301.5,409.3,300.9z"
            />
            <path
              style={{ fill: "#299947" }}
              className="st10"
              d="M412.3,300.9c1.8-1.7,3-2.9,3-3.9c0-0.7-0.4-1-1-1c-0.5,0-0.9,0.3-1.2,0.7l-0.9-0.9c0.7-0.7,1.3-1.1,2.3-1.1
		c1.4,0,2.3,0.9,2.3,2.2c0,1.2-1.1,2.4-2.2,3.6c0.4,0,0.8-0.1,1.2-0.1h1.4v1.4h-4.9V300.9z"
            />
            <path
              style={{ fill: "#299947" }}
              className="st10"
              d="M381.2,332.1c1.8-1.7,3-2.9,3-3.9c0-0.7-0.4-1-1-1c-0.5,0-0.9,0.3-1.2,0.7l-0.9-0.9c0.7-0.7,1.3-1.1,2.3-1.1
		c1.4,0,2.3,0.9,2.3,2.2c0,1.2-1.1,2.4-2.2,3.6c0.4,0,0.8-0.1,1.2-0.1h1.4v1.4h-4.9V332.1z"
            />
            <path
              style={{ fill: "#299947" }}
              className="st10"
              d="M387.3,332.1c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S387.3,332.7,387.3,332.1z"
            />
            <path
              style={{ fill: "#299947" }}
              className="st10"
              d="M390.2,332.2l0.7-1c0.4,0.4,0.9,0.7,1.5,0.7c0.7,0,1.1-0.3,1.1-0.8c0-0.6-0.4-1-1.9-1v-1.1
		c1.3,0,1.6-0.4,1.6-0.9c0-0.5-0.3-0.8-0.9-0.8c-0.5,0-0.9,0.2-1.3,0.6l-0.8-1c0.6-0.6,1.3-0.9,2.2-0.9c1.5,0,2.4,0.7,2.4,1.9
		c0,0.7-0.4,1.2-1.2,1.6v0c0.8,0.2,1.4,0.8,1.4,1.7c0,1.3-1.2,2-2.6,2C391.5,333.2,390.7,332.8,390.2,332.2z"
            />
            <path
              style={{ fill: "#299947" }}
              className="st10"
              d="M354.9,360.1c1.8-1.7,3-2.9,3-3.9c0-0.7-0.4-1-1-1c-0.5,0-0.9,0.3-1.2,0.7l-0.9-0.9c0.7-0.7,1.3-1.1,2.3-1.1
		c1.4,0,2.3,0.9,2.3,2.2c0,1.2-1.1,2.4-2.2,3.6c0.4,0,0.8-0.1,1.2-0.1h1.4v1.4h-4.9V360.1z"
            />
            <path
              style={{ fill: "#299947" }}
              className="st10"
              d="M361,360.1c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S361,360.7,361,360.1z"
            />
            <path
              style={{ fill: "#299947" }}
              className="st10"
              d="M366.8,356.9c0-0.4,0-1.1,0.1-1.6h0c-0.2,0.4-0.4,0.8-0.6,1.2l-0.9,1.5h3.8v1.2h-5.3v-1.1l2.6-4.2h2v7h-1.5
		V356.9z"
            />
            <path
              style={{ fill: "#1DA2A3" }}
              className="st11"
              d="M110.8,356.9c0-0.4,0-1.1,0.1-1.6h0c-0.2,0.4-0.4,0.8-0.6,1.2l-0.9,1.5h3.8v1.2h-5.3v-1.1l2.6-4.2h2v7h-1.5
		V356.9z"
            />
            <path
              style={{ fill: "#1DA2A3" }}
              className="st11"
              d="M114.1,360.1c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S114.1,360.7,114.1,360.1z"
            />
            <path
              style={{ fill: "#1DA2A3" }}
              className="st11"
              d="M117.5,359.7h1.5v-4h-1.3v-1c0.7-0.1,1.2-0.3,1.7-0.6h1.2v5.7h1.3v1.3h-4.5V359.7z"
            />
            <path
              style={{ fill: "#623785" }}
              className="st12"
              d="M37.7,190.2l0.7-1c0.4,0.4,0.9,0.7,1.5,0.7c0.7,0,1.2-0.4,1.2-1.1c0-0.7-0.5-1.1-1.1-1.1
		c-0.4,0-0.6,0.1-1,0.4l-0.7-0.5l0.2-3.5h4v1.4h-2.6l-0.1,1.3c0.3-0.1,0.5-0.2,0.8-0.2c1.2,0,2.2,0.7,2.2,2.2c0,1.6-1.2,2.4-2.6,2.4
		C39,191.2,38.2,190.8,37.7,190.2z"
            />
            <path
              style={{ fill: "#623785" }}
              className="st12"
              d="M43.9,190.2c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S43.9,190.7,43.9,190.2z"
            />
            <path
              style={{ fill: "#623785" }}
              className="st12"
              d="M46.8,190.2l0.7-1c0.4,0.4,0.9,0.7,1.5,0.7c0.7,0,1.1-0.3,1.1-0.8c0-0.6-0.4-1-1.9-1v-1.1
		c1.3,0,1.6-0.4,1.6-0.9c0-0.5-0.3-0.8-0.9-0.8c-0.5,0-0.9,0.2-1.3,0.6l-0.8-1c0.6-0.6,1.3-0.9,2.2-0.9c1.5,0,2.4,0.7,2.4,1.9
		c0,0.7-0.4,1.2-1.2,1.6v0c0.8,0.2,1.4,0.8,1.4,1.7c0,1.3-1.2,2-2.6,2C48.1,191.2,47.3,190.8,46.8,190.2z"
            />
            <path
              style={{ fill: "#623785" }}
              className="st12"
              d="M44.3,152.2l0.7-1c0.4,0.4,0.9,0.7,1.5,0.7c0.7,0,1.2-0.4,1.2-1.1c0-0.7-0.5-1.1-1.1-1.1
		c-0.4,0-0.6,0.1-1,0.4l-0.7-0.5l0.2-3.5h4v1.4h-2.6l-0.1,1.3c0.3-0.1,0.5-0.2,0.8-0.2c1.2,0,2.2,0.7,2.2,2.2c0,1.6-1.2,2.4-2.6,2.4
		C45.7,153.2,44.9,152.8,44.3,152.2z"
            />
            <path
              style={{ fill: "#623785" }}
              className="st12"
              d="M50.6,152.2c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S50.6,152.8,50.6,152.2z"
            />
            <path
              style={{ fill: "#623785" }}
              className="st12"
              d="M56.4,149.1c0-0.4,0-1.1,0.1-1.6h0c-0.2,0.4-0.4,0.8-0.6,1.2l-0.9,1.5h3.8v1.2h-5.3v-1.1l2.6-4.2h2v7h-1.5
		V149.1z"
            />
            <path
              style={{ fill: "#623785" }}
              className="st12"
              d="M45.3,265.8l0.7-1c0.4,0.4,0.9,0.7,1.5,0.7c0.7,0,1.2-0.4,1.2-1.1c0-0.7-0.5-1.1-1.1-1.1
		c-0.4,0-0.6,0.1-1,0.4l-0.7-0.5l0.2-3.5h4v1.4h-2.6l-0.1,1.3c0.3-0.1,0.5-0.2,0.8-0.2c1.2,0,2.2,0.7,2.2,2.2c0,1.6-1.2,2.4-2.6,2.4
		C46.6,266.8,45.8,266.3,45.3,265.8z"
            />
            <path
              style={{ fill: "#623785" }}
              className="st12"
              d="M51.5,265.8c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S51.5,266.3,51.5,265.8z"
            />
            <path
              style={{ fill: "#623785" }}
              className="st12"
              d="M54.9,265.3h1.5v-4h-1.3v-1c0.7-0.1,1.2-0.3,1.7-0.6H58v5.7h1.3v1.3h-4.5V265.3z"
            />
            <path
              style={{ fill: "#1DA2A3" }}
              className="st11"
              d="M62.6,297.9c0-0.4,0-1.1,0.1-1.6h0c-0.2,0.4-0.4,0.8-0.6,1.2l-0.9,1.5h3.8v1.2h-5.3v-1.1l2.6-4.2h2v7h-1.5
		V297.9z"
            />
            <path
              style={{ fill: "#1DA2A3" }}
              className="st11"
              d="M65.8,301c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S65.8,301.6,65.8,301z"
            />
            <path
              style={{ fill: "#1DA2A3" }}
              className="st11"
              d="M68.7,301.1l0.7-1c0.4,0.4,0.9,0.7,1.5,0.7c0.7,0,1.1-0.3,1.1-0.8c0-0.6-0.4-1-1.9-1v-1.1
		c1.3,0,1.6-0.4,1.6-0.9c0-0.5-0.3-0.8-0.9-0.8c-0.5,0-0.9,0.2-1.3,0.6l-0.8-1c0.6-0.6,1.3-0.9,2.2-0.9c1.5,0,2.4,0.7,2.4,1.9
		c0,0.7-0.4,1.2-1.2,1.6v0c0.8,0.2,1.4,0.8,1.4,1.7c0,1.3-1.2,2-2.6,2C70,302.1,69.2,301.7,68.7,301.1z"
            />
            <path
              style={{ fill: "#1DA2A3" }}
              className="st11"
              d="M83.4,329.1c0-0.4,0-1.1,0.1-1.6h0c-0.2,0.4-0.4,0.8-0.6,1.2l-0.9,1.5h3.8v1.2h-5.3v-1.1l2.6-4.2h2v7h-1.5
		V329.1z"
            />
            <path
              style={{ fill: "#1DA2A3" }}
              className="st11"
              d="M86.7,332.3c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S86.7,332.9,86.7,332.3z"
            />
            <path
              style={{ fill: "#1DA2A3" }}
              className="st11"
              d="M89.7,332.2c1.8-1.7,3-2.9,3-3.9c0-0.7-0.4-1-1-1c-0.5,0-0.9,0.3-1.2,0.7l-0.9-0.9c0.7-0.7,1.3-1.1,2.3-1.1
		c1.4,0,2.3,0.9,2.3,2.2c0,1.2-1.1,2.4-2.2,3.6c0.4,0,0.8-0.1,1.2-0.1h1.4v1.4h-4.9V332.2z"
            />
            <path
              style={{ fill: "#3F85C6" }}
              className="st13"
              d="M139.6,381.2l0.7-1c0.4,0.4,0.9,0.7,1.5,0.7c0.7,0,1.1-0.3,1.1-0.8c0-0.6-0.4-1-1.9-1v-1.1
		c1.3,0,1.6-0.4,1.6-0.9c0-0.5-0.3-0.8-0.9-0.8c-0.5,0-0.9,0.2-1.3,0.6l-0.8-1c0.6-0.6,1.3-0.9,2.2-0.9c1.5,0,2.4,0.7,2.4,1.9
		c0,0.7-0.4,1.2-1.2,1.6v0c0.8,0.2,1.4,0.8,1.4,1.7c0,1.3-1.2,2-2.6,2C140.9,382.2,140.1,381.8,139.6,381.2z"
            />
            <path
              style={{ fill: "#3F85C6" }}
              className="st13"
              d="M145.8,381.2c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S145.8,381.8,145.8,381.2z"
            />
            <path
              style={{ fill: "#3F85C6" }}
              className="st13"
              d="M148.7,381.2l0.7-1c0.4,0.4,0.9,0.7,1.5,0.7c0.7,0,1.2-0.4,1.2-1.1c0-0.7-0.5-1.1-1.1-1.1
		c-0.4,0-0.6,0.1-1,0.4l-0.7-0.5l0.2-3.5h4v1.4h-2.6l-0.1,1.3c0.3-0.1,0.5-0.2,0.8-0.2c1.2,0,2.2,0.7,2.2,2.2c0,1.6-1.2,2.4-2.6,2.4
		C150,382.2,149.2,381.8,148.7,381.2z"
            />
            <path
              style={{ fill: "#3F85C6" }}
              className="st13"
              d="M174.9,395.7l0.7-1c0.4,0.4,0.9,0.7,1.5,0.7c0.7,0,1.1-0.3,1.1-0.8c0-0.6-0.4-1-1.9-1v-1.1
		c1.3,0,1.6-0.4,1.6-0.9c0-0.5-0.3-0.8-0.9-0.8c-0.5,0-0.9,0.2-1.3,0.6l-0.8-1c0.6-0.6,1.3-0.9,2.2-0.9c1.5,0,2.4,0.7,2.4,1.9
		c0,0.7-0.4,1.2-1.2,1.6v0c0.8,0.2,1.4,0.8,1.4,1.7c0,1.3-1.2,2-2.6,2C176.2,396.7,175.4,396.3,174.9,395.7z"
            />
            <path
              style={{ fill: "#3F85C6" }}
              className="st13"
              d="M181.2,395.7c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S181.2,396.2,181.2,395.7z"
            />
            <path
              style={{ fill: "#3F85C6" }}
              className="st13"
              d="M187,392.5c0-0.4,0-1.1,0.1-1.6h0c-0.2,0.4-0.4,0.8-0.6,1.2l-0.9,1.5h3.8v1.2H184v-1.1l2.6-4.2h2v7H187V392.5
		z"
            />
            <path
              style={{ fill: "#3F85C6" }}
              className="st13"
              d="M212.2,403.3l0.7-1c0.4,0.4,0.9,0.7,1.5,0.7c0.7,0,1.1-0.3,1.1-0.8c0-0.6-0.4-1-1.9-1V400
		c1.3,0,1.6-0.4,1.6-0.9c0-0.5-0.3-0.8-0.9-0.8c-0.5,0-0.9,0.2-1.3,0.6l-0.8-1c0.6-0.6,1.3-0.9,2.2-0.9c1.5,0,2.4,0.7,2.4,1.9
		c0,0.7-0.4,1.2-1.2,1.6v0c0.8,0.2,1.4,0.8,1.4,1.7c0,1.3-1.2,2-2.6,2C213.5,404.3,212.7,403.9,212.2,403.3z"
            />
            <path
              style={{ fill: "#3F85C6" }}
              className="st13"
              d="M218.4,403.3c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S218.4,403.9,218.4,403.3z"
            />
            <path
              style={{ fill: "#3F85C6" }}
              className="st13"
              d="M221.3,403.3l0.7-1c0.4,0.4,0.9,0.7,1.5,0.7c0.7,0,1.1-0.3,1.1-0.8c0-0.6-0.4-1-1.9-1V400
		c1.3,0,1.6-0.4,1.6-0.9c0-0.5-0.3-0.8-0.9-0.8c-0.5,0-0.9,0.2-1.3,0.6l-0.8-1c0.6-0.6,1.3-0.9,2.2-0.9c1.5,0,2.4,0.7,2.4,1.9
		c0,0.7-0.4,1.2-1.2,1.6v0c0.8,0.2,1.4,0.8,1.4,1.7c0,1.3-1.2,2-2.6,2C222.6,404.3,221.8,403.9,221.3,403.3z"
            />
            <path
              style={{ fill: "#3F85C6" }}
              className="st13"
              d="M250.5,403.2l0.7-1c0.4,0.4,0.9,0.7,1.5,0.7c0.7,0,1.1-0.3,1.1-0.8c0-0.6-0.4-1-1.9-1v-1.1
		c1.3,0,1.6-0.4,1.6-0.9c0-0.5-0.3-0.8-0.9-0.8c-0.5,0-0.9,0.2-1.3,0.6l-0.8-1c0.6-0.6,1.3-0.9,2.2-0.9c1.5,0,2.4,0.7,2.4,1.9
		c0,0.7-0.4,1.2-1.2,1.6v0c0.8,0.2,1.4,0.8,1.4,1.7c0,1.3-1.2,2-2.6,2C251.8,404.2,251,403.8,250.5,403.2z"
            />
            <path
              style={{ fill: "#3F85C6" }}
              className="st13"
              d="M256.8,403.2c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S256.8,403.7,256.8,403.2z"
            />
            <path
              style={{ fill: "#3F85C6" }}
              className="st13"
              d="M259.8,403.1c1.8-1.7,3-2.9,3-3.9c0-0.7-0.4-1-1-1c-0.5,0-0.9,0.3-1.2,0.7l-0.9-0.9c0.7-0.7,1.3-1.1,2.3-1.1
		c1.4,0,2.3,0.9,2.3,2.2c0,1.2-1.1,2.4-2.2,3.6c0.4,0,0.8-0.1,1.2-0.1h1.4v1.4h-4.9V403.1z"
            />
            <path
              style={{ fill: "#3F85C6" }}
              className="st13"
              d="M287.4,395.7l0.7-1c0.4,0.4,0.9,0.7,1.5,0.7c0.7,0,1.1-0.3,1.1-0.8c0-0.6-0.4-1-1.9-1v-1.1
		c1.3,0,1.6-0.4,1.6-0.9c0-0.5-0.3-0.8-0.9-0.8c-0.5,0-0.9,0.2-1.3,0.6l-0.8-1c0.6-0.6,1.3-0.9,2.2-0.9c1.5,0,2.4,0.7,2.4,1.9
		c0,0.7-0.4,1.2-1.2,1.6v0c0.8,0.2,1.4,0.8,1.4,1.7c0,1.3-1.2,2-2.6,2C288.7,396.7,287.9,396.3,287.4,395.7z"
            />
            <path
              style={{ fill: "#3F85C6" }}
              className="st13"
              d="M293.7,395.7c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S293.7,396.2,293.7,395.7z"
            />
            <path
              style={{ fill: "#3F85C6" }}
              className="st13"
              d="M297,395.2h1.5v-4h-1.3v-1c0.7-0.1,1.2-0.3,1.7-0.6h1.2v5.7h1.3v1.3H297V395.2z"
            />
            <path
              style={{ fill: "#299947" }}
              className="st10"
              d="M322.9,381c1.8-1.7,3-2.9,3-3.9c0-0.7-0.4-1-1-1c-0.5,0-0.9,0.3-1.2,0.7l-0.9-0.9c0.7-0.7,1.3-1.1,2.3-1.1
		c1.4,0,2.3,0.9,2.3,2.2c0,1.2-1.1,2.4-2.2,3.6c0.4,0,0.8-0.1,1.2-0.1h1.4v1.4h-4.9V381z"
            />
            <path
              style={{ fill: "#299947" }}
              className="st10"
              d="M329,381c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S329,381.6,329,381z"
            />
            <path
              style={{ fill: "#299947" }}
              className="st10"
              d="M331.9,381.1l0.7-1c0.4,0.4,0.9,0.7,1.5,0.7c0.7,0,1.2-0.4,1.2-1.1c0-0.7-0.5-1.1-1.1-1.1
		c-0.4,0-0.6,0.1-1,0.4l-0.7-0.5l0.2-3.5h4v1.4H334l-0.1,1.3c0.3-0.1,0.5-0.2,0.8-0.2c1.2,0,2.2,0.7,2.2,2.2c0,1.6-1.2,2.4-2.6,2.4
		C333.2,382.1,332.4,381.6,331.9,381.1z"
            />
            <path
              style={{ fill: "#D3375A" }}
              className="st14"
              d="M59.8,114.3c0-2.6,1.4-3.8,2.8-3.8c0.9,0,1.6,0.4,2,0.8l-0.9,1c-0.2-0.3-0.7-0.5-1.1-0.5
		c-0.8,0-1.5,0.6-1.5,2.5c0,1.7,0.5,2.2,1.1,2.2c0.5,0,0.9-0.3,0.9-1.1c0-0.7-0.4-1-0.9-1c-0.4,0-0.8,0.2-1.1,0.8l-0.1-1.1
		c0.4-0.5,1-0.8,1.5-0.8c1.2,0,2.1,0.7,2.1,2.2c0,1.5-1.1,2.3-2.3,2.3C61.1,117.7,59.8,116.7,59.8,114.3z"
            />
            <path
              style={{ fill: "#D3375A" }}
              className="st14"
              d="M65.8,116.7c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S65.8,117.3,65.8,116.7z"
            />
            <path
              style={{ fill: "#D3375A" }}
              className="st14"
              d="M69.2,116.3h1.5v-4h-1.3v-1c0.7-0.1,1.2-0.3,1.7-0.6h1.2v5.7h1.3v1.3h-4.5V116.3z"
            />
            <path
              style={{ fill: "#D3375A" }}
              className="st14"
              d="M80.6,82.9c0-2.6,1.4-3.8,2.8-3.8c0.9,0,1.6,0.4,2,0.8l-0.9,1c-0.2-0.3-0.7-0.5-1.1-0.5
		c-0.8,0-1.5,0.6-1.5,2.5c0,1.7,0.5,2.2,1.1,2.2c0.5,0,0.9-0.3,0.9-1.1c0-0.7-0.4-1-0.9-1c-0.4,0-0.8,0.2-1.1,0.8L82,82.7
		c0.4-0.5,1-0.8,1.5-0.8c1.2,0,2.1,0.7,2.1,2.2c0,1.5-1.1,2.3-2.3,2.3C81.9,86.3,80.6,85.3,80.6,82.9z"
            />
            <path
              style={{ fill: "#D3375A" }}
              className="st14"
              d="M86.7,85.3c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S86.7,85.9,86.7,85.3z"
            />
            <path
              style={{ fill: "#D3375A" }}
              className="st14"
              d="M89.7,85.3c1.8-1.7,3-2.9,3-3.9c0-0.7-0.4-1-1-1c-0.5,0-0.9,0.3-1.2,0.7l-0.9-0.9c0.7-0.7,1.3-1.1,2.3-1.1
		c1.4,0,2.3,0.9,2.3,2.2c0,1.2-1.1,2.4-2.2,3.6c0.4,0,0.8-0.1,1.2-0.1h1.4v1.4h-4.9V85.3z"
            />
            <path
              style={{ fill: "#D3375A" }}
              className="st14"
              d="M108,56.1c0-2.6,1.4-3.8,2.8-3.8c0.9,0,1.6,0.4,2,0.8l-0.9,1c-0.2-0.3-0.7-0.5-1.1-0.5
		c-0.8,0-1.5,0.6-1.5,2.5c0,1.7,0.5,2.2,1.1,2.2c0.5,0,0.9-0.3,0.9-1.1c0-0.7-0.4-1-0.9-1c-0.4,0-0.8,0.2-1.1,0.8l-0.1-1.1
		c0.4-0.5,1-0.8,1.5-0.8c1.2,0,2.1,0.7,2.1,2.2c0,1.5-1.1,2.3-2.3,2.3C109.3,59.6,108,58.6,108,56.1z"
            />
            <path
              style={{ fill: "#D3375A" }}
              className="st14"
              d="M114.1,58.6c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S114.1,59.1,114.1,58.6z"
            />
            <path
              style={{ fill: "#D3375A" }}
              className="st14"
              d="M116.9,58.6l0.7-1c0.4,0.4,0.9,0.7,1.5,0.7c0.7,0,1.1-0.3,1.1-0.8c0-0.6-0.4-1-1.9-1v-1.1
		c1.3,0,1.6-0.4,1.6-0.9c0-0.5-0.3-0.8-0.9-0.8c-0.5,0-0.9,0.2-1.3,0.6l-0.8-1c0.6-0.6,1.3-0.9,2.2-0.9c1.5,0,2.4,0.7,2.4,1.9
		c0,0.7-0.4,1.2-1.2,1.6v0c0.8,0.2,1.4,0.8,1.4,1.7c0,1.3-1.2,2-2.6,2C118.2,59.6,117.4,59.2,116.9,58.6z"
            />
            <path
              style={{ fill: "#D3375A" }}
              className="st14"
              d="M139.8,35.2c0-2.6,1.4-3.8,2.8-3.8c0.9,0,1.6,0.4,2,0.8l-0.9,1c-0.2-0.3-0.7-0.5-1.1-0.5
		c-0.8,0-1.5,0.6-1.5,2.5c0,1.7,0.5,2.2,1.1,2.2c0.5,0,0.9-0.3,0.9-1.1c0-0.7-0.4-1-0.9-1c-0.4,0-0.8,0.2-1.1,0.8l-0.1-1.1
		c0.4-0.5,1-0.8,1.5-0.8c1.2,0,2.1,0.7,2.1,2.2c0,1.5-1.1,2.3-2.3,2.3C141.1,38.7,139.8,37.7,139.8,35.2z"
            />
            <path
              style={{ fill: "#D3375A" }}
              className="st14"
              d="M145.8,37.7c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S145.8,38.2,145.8,37.7z"
            />
            <path
              style={{ fill: "#D3375A" }}
              className="st14"
              d="M151.7,34.5c0-0.4,0-1.1,0.1-1.6h0c-0.2,0.4-0.4,0.8-0.6,1.2l-0.9,1.5h3.8v1.2h-5.3v-1.1l2.6-4.2h2v7h-1.5
		V34.5z"
            />
            <path
              style={{ fill: "#D3375A" }}
              className="st14"
              d="M174.8,20.1c0-2.6,1.4-3.8,2.8-3.8c0.9,0,1.6,0.4,2,0.8l-0.9,1c-0.2-0.3-0.7-0.5-1.1-0.5
		c-0.8,0-1.5,0.6-1.5,2.5c0,1.7,0.5,2.2,1.1,2.2c0.5,0,0.9-0.3,0.9-1.1c0-0.7-0.4-1-0.9-1c-0.4,0-0.8,0.2-1.1,0.8l-0.1-1.1
		c0.4-0.5,1-0.8,1.5-0.8c1.2,0,2.1,0.7,2.1,2.2c0,1.5-1.1,2.3-2.3,2.3C176.1,23.6,174.8,22.6,174.8,20.1z"
            />
            <path
              style={{ fill: "#D3375A" }}
              className="st14"
              d="M180.8,22.6c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S180.8,23.2,180.8,22.6z"
            />
            <path
              style={{ fill: "#D3375A" }}
              className="st14"
              d="M183.7,22.6l0.7-1c0.4,0.4,0.9,0.7,1.5,0.7c0.7,0,1.2-0.4,1.2-1.1c0-0.7-0.5-1.1-1.1-1.1
		c-0.4,0-0.6,0.1-1,0.4l-0.7-0.5l0.2-3.5h4v1.4h-2.6l-0.1,1.3c0.3-0.1,0.5-0.2,0.8-0.2c1.2,0,2.2,0.7,2.2,2.2c0,1.6-1.2,2.4-2.6,2.4
		C185,23.6,184.3,23.2,183.7,22.6z"
            />
            <path
              style={{ fill: "#D3375A" }}
              className="st14"
              d="M212.4,13c0-2.6,1.4-3.8,2.8-3.8c0.9,0,1.6,0.4,2,0.8l-0.9,1c-0.2-0.3-0.7-0.5-1.1-0.5
		c-0.8,0-1.5,0.6-1.5,2.5c0,1.7,0.5,2.2,1.1,2.2c0.5,0,0.9-0.3,0.9-1.1c0-0.7-0.4-1-0.9-1c-0.4,0-0.8,0.2-1.1,0.8l-0.1-1.1
		c0.4-0.5,1-0.8,1.5-0.8c1.2,0,2.1,0.7,2.1,2.2c0,1.5-1.1,2.3-2.3,2.3C213.7,16.5,212.4,15.5,212.4,13z"
            />
            <path
              style={{ fill: "#D3375A" }}
              className="st14"
              d="M218.4,15.5c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S218.4,16,218.4,15.5z"
            />
            <path
              style={{ fill: "#D3375A" }}
              className="st14"
              d="M221.5,13c0-2.6,1.4-3.8,2.8-3.8c0.9,0,1.6,0.4,2,0.8l-0.9,1c-0.2-0.3-0.7-0.5-1.1-0.5
		c-0.8,0-1.5,0.6-1.5,2.5c0,1.7,0.5,2.2,1.1,2.2c0.5,0,0.9-0.3,0.9-1.1c0-0.7-0.4-1-0.9-1c-0.4,0-0.8,0.2-1.1,0.8l-0.1-1.1
		c0.4-0.5,1-0.8,1.5-0.8c1.2,0,2.1,0.7,2.1,2.2c0,1.5-1.1,2.3-2.3,2.3C222.8,16.5,221.5,15.5,221.5,13z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M250.4,14.8h1.5v-4h-1.3v-1c0.7-0.1,1.2-0.3,1.7-0.6h1.2v5.7h1.3v1.3h-4.5V14.8z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M256.1,15.2c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S256.1,15.8,256.1,15.2z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M259.5,14.8h1.5v-4h-1.3v-1c0.7-0.1,1.2-0.3,1.7-0.6h1.2v5.7h1.3v1.3h-4.5V14.8z"
            />
            <path
              style={{ fill: "#623785" }}
              className="st12"
              d="M37.4,228.3l0.7-1c0.4,0.4,0.9,0.7,1.5,0.7c0.7,0,1.2-0.4,1.2-1.1c0-0.7-0.5-1.1-1.1-1.1
		c-0.4,0-0.6,0.1-1,0.4l-0.7-0.5l0.2-3.5h4v1.4h-2.6l-0.1,1.3c0.3-0.1,0.5-0.2,0.8-0.2c1.2,0,2.2,0.7,2.2,2.2c0,1.6-1.2,2.4-2.6,2.4
		C38.8,229.3,38,228.8,37.4,228.3z"
            />
            <path
              style={{ fill: "#623785" }}
              className="st12"
              d="M43.7,228.3c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S43.7,228.8,43.7,228.3z"
            />
            <path
              style={{ fill: "#623785" }}
              className="st12"
              d="M46.7,228.2c1.8-1.7,3-2.9,3-3.9c0-0.7-0.4-1-1-1c-0.5,0-0.9,0.3-1.2,0.7l-0.9-0.9c0.7-0.7,1.3-1.1,2.3-1.1
		c1.4,0,2.3,0.9,2.3,2.2c0,1.2-1.1,2.4-2.2,3.6c0.4,0,0.8-0.1,1.2-0.1h1.4v1.4h-4.9V228.2z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M407.9,78.7c-6.3,0-11.4-5.1-11.4-11.4S401.7,56,407.9,56s11.4,5.1,11.4,11.4S414.2,78.7,407.9,78.7z
		 M407.9,56.5c-6,0-10.9,4.9-10.9,10.9s4.9,10.9,10.9,10.9s10.9-4.9,10.9-10.9S413.9,56.5,407.9,56.5z"
            />
            <path
              style={{ fill: "#EF7E2B" }}
              className="st9"
              d="M405.6,69.6h1.7v-4.4h-1.4v-1.1c0.8-0.2,1.4-0.4,1.9-0.7h1.3v6.2h1.4V71h-4.9V69.6z"
            />
            <path
              style={{ fill: "#299947" }}
              className="st10"
              d="M407.9,356.8c-6.3,0-11.4-5.1-11.4-11.4s5.1-11.4,11.4-11.4s11.4,5.1,11.4,11.4S414.2,356.8,407.9,356.8z
		 M407.9,334.5c-6,0-10.9,4.9-10.9,10.9s4.9,10.9,10.9,10.9s10.9-4.9,10.9-10.9S413.9,334.5,407.9,334.5z"
            />
            <path
              style={{ fill: "#299947" }}
              className="st10"
              d="M405.2,348.1c1.9-1.8,3.3-3.1,3.3-4.2c0-0.7-0.4-1.1-1.1-1.1c-0.5,0-1,0.4-1.4,0.8l-1-1
		c0.7-0.8,1.5-1.2,2.5-1.2c1.5,0,2.5,1,2.5,2.4c0,1.3-1.2,2.6-2.4,3.9c0.4,0,0.9-0.1,1.3-0.1h1.5v1.5h-5.4V348.1z"
            />
            <path
              style={{ fill: "#3F85C6" }}
              className="st13"
              d="M217.1,436.4c-6.3,0-11.4-5.1-11.4-11.4s5.1-11.4,11.4-11.4s11.4,5.1,11.4,11.4S223.3,436.4,217.1,436.4z
		 M217.1,414.2c-6,0-10.9,4.9-10.9,10.9s4.9,10.9,10.9,10.9c6,0,10.9-4.9,10.9-10.9S223.1,414.2,217.1,414.2z"
            />
            <path
              style={{ fill: "#3F85C6" }}
              className="st13"
              d="M214.1,427.8l0.8-1.1c0.5,0.4,1,0.8,1.7,0.8c0.7,0,1.2-0.3,1.2-0.9c0-0.7-0.4-1.1-2-1.1v-1.2
		c1.4,0,1.8-0.4,1.8-1c0-0.5-0.3-0.8-0.9-0.8c-0.5,0-1,0.2-1.4,0.7l-0.9-1.1c0.7-0.6,1.5-1,2.4-1c1.6,0,2.6,0.8,2.6,2.1
		c0,0.8-0.5,1.3-1.3,1.7v0c0.9,0.3,1.5,0.9,1.5,1.9c0,1.4-1.3,2.2-2.8,2.2C215.5,428.9,214.7,428.5,214.1,427.8z"
            />
            <path
              style={{ fill: "#1DA2A3" }}
              className="st11"
              d="M68.3,356.8c-6.3,0-11.4-5.1-11.4-11.4S62.1,334,68.3,334s11.4,5.1,11.4,11.4S74.6,356.8,68.3,356.8z
		 M68.3,334.5c-6,0-10.9,4.9-10.9,10.9s4.9,10.9,10.9,10.9s10.9-4.9,10.9-10.9S74.3,334.5,68.3,334.5z"
            />
            <pattern id="SVGID_1_" patternTransform="matrix(1 0 0 1 -20.9717 -3.0044)"></pattern>
            <path
              style={{ fill: "#1DA2A3" }}
              className="st15"
              d="M68.7,344.7c0-0.5,0-1.2,0.1-1.7h0c-0.2,0.4-0.4,0.9-0.6,1.3l-1,1.7h4.1v1.3h-5.8v-1.2l2.8-4.6h2.2v7.6h-1.6
		V344.7z"
            />
            <path
              style={{ fill: "#623785" }}
              className="st12"
              d="M18.6,217.7c-6.3,0-11.4-5.1-11.4-11.4s5.1-11.4,11.4-11.4s11.4,5.1,11.4,11.4S24.8,217.7,18.6,217.7z
		 M18.6,195.4c-6,0-10.9,4.9-10.9,10.9s4.9,10.9,10.9,10.9c6,0,10.9-4.9,10.9-10.9S24.6,195.4,18.6,195.4z"
            />
            <path
              style={{ fill: "#623785" }}
              className="st12"
              d="M15.6,209.1l0.8-1.1c0.5,0.4,1,0.8,1.6,0.8c0.8,0,1.3-0.4,1.3-1.2c0-0.8-0.5-1.2-1.2-1.2
		c-0.4,0-0.7,0.1-1.1,0.4l-0.8-0.5l0.2-3.8h4.3v1.5H18l-0.1,1.4c0.3-0.1,0.5-0.2,0.8-0.2c1.3,0,2.4,0.7,2.4,2.4
		c0,1.7-1.3,2.7-2.8,2.7C17.1,210.2,16.2,209.7,15.6,209.1z"
            />
            <path
              style={{ fill: "#D3375A" }}
              className="st14"
              d="M116.4,35.3c-6.3,0-11.4-5.1-11.4-11.4s5.1-11.4,11.4-11.4s11.4,5.1,11.4,11.4S122.6,35.3,116.4,35.3z
		 M116.4,13c-6,0-10.9,4.9-10.9,10.9c0,6,4.9,10.9,10.9,10.9s10.9-4.9,10.9-10.9C127.2,17.9,122.4,13,116.4,13z"
            />
            <path
              style={{ fill: "#D3375A" }}
              className="st14"
              d="M113.6,24c0-2.8,1.5-4.1,3.1-4.1c1,0,1.7,0.4,2.2,0.9l-0.9,1.1c-0.3-0.3-0.7-0.5-1.2-0.5
		c-0.9,0-1.6,0.7-1.6,2.7c0,1.9,0.6,2.5,1.2,2.5c0.5,0,1-0.4,1-1.2c0-0.8-0.4-1.1-1-1.1c-0.4,0-0.8,0.2-1.2,0.8l-0.1-1.2
		c0.4-0.6,1.1-0.9,1.6-0.9c1.3,0,2.3,0.7,2.3,2.4c0,1.6-1.2,2.6-2.5,2.6C115,27.7,113.6,26.6,113.6,24z"
            />
          </g>
        </svg>
      </div>
      <div className="pie-chart-data">
        <ul style={{ listStyle: "none", fontSize: "18px" }}>
          {sections &&
            sections.length > 0 &&
            sections.map((section, index) => (
              <li
                key={index}
                style={{ color: getLegendColor(index), marginBottom: "20px", fontWeight: "bold" }}
              >
                <i
                  style={{
                    borderRadius: "50%",
                    width: "25px",
                    height: "25px",
                    padding: "2px",
                    fontSize: "0.7em !important",
                    background: "#fff",
                    border: "2px solid " + getLegendColor(index),
                    color: getLegendColor(index),
                    textAlign: "center",
                    display: "inline-block",
                    marginRight: "10px",
                  }}
                >
                  {index + 1}
                </i>
                {commonStore.getUserSurveySectionGraphText(section)}
              </li>
            ))}
        </ul>
      </div>
    </>
  );
}
